(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(self, () => {
return /******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./src/assets/images sync recursive ^\\.\\/.*\\.svg$":
/*!***********************************************!*\
  !*** ./src/assets/images/ sync ^\.\/.*\.svg$ ***!
  \***********************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var map = {
	"./Call_Icon.svg": "./src/assets/images/Call_Icon.svg",
	"./Cat_ate_the_fish.svg": "./src/assets/images/Cat_ate_the_fish.svg",
	"./Chat_Icon.svg": "./src/assets/images/Chat_Icon.svg",
	"./Cisco_Webex_Logo.svg": "./src/assets/images/Cisco_Webex_Logo.svg",
	"./Dog_digging_hole.svg": "./src/assets/images/Dog_digging_hole.svg",
	"./Email_Icon.svg": "./src/assets/images/Email_Icon.svg",
	"./Empty_notifications.svg": "./src/assets/images/Empty_notifications.svg",
	"./Facebook_Icon.svg": "./src/assets/images/Facebook_Icon.svg",
	"./Lighthouse.svg": "./src/assets/images/Lighthouse.svg",
	"./Lighthouse_anding.svg": "./src/assets/images/Lighthouse_anding.svg",
	"./Outgoing_Call_Icon.svg": "./src/assets/images/Outgoing_Call_Icon.svg",
	"./Rocket_flying.svg": "./src/assets/images/Rocket_flying.svg",
	"./Rocket_landed.svg": "./src/assets/images/Rocket_landed.svg",
	"./Rocket_taking_off.svg": "./src/assets/images/Rocket_taking_off.svg",
	"./Saving_completed.svg": "./src/assets/images/Saving_completed.svg",
	"./Sending_completed.svg": "./src/assets/images/Sending_completed.svg",
	"./Setup_completed.svg": "./src/assets/images/Setup_completed.svg",
	"./Sleeping_cat.svg": "./src/assets/images/Sleeping_cat.svg",
	"./Sms_Icon.svg": "./src/assets/images/Sms_Icon.svg",
	"./Torn-out_page_from_a_book.svg": "./src/assets/images/Torn-out_page_from_a_book.svg",
	"./cloud_failure_red.svg": "./src/assets/images/cloud_failure_red.svg",
	"./flashlight_dark.svg": "./src/assets/images/flashlight_dark.svg",
	"./flashlight_light.svg": "./src/assets/images/flashlight_light.svg",
	"./four_managers.svg": "./src/assets/images/four_managers.svg",
	"./no_search_results.svg": "./src/assets/images/no_search_results.svg",
	"./teams-icon-color.svg": "./src/assets/images/teams-icon-color.svg",
	"./ufo_kidnapped_a_dog.svg": "./src/assets/images/ufo_kidnapped_a_dog.svg",
	"./webex_cc_logo.svg": "./src/assets/images/webex_cc_logo.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images sync recursive ^\\.\\/.*\\.svg$";

/***/ }),

/***/ "./src/assets/images/Call_Icon.svg":
/*!*****************************************!*\
  !*** ./src/assets/images/Call_Icon.svg ***!
  \*****************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__.p + "uuip-images-mfe-wc/Call_Icon.1a72c2e0.svg";

/***/ }),

/***/ "./src/assets/images/Cat_ate_the_fish.svg":
/*!************************************************!*\
  !*** ./src/assets/images/Cat_ate_the_fish.svg ***!
  \************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__.p + "uuip-images-mfe-wc/Cat_ate_the_fish.7a011d51.svg";

/***/ }),

/***/ "./src/assets/images/Chat_Icon.svg":
/*!*****************************************!*\
  !*** ./src/assets/images/Chat_Icon.svg ***!
  \*****************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__.p + "uuip-images-mfe-wc/Chat_Icon.9bdab516.svg";

/***/ }),

/***/ "./src/assets/images/Cisco_Webex_Logo.svg":
/*!************************************************!*\
  !*** ./src/assets/images/Cisco_Webex_Logo.svg ***!
  \************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__.p + "uuip-images-mfe-wc/Cisco_Webex_Logo.4be28180.svg";

/***/ }),

/***/ "./src/assets/images/Dog_digging_hole.svg":
/*!************************************************!*\
  !*** ./src/assets/images/Dog_digging_hole.svg ***!
  \************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__.p + "uuip-images-mfe-wc/Dog_digging_hole.91d2e4ea.svg";

/***/ }),

/***/ "./src/assets/images/Email_Icon.svg":
/*!******************************************!*\
  !*** ./src/assets/images/Email_Icon.svg ***!
  \******************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__.p + "uuip-images-mfe-wc/Email_Icon.076ae7be.svg";

/***/ }),

/***/ "./src/assets/images/Empty_notifications.svg":
/*!***************************************************!*\
  !*** ./src/assets/images/Empty_notifications.svg ***!
  \***************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__.p + "uuip-images-mfe-wc/Empty_notifications.06c8b4a8.svg";

/***/ }),

/***/ "./src/assets/images/Facebook_Icon.svg":
/*!*********************************************!*\
  !*** ./src/assets/images/Facebook_Icon.svg ***!
  \*********************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__.p + "uuip-images-mfe-wc/Facebook_Icon.06f69b84.svg";

/***/ }),

/***/ "./src/assets/images/Lighthouse.svg":
/*!******************************************!*\
  !*** ./src/assets/images/Lighthouse.svg ***!
  \******************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__.p + "uuip-images-mfe-wc/Lighthouse.b206ed0d.svg";

/***/ }),

/***/ "./src/assets/images/Lighthouse_anding.svg":
/*!*************************************************!*\
  !*** ./src/assets/images/Lighthouse_anding.svg ***!
  \*************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__.p + "uuip-images-mfe-wc/Lighthouse_anding.5275a678.svg";

/***/ }),

/***/ "./src/assets/images/Outgoing_Call_Icon.svg":
/*!**************************************************!*\
  !*** ./src/assets/images/Outgoing_Call_Icon.svg ***!
  \**************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__.p + "uuip-images-mfe-wc/Outgoing_Call_Icon.be2198c7.svg";

/***/ }),

/***/ "./src/assets/images/Rocket_flying.svg":
/*!*********************************************!*\
  !*** ./src/assets/images/Rocket_flying.svg ***!
  \*********************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__.p + "uuip-images-mfe-wc/Rocket_flying.c3102925.svg";

/***/ }),

/***/ "./src/assets/images/Rocket_landed.svg":
/*!*********************************************!*\
  !*** ./src/assets/images/Rocket_landed.svg ***!
  \*********************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__.p + "uuip-images-mfe-wc/Rocket_landed.05ad2a7a.svg";

/***/ }),

/***/ "./src/assets/images/Rocket_taking_off.svg":
/*!*************************************************!*\
  !*** ./src/assets/images/Rocket_taking_off.svg ***!
  \*************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__.p + "uuip-images-mfe-wc/Rocket_taking_off.2e4f027f.svg";

/***/ }),

/***/ "./src/assets/images/Saving_completed.svg":
/*!************************************************!*\
  !*** ./src/assets/images/Saving_completed.svg ***!
  \************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__.p + "uuip-images-mfe-wc/Saving_completed.89997d09.svg";

/***/ }),

/***/ "./src/assets/images/Sending_completed.svg":
/*!*************************************************!*\
  !*** ./src/assets/images/Sending_completed.svg ***!
  \*************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__.p + "uuip-images-mfe-wc/Sending_completed.721a1d85.svg";

/***/ }),

/***/ "./src/assets/images/Setup_completed.svg":
/*!***********************************************!*\
  !*** ./src/assets/images/Setup_completed.svg ***!
  \***********************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__.p + "uuip-images-mfe-wc/Setup_completed.3b5b4942.svg";

/***/ }),

/***/ "./src/assets/images/Sleeping_cat.svg":
/*!********************************************!*\
  !*** ./src/assets/images/Sleeping_cat.svg ***!
  \********************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__.p + "uuip-images-mfe-wc/Sleeping_cat.5efd6168.svg";

/***/ }),

/***/ "./src/assets/images/Sms_Icon.svg":
/*!****************************************!*\
  !*** ./src/assets/images/Sms_Icon.svg ***!
  \****************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__.p + "uuip-images-mfe-wc/Sms_Icon.bd7d6e88.svg";

/***/ }),

/***/ "./src/assets/images/Torn-out_page_from_a_book.svg":
/*!*********************************************************!*\
  !*** ./src/assets/images/Torn-out_page_from_a_book.svg ***!
  \*********************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__.p + "uuip-images-mfe-wc/Torn-out_page_from_a_book.318be3e1.svg";

/***/ }),

/***/ "./src/assets/images/cloud_failure_red.svg":
/*!*************************************************!*\
  !*** ./src/assets/images/cloud_failure_red.svg ***!
  \*************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__.p + "uuip-images-mfe-wc/cloud_failure_red.14730736.svg";

/***/ }),

/***/ "./src/assets/images/flashlight_dark.svg":
/*!***********************************************!*\
  !*** ./src/assets/images/flashlight_dark.svg ***!
  \***********************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__.p + "uuip-images-mfe-wc/flashlight_dark.a3d03038.svg";

/***/ }),

/***/ "./src/assets/images/flashlight_light.svg":
/*!************************************************!*\
  !*** ./src/assets/images/flashlight_light.svg ***!
  \************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__.p + "uuip-images-mfe-wc/flashlight_light.bda55fbf.svg";

/***/ }),

/***/ "./src/assets/images/four_managers.svg":
/*!*********************************************!*\
  !*** ./src/assets/images/four_managers.svg ***!
  \*********************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__.p + "uuip-images-mfe-wc/four_managers.2a53b131.svg";

/***/ }),

/***/ "./src/assets/images/no_search_results.svg":
/*!*************************************************!*\
  !*** ./src/assets/images/no_search_results.svg ***!
  \*************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__.p + "uuip-images-mfe-wc/no_search_results.0c319d2b.svg";

/***/ }),

/***/ "./src/assets/images/teams-icon-color.svg":
/*!************************************************!*\
  !*** ./src/assets/images/teams-icon-color.svg ***!
  \************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__.p + "uuip-images-mfe-wc/teams-icon-color.5a6d40fd.svg";

/***/ }),

/***/ "./src/assets/images/ufo_kidnapped_a_dog.svg":
/*!***************************************************!*\
  !*** ./src/assets/images/ufo_kidnapped_a_dog.svg ***!
  \***************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__.p + "uuip-images-mfe-wc/ufo_kidnapped_a_dog.1c9723e8.svg";

/***/ }),

/***/ "./src/assets/images/webex_cc_logo.svg":
/*!*********************************************!*\
  !*** ./src/assets/images/webex_cc_logo.svg ***!
  \*********************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__.p + "uuip-images-mfe-wc/webex_cc_logo.38e8421d.svg";

/***/ }),

/***/ "./src/components/AdvancedSearch/components/AdvancedSearch.scss":
/*!**********************************************************************!*\
  !*** ./src/components/AdvancedSearch/components/AdvancedSearch.scss ***!
  \**********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  /* Font family */
  --font-family: var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial, sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "CiscoSansTT Light", "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
}

.search-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: var(--placeholder-container-height, 100%);
  justify-content: center;
}

.search-error-msg {
  display: flex;
  flex-direction: row;
  column-gap: 8px;
  align-items: center;
  font-size: var(--font-size-medium);
}

.empty-state-placeholder {
  display: flex;
  flex-direction: column;
  text-align: center;
  height: var(--placeholder-container-height, 100%);
  justify-content: center;
}
.empty-state-placeholder .empty-title {
  font-size: var(--font-size-medium);
  margin: 0;
  color: var(--list-text-color, --color-gray-100);
  align-items: center;
}
.empty-state-placeholder .empty-state-wrapper::part(container) {
  background-color: transparent;
}
.empty-state-placeholder .empty-state-wrapper::part(img) {
  display: block;
  margin: auto;
  width: auto;
}

.load-error {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: var(--placeholder-container-height, 100%);
}
.load-error .load-error-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.load-error .load-error-title {
  font-size: var(--font-size-medium);
  margin: 0 calc(var(--space-token-even) * 8);
  font-weight: var(--brand-font-weight-regular);
  text-align: center;
  padding: 0;
  color: var(--list-text-color, --color-gray-100);
}
.load-error .load-error-wrapper {
  height: auto;
}
.load-error .load-error-wrapper::part(container) {
  background-color: transparent;
}
.load-error .load-error-wrapper::part(img) {
  display: block;
  margin: auto;
  width: 120px;
}
.load-error md-button {
  margin: calc(var(--space-token-even) * 8) auto auto auto;
}
.load-error md-button span[slot=text] {
  font-weight: var(--brand-font-weight-medium);
}

md-input::part(md-input-container) {
  margin-bottom: calc(var(--space-token-even) * 2);
}

.loading-spinner {
  display: flex;
  align-items: center;
  justify-content: center;
  height: var(--placeholder-container-height, 100%);
}
/*# sourceURL=/home/jenkins/agent/workspace/cicd-jobs/wxcc-common-CI-Builder/packages/@uuip/unified-ui-platform-common-components/src/assets/styles/variables.scss */
/*# sourceURL=AdvancedSearch.scss */
/*# sourceURL=/home/jenkins/agent/workspace/cicd-jobs/wxcc-common-CI-Builder/packages/@uuip/unified-ui-platform-common-components/src/components/AdvancedSearch/components/AdvancedSearch.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/AdvancedSearch/components/AdvancedSearch.ts":
/*!********************************************************************!*\
  !*** ./src/components/AdvancedSearch/components/AdvancedSearch.ts ***!
  \********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   AdvancedSearch: () => (/* binding */ AdvancedSearch)
/* harmony export */ });
/* harmony import */ var _mixins_i18n__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18n */ "./src/mixins/i18n.ts");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lit-html/directives/if-defined */ "lit-html/directives/if-defined");
/* harmony import */ var lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _components_EmptyState_EmptyState__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../components/EmptyState/EmptyState */ "./src/components/EmptyState/EmptyState.ts");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @/utils/helpers */ "./src/utils/helpers.ts");
/* harmony import */ var _components_AdvancedSearch_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../components/AdvancedSearch.scss */ "./src/components/AdvancedSearch/components/AdvancedSearch.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable sonarjs/no-nested-template-literals */










var AdvancedSearch;
(function (AdvancedSearch) {
    /**
     * @element uuip-wc-advanced-search
     */
    let Element = class Element extends (0,_mixins_i18n__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_2__.LitElement) {
        constructor() {
            super(...arguments);
            this.localization = {};
            this.searchAriaLabel = "";
            this.isSearchLoading = false;
            this.clearBtnAriaLabel = "";
            this.searchable = true;
            this.searchErrorText = "";
            this.searchTitle = "";
            this.isInputDisabled = false;
            this.listAriaLabel = "";
            this.isNonSelectable = false;
            this.listPlaceholderText = "";
            this.listPlaceholderIllustration = "";
            this.listErrorText = "";
            this.listRetryText = "";
            this.selectedItemId = "";
            this.listContainerHeight = "292px";
            this.autoFocus = false;
            this.loadOnFirstRender = false;
            this.advancedSearchStyle = {};
            this.searchQuery = "";
            this.isSearchQueryTooShort = false;
            this.isSearchInProgress = false;
            this.SEARCH_THRESHOLD = 3;
            this.searchErrorIconSize = "16";
            this.spinnerSize = "18";
            this.items = [];
            this.totalRecords = 0;
            this.currentPage = 0;
            this.focusReset = false;
            this.isPageLoading = false;
            this.isPageFetchError = false;
            this.isSearchPageLoading = false;
            this.retryButtonSize = "28";
            this.t = {
                search: "Search",
                clear: "Clear",
                listAriaLabel: "List of Results",
                listPlaceholderText: "No results found",
                searchErrorText: "Enter a minimum of three characters to search.",
                listErrorText: "Failed to load data",
                listRetryText: "Try again"
            };
            this.setItemsForList = (newItems, totalRecords, isNewPage, isNewSearch = false) => {
                if (isNewSearch) {
                    this.items = [];
                    this.totalRecords = 0;
                    this.currentPage = 0;
                }
                this.totalRecords = totalRecords;
                this.items = isNewPage ? [...this.items, ...newItems] : newItems;
            };
            this.resetDisplayProperties = () => {
                this.items = [];
                this.currentPage = 0;
                this.totalRecords = 0;
                this.isPageFetchError = false;
                this.isSearchInProgress = false;
            };
            this.reloadListData = () => __awaiter(this, void 0, void 0, function* () {
                this.loadNextPage();
                this.handleInputFocus();
            });
            this.setLoadingStates = (isPageLoading, isNewSearch = false) => {
                this.isPageLoading = isPageLoading;
                isNewSearch && (this.isSearchPageLoading = isPageLoading);
            };
            this.loadNextPage = (isNewSearch = false) => __awaiter(this, void 0, void 0, function* () {
                try {
                    this.setLoadingStates(true, isNewSearch);
                    if (isNewSearch) {
                        this.isSearchInProgress = true;
                    }
                    const { listItems, totalRecords } = yield this.fetchItems(this.currentPage, this.searchQuery);
                    if (this.isSearchInProgress || !this.isSearchQueryTooShort) {
                        const isNewPage = this.searchQuery.length > 0 ? true : false;
                        this.setItemsForList(listItems, totalRecords, isNewPage, isNewSearch);
                    }
                    this.isPageFetchError = false;
                    _sdk__WEBPACK_IMPORTED_MODULE_6__.logger.info("event=loadNextPage | Items fetched successfully for page: ", this.currentPage);
                }
                catch (error) {
                    this.isPageFetchError = true;
                    _sdk__WEBPACK_IMPORTED_MODULE_6__.logger.error("event=loadNextPage | Error on fetching items for callback", error);
                }
                finally {
                    if (isNewSearch && this.items.length > 0) {
                        this.isSearchInProgress = false;
                    }
                    this.setLoadingStates(false, isNewSearch);
                }
            });
            this.handleLoadMoreItems = () => {
                if (this.isPageLoading || this.items.length === 0) {
                    return;
                }
                this.currentPage += 1;
                this.loadNextPage();
            };
            this.renderContent = () => {
                if (this.items.length === 0) {
                    if (this.isPageLoading && (this.isSearchInProgress || !this.isSearchQueryTooShort)) {
                        return (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_7__.renderLoadingSpinner)(this.spinnerSize);
                    }
                    if (this.isPageFetchError) {
                        return (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_7__.renderListError)(this.listErrorText || this.t.listErrorText, this.listRetryText || this.t.listRetryText, this.reloadListData, this.retryButtonSize);
                    }
                    if (!this.isPageLoading && !this.isSearchQueryTooShort && this.totalRecords === 0) {
                        return (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_7__.renderPlaceholder)(this.listPlaceholderIllustration, this.listPlaceholderText || this.t.listPlaceholderText);
                    }
                }
                if (this.isSearchQueryTooShort) {
                    return (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_7__.renderSearchErrorMessage)(this.searchErrorText || this.t.searchErrorText, this.searchErrorIconSize);
                }
                if (this.isSearchInProgress) {
                    return (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_7__.renderPlaceholder)(this.listPlaceholderIllustration, this.listPlaceholderText || this.t.listPlaceholderText);
                }
                return this.renderAdvanceList();
            };
        }
        static get styles() {
            return [_components_AdvancedSearch_scss__WEBPACK_IMPORTED_MODULE_8__["default"]];
        }
        firstUpdated() {
            if (this.loadOnFirstRender) {
                this.loadNextPage();
            }
        }
        handleListItemChange(event) {
            if (!event.detail.selected[0]) {
                return;
            }
            this.selectedItemId = event.detail.selected[0];
            this.dispatchEvent(new CustomEvent("list-item-selected", {
                detail: { selected: this.selectedItemId },
                bubbles: true,
                composed: true
            }));
        }
        handleInputFocus() {
            this.focusReset = true;
            setTimeout(() => {
                this.focusReset = false;
            }, 0);
        }
        handleSearch(event) {
            this.searchQuery = event.detail.value;
            if (this.searchQuery.length > 0) {
                if (this.searchQuery.length < this.SEARCH_THRESHOLD) {
                    this.handleSearchQuery(true);
                }
                else if (this.searchQuery.length >= this.SEARCH_THRESHOLD) {
                    this.handleSearchQuery(false);
                    this.loadNextPage(true);
                }
            }
            else {
                this.handleSearchQuery(false);
                this.loadNextPage();
            }
            this.isPageFetchError = false;
        }
        handleSearchQuery(isSearchQueryTooShort) {
            this.resetDisplayProperties();
            this.isSearchQueryTooShort = isSearchQueryTooShort;
        }
        renderAdvanceList() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
        <md-advance-list
          .items=${this.items}
          .value=${[this.selectedItemId]}
          .isLoading=${this.isPageLoading}
          .isError=${this.isPageFetchError}
          .isNonSelectable=${this.isNonSelectable}
          .focusReset=${this.focusReset || this.isPageLoading}
          containerHeight=${this.listContainerHeight}
          ariaLabelList=${this.listAriaLabel || this.t.listAriaLabel}
          totalRecords=${this.totalRecords}
          @list-item-change=${this.handleListItemChange}
          @load-more=${this.handleLoadMoreItems}
        >
        </md-advance-list>
      `;
        }
        render() {
            const res = this.renderContent();
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) ` <style>
          :host {
            --placeholder-container-height: ${this.advancedSearchStyle.placeholderContainerHeight};
        </style>
        <md-input
          placeholder=${this.searchAriaLabel || this.t.search}
          ariaLabel=${this.searchAriaLabel || this.t.search}
          searchable
          .isLoading=${this.isSearchLoading}
          shape=${(0,lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_4__.ifDefined)(!_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__.themeManager.isMomentumV2Enabled ? "pill" : undefined)}
          ?newMomentum=${_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__.themeManager.isMomentumV2Enabled}
          clear
          clearAriaLabel=${this.clearBtnAriaLabel || this.t.clear}
          value=${this.searchQuery}
          autofocus=${this.autoFocus}
          label=${this.searchTitle || ""}
          @input-change=${this.handleSearch}
          @input-focus=${this.handleInputFocus}
          .disabled=${this.isInputDisabled}
        ></md-input>
        ${res !== lit_html__WEBPACK_IMPORTED_MODULE_3__.nothing ? (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `<div class="status-div">${this.renderContent()}</div>` : ""}`;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Object })
    ], Element.prototype, "localization", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: String })
    ], Element.prototype, "searchAriaLabel", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Boolean })
    ], Element.prototype, "isSearchLoading", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: String })
    ], Element.prototype, "clearBtnAriaLabel", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Boolean })
    ], Element.prototype, "searchable", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: String })
    ], Element.prototype, "searchErrorText", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: String })
    ], Element.prototype, "searchTitle", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Boolean })
    ], Element.prototype, "isInputDisabled", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: String })
    ], Element.prototype, "listAriaLabel", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Boolean })
    ], Element.prototype, "isNonSelectable", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: String })
    ], Element.prototype, "listPlaceholderText", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: String })
    ], Element.prototype, "listPlaceholderIllustration", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: String })
    ], Element.prototype, "listErrorText", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: String })
    ], Element.prototype, "listRetryText", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: String })
    ], Element.prototype, "selectedItemId", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: String })
    ], Element.prototype, "listContainerHeight", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Boolean })
    ], Element.prototype, "autoFocus", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Boolean })
    ], Element.prototype, "loadOnFirstRender", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Object })
    ], Element.prototype, "advancedSearchStyle", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ attribute: false })
    ], Element.prototype, "fetchItems", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.internalProperty)()
    ], Element.prototype, "searchQuery", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.internalProperty)()
    ], Element.prototype, "isSearchQueryTooShort", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.internalProperty)()
    ], Element.prototype, "isSearchInProgress", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.internalProperty)()
    ], Element.prototype, "SEARCH_THRESHOLD", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.internalProperty)()
    ], Element.prototype, "searchErrorIconSize", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.internalProperty)()
    ], Element.prototype, "spinnerSize", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.internalProperty)()
    ], Element.prototype, "items", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.internalProperty)()
    ], Element.prototype, "totalRecords", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.internalProperty)()
    ], Element.prototype, "currentPage", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.internalProperty)()
    ], Element.prototype, "focusReset", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.internalProperty)()
    ], Element.prototype, "isPageLoading", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.internalProperty)()
    ], Element.prototype, "isPageFetchError", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.internalProperty)()
    ], Element.prototype, "isSearchPageLoading", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.internalProperty)()
    ], Element.prototype, "retryButtonSize", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.internalProperty)()
    ], Element.prototype, "t", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.customElement)("uuip-wc-advanced-search")
    ], Element);
    AdvancedSearch.Element = Element;
})(AdvancedSearch || (AdvancedSearch = {}));


/***/ }),

/***/ "./src/components/AgentList/AgentList.scss":
/*!*************************************************!*\
  !*** ./src/components/AgentList/AgentList.scss ***!
  \*************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`.agent-list-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
}

.insufficient-search-characters {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  text-align: center;
}

.insufficient-search-characters md-icon {
  vertical-align: middle;
  position: relative;
  top: -1px;
}

.agent-list-loading-empty {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  height: 100%;
  width: 100%;
}

md-advance-list::part(spinner) {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
}

md-advance-list::part(advance-list-item-wrapper) {
  padding-top: 0px;
  padding-left: 0px;
  padding-bottom: 2px;
  padding-right: 0px;
  right: 8px;
  background-color: transparent;
  width: 96%;
}

.search-input {
  padding-left: 4px;
}

.empty-state-placeholder {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  text-align: center;
}
.empty-state-placeholder .empty-state-wrapper::part(container) {
  width: 245px;
  margin: 0 auto;
  background-color: transparent;
}
.empty-state-placeholder .empty-state-wrapper::part(img) {
  width: 90px;
  height: 90px;
  object-fit: contain;
  display: block;
  margin: 12px 0px;
  padding: 0px;
}

.no-result-text {
  text-wrap: wrap;
}

.list-notice {
  margin-top: 0px;
  margin-bottom: 0px;
  padding-left: 4px;
  padding-bottom: 0px;
  color: var(--md-secondary-text-color);
}

.list-notice p {
  margin: 0px;
  padding-bottom: 0px;
}

.list-notice md-icon {
  vertical-align: middle;
  position: relative;
  top: -1px;
}
/*# sourceURL=/home/jenkins/agent/workspace/cicd-jobs/wxcc-common-CI-Builder/packages/@uuip/unified-ui-platform-common-components/src/components/AgentList/AgentList.scss */
/*# sourceURL=AgentList.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/AgentList/AgentList.ts":
/*!***********************************************!*\
  !*** ./src/components/AgentList/AgentList.ts ***!
  \***********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   AgentList: () => (/* binding */ AgentList)
/* harmony export */ });
/* harmony import */ var _mixins_i18n__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18n */ "./src/mixins/i18n.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _AgentList_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./AgentList.scss */ "./src/components/AgentList/AgentList.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var AgentList;
(function (AgentList) {
    /**
     * @element uuip-wc-agent-list
     * @fires action-button-clicked
     * @fires load-more-items
     * @fires search-input-changed
     */
    let Element = class Element extends (0,_mixins_i18n__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_1__.LitElement) {
        constructor() {
            super(...arguments);
            this.agentList = [];
            this.isLoading = false;
            this.showSearchInput = true;
            this.showListNotice = false;
            this.actionButtonsDisabled = false;
            this.localization = {};
            this.totalRecords = 0;
            this.containerHeight = "300px";
            this.minimumSearchStringLength = 3;
            this.t = {
                title: "Items",
                searchPlaceholder: "Search",
                insufficientSearchCharacters: "Enter at least 3 characters to search",
                noSearchResults: "We couldn't find anyone who matches your search",
                listAriaLabel: "List items",
                clearAriaLabel: "Clear",
                listNoticeLabel: "Agents from your team:",
                listNoticeTooltipMessage: "You can only see the agents from your team"
            };
            this.searchValue = "";
            this.hasSearchString = false;
            this.isSearchStringLongEnough = false;
            this.getFormattedAgentListItem = (agent) => {
                return {
                    name: agent.name,
                    email: agent.email,
                    id: agent.id,
                    ariaLabel: agent.name,
                    actionButtonIconName: agent.actionButtonIconName,
                    actionButtonIconColor: agent.actionButtonIconColor,
                    avatarUrl: agent.avatarUrl,
                    showActionButton: agent.showActionButton,
                    actionButtonDisabled: agent.actionButtonDisabled,
                    isHighlighted: agent.isHighlighted,
                    template: (data) => {
                        return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
            <div class="agent-list-item" style="width: 100%">
              <uuip-wc-agent-list-item
                agentId=${data.id}
                agentName=${data.name}
                agentEmail=${data.email}
                actionButtonIconName=${data.actionButtonIconName}
                actionButtonIconColor=${data.actionButtonIconColor}
                avatarUrl=${data.avatarUrl}
                .showActionButton=${data.showActionButton}
                .actionButtonDisabled=${this.actionButtonsDisabled || data.actionButtonDisabled}
                .isHighlighted=${data.isHighlighted}
                @action-button-clicked=${this.handleActionButtonClicked}
              ></uuip-wc-agent-list-item>
            </div>
          `;
                    }
                };
            };
            this.getLoadingSpinner = () => {
                return {
                    id: "status-indicator",
                    name: "loading",
                    template: () => {
                        return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `<div part="spinner">
            <md-spinner size="18"></md-spinner>
          </div>`;
                    }
                };
            };
            this.handleLoadMore = () => {
                const loadMoreEvent = new CustomEvent("load-more-items", {
                    bubbles: true,
                    composed: true
                });
                this.dispatchEvent(loadMoreEvent);
            };
            this.handleSearchInputChanged = (event) => {
                var _a;
                this.searchValue = (_a = event.detail) === null || _a === void 0 ? void 0 : _a.value;
                this.hasSearchString = this.searchValue.length > 0;
                this.isSearchStringLongEnough = this.searchValue.length >= this.minimumSearchStringLength;
                if (!this.hasSearchString || this.isSearchStringLongEnough) {
                    this.agentList = [];
                    this.isLoading = true;
                    const searchInputChangedEvent = new CustomEvent("search-input-changed", {
                        bubbles: true,
                        composed: true,
                        detail: {
                            value: this.searchValue,
                            isSearchStringLongEnough: this.isSearchStringLongEnough
                        }
                    });
                    this.dispatchEvent(searchInputChangedEvent);
                }
            };
        }
        static get styles() {
            return _AgentList_scss__WEBPACK_IMPORTED_MODULE_3__["default"];
        }
        connectedCallback() {
            super.connectedCallback();
        }
        handleActionButtonClicked(event) {
            event.stopPropagation();
            const id = event.detail.id;
            const actionButtonClickedEvent = new CustomEvent("action-button-clicked", {
                bubbles: true,
                composed: true,
                detail: {
                    id
                }
            });
            this.dispatchEvent(actionButtonClickedEvent);
        }
        get agentListItems() {
            return this.agentList.map(this.getFormattedAgentListItem);
        }
        get loadingSpinner() {
            return this.isLoading ? [this.getLoadingSpinner()] : [];
        }
        renderSearchInput() {
            return this.showSearchInput
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
            <md-input
              class="search-input"
              label=${this.t.title}
              ariaLabel="${this.t.searchPlaceholder}"
              placeholder="${this.t.searchPlaceholder}"
              clear
              clearAriaLabel=${this.t.clearAriaLabel}
              newMomentum
              searchable
              value=${this.searchValue}
              @input-change=${this.handleSearchInputChanged}
            ></md-input>
          `
                : lit_html__WEBPACK_IMPORTED_MODULE_2__.nothing;
        }
        renderLoadingEmpty() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
        <div class="agent-list-loading-empty">
          <md-spinner size="18" class="loading-spinner"></md-spinner>
        </div>
      `;
        }
        renderInsufficientSearch() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
        <div class="insufficient-search-characters">
          <p>
            <md-icon name="info-circle-regular" size="16" iconSet="momentumDesign"></md-icon>
            ${this.t.insufficientSearchCharacters}
          </p>
        </div>
      `;
        }
        renderNoResults() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
        <div class="empty-state-placeholder">
          <uuip-wc-empty-state class="empty-state-wrapper" illustration-name="no_search_results">
            <p class="no-result-text">${this.t.noSearchResults}</p>
          </uuip-wc-empty-state>
        </div>
      `;
        }
        renderListNotice() {
            return this.showListNotice
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
            <div class="list-notice">
              <p>
                ${this.t.listNoticeLabel}
                <md-tooltip placement="right" message=${this.t.listNoticeTooltipMessage}>
                  <md-icon name="info-badge-filled" size="16" iconSet="momentumDesign"></md-icon>
                </md-tooltip>
              </p>
            </div>
          `
                : lit_html__WEBPACK_IMPORTED_MODULE_2__.nothing;
        }
        renderAgentList() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
        <md-advance-list
          .items=${[...this.agentListItems, ...this.loadingSpinner]}
          .isLoading=${this.isLoading}
          ariaRoleList="listbox"
          ariaLabelList=${this.t.listAriaLabel}
          containerHeight=${this.containerHeight}
          .totalRecords=${this.totalRecords}
          @load-more=${this.handleLoadMore}
        >
        </md-advance-list>
      `;
        }
        get isEmptyListLoading() {
            return this.isLoading && this.agentListItems.length === 0;
        }
        get noSearchResultsFound() {
            return this.hasSearchString && this.agentListItems.length === 0 && !this.isLoading;
        }
        get isSearchStringTooShort() {
            return this.hasSearchString && !this.isSearchStringLongEnough;
        }
        renderList() {
            if (this.isEmptyListLoading) {
                return this.renderLoadingEmpty();
            }
            if (this.isSearchStringTooShort) {
                return this.renderInsufficientSearch();
            }
            if (this.noSearchResultsFound) {
                return this.renderNoResults();
            }
            return this.renderAgentList();
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
        <div class="agent-list-container">
          ${this.renderSearchInput()} ${this.renderListNotice()} ${this.renderList()}
        </div>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Array })
    ], Element.prototype, "agentList", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Boolean })
    ], Element.prototype, "isLoading", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Boolean })
    ], Element.prototype, "showSearchInput", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Boolean })
    ], Element.prototype, "showListNotice", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Boolean })
    ], Element.prototype, "actionButtonsDisabled", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Object })
    ], Element.prototype, "localization", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Number })
    ], Element.prototype, "totalRecords", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: String })
    ], Element.prototype, "containerHeight", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Number })
    ], Element.prototype, "minimumSearchStringLength", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "t", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "searchValue", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "hasSearchString", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "isSearchStringLongEnough", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.customElement)("uuip-wc-agent-list")
    ], Element);
    AgentList.Element = Element;
})(AgentList || (AgentList = {}));


/***/ }),

/***/ "./src/components/AgentList/components/AgentListItem.scss":
/*!****************************************************************!*\
  !*** ./src/components/AgentList/components/AgentListItem.scss ***!
  \****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  /* Font family */
  --font-family: var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial, sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "CiscoSansTT Light", "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
}

.agent-list-item-container {
  width: 100%;
  height: 40px;
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  border-radius: 8px;
  gap: 12px;
}

.theme-background {
  background-color: var(--list-hover-background);
}

.theme-background:hover {
  background-color: var(--list-active-background);
}

.highlight-background {
  background-color: var(--badge-blue-active-bg-color);
}

.highlight-background:hover {
  background-color: var(--badge-blue-hover-bg-color);
}

.agent-list-item-layout {
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  margin-left: 12px;
}

.action-button {
  display: flex;
  align-items: center;
}

.agent-name-label {
  width: 100%;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.contact-card {
  width: 288px;
}
/*# sourceURL=/home/jenkins/agent/workspace/cicd-jobs/wxcc-common-CI-Builder/packages/@uuip/unified-ui-platform-common-components/src/assets/styles/variables.scss */
/*# sourceURL=AgentListItem.scss */
/*# sourceURL=/home/jenkins/agent/workspace/cicd-jobs/wxcc-common-CI-Builder/packages/@uuip/unified-ui-platform-common-components/src/components/AgentList/components/AgentListItem.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/AgentList/components/AgentListItem.ts":
/*!**************************************************************!*\
  !*** ./src/components/AgentList/components/AgentListItem.ts ***!
  \**************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   AgentListItem: () => (/* binding */ AgentListItem)
/* harmony export */ });
/* harmony import */ var _mixins_i18n__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18n */ "./src/mixins/i18n.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _AgentListItem_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./AgentListItem.scss */ "./src/components/AgentList/components/AgentListItem.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var AgentListItem;
(function (AgentListItem) {
    /**
     * @element uuip-wc-agent-list-item
     * @fires action-button-clicked
     */
    let Element = class Element extends (0,_mixins_i18n__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_1__.LitElement) {
        constructor() {
            super(...arguments);
            this.agentId = "";
            this.agentName = "";
            this.agentEmail = "";
            this.avatarUrl = "";
            this.actionButtonIconName = "";
            this.actionButtonIconColor = "";
            this.showActionButton = true;
            this.actionButtonDisabled = false;
            this.isHighlighted = false;
            this.localization = {};
            this.t = {};
            this.onActionButtonClicked = () => {
                this.dispatchEvent(new CustomEvent("action-button-clicked", { bubbles: true, composed: true, detail: { id: this.agentId } }));
            };
            this.renderActionButton = () => {
                return this.showActionButton
                    ? (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
            <md-button
              class="action-button"
              circle
              size="size-none"
              @button-click="${() => this.onActionButtonClicked()}"
              ?disabled=${this.actionButtonDisabled}
            >
              <md-icon
                slot="icon"
                name="${this.actionButtonIconName}"
                size="16"
                iconSet="momentumDesign"
                color="var(${this.actionButtonDisabled ? "--md-disabled-text-color" : this.actionButtonIconColor})"
              ></md-icon>
            </md-button>
          `
                    : lit_html__WEBPACK_IMPORTED_MODULE_2__.nothing;
            };
        }
        static get styles() {
            return _AgentListItem_scss__WEBPACK_IMPORTED_MODULE_3__["default"];
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
        <div class="agent-list-item-container ${this.isHighlighted ? "highlight-background" : "theme-background"}">
          <div class="agent-list-item-layout">
            ${this.renderActionButton()}
            <uuip-wc-agent-popover-avatar
              agentId=${this.agentId}
              agentName=${this.agentName}
              agentEmail=${this.agentEmail}
              avatarUrl=${this.avatarUrl}
              appendTo="app-theme"
              ?isTopmost=${true}
            ></uuip-wc-agent-popover-avatar>
          </div>
          <div class="agent-name-label">${this.agentName}</div>
        </div>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: String })
    ], Element.prototype, "agentId", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: String })
    ], Element.prototype, "agentName", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: String })
    ], Element.prototype, "agentEmail", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: String })
    ], Element.prototype, "avatarUrl", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: String })
    ], Element.prototype, "actionButtonIconName", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: String })
    ], Element.prototype, "actionButtonIconColor", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Boolean })
    ], Element.prototype, "showActionButton", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Boolean })
    ], Element.prototype, "actionButtonDisabled", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Boolean })
    ], Element.prototype, "isHighlighted", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Object })
    ], Element.prototype, "localization", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "t", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.customElement)("uuip-wc-agent-list-item")
    ], Element);
    AgentListItem.Element = Element;
})(AgentListItem || (AgentListItem = {}));


/***/ }),

/***/ "./src/components/AgentList/components/AgentPopoverAvatar.ts":
/*!*******************************************************************!*\
  !*** ./src/components/AgentList/components/AgentPopoverAvatar.ts ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   AgentPopoverAvatar: () => (/* binding */ AgentPopoverAvatar)
/* harmony export */ });
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-html/directives/if-defined */ "lit-html/directives/if-defined");
/* harmony import */ var lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_2__);
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var AgentPopoverAvatar;
(function (AgentPopoverAvatar) {
    /**
     * @element uuip-wc-agent-popover-avatar
     */
    let Element = class Element extends lit_element__WEBPACK_IMPORTED_MODULE_1__.LitElement {
        constructor() {
            super(...arguments);
            this.agentId = "";
            this.agentName = "";
            this.agentEmail = "";
            this.avatarUrl = "";
            this.isTopmost = false;
            this.isManuallyTriggered = false;
            this.appendTo = "";
            this.popoverController = this.isManuallyTriggered
                ? new _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_0__.PopoverController()
                : null;
            this.hoverTimer = null;
            this.closeTimer = null;
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
        <md-popover
          placement="bottom"
          triggerID=${this.agentId}
          trigger=${this.isManuallyTriggered ? "manual" : "mouseenter"}
          append-to=${(0,lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_2__.ifDefined)(this.appendTo)}
          interactive
          show-arrow
          hide-on-outside-click
          hide-on-escape
          focus-trap
          focus-back-to-trigger
          .controller=${this.popoverController}
          z-index=${this.isTopmost ? 9999 : 1000}
        >
          <div class="contact-card">
            <uuip-wc-contact-card
              agentName=${this.agentName}
              agentEmail=${this.agentEmail}
              avatarUrl=${this.avatarUrl}
              @mouseenter=${() => {
                if (this.closeTimer) {
                    clearTimeout(this.closeTimer);
                }
                this.closeTimer = null;
            }}
              @mouseleave=${() => {
                var _a;
                (_a = this.popoverController) === null || _a === void 0 ? void 0 : _a.hide();
            }}
            ></uuip-wc-contact-card>
          </div>
        </md-popover>
        <md-avatar
          id=${this.agentId}
          alt="avatar"
          size="24"
          title="${this.agentName}"
          src=${this.avatarUrl}
          @mouseenter=${() => {
                this.hoverTimer = window.setTimeout(() => {
                    var _a;
                    (_a = this.popoverController) === null || _a === void 0 ? void 0 : _a.show();
                }, 500);
            }}
          @mouseleave=${() => {
                if (this.hoverTimer) {
                    clearTimeout(this.hoverTimer);
                }
                this.hoverTimer = null;
                this.closeTimer = window.setTimeout(() => {
                    var _a;
                    (_a = this.popoverController) === null || _a === void 0 ? void 0 : _a.hide();
                }, 300);
            }}
        ></md-avatar>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: String })
    ], Element.prototype, "agentId", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: String })
    ], Element.prototype, "agentName", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: String })
    ], Element.prototype, "agentEmail", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: String })
    ], Element.prototype, "avatarUrl", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Boolean })
    ], Element.prototype, "isTopmost", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Boolean })
    ], Element.prototype, "isManuallyTriggered", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: String })
    ], Element.prototype, "appendTo", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "popoverController", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "hoverTimer", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "closeTimer", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.customElement)("uuip-wc-agent-popover-avatar")
    ], Element);
    AgentPopoverAvatar.Element = Element;
})(AgentPopoverAvatar || (AgentPopoverAvatar = {}));


/***/ }),

/***/ "./src/components/AgentList/components/ContactCard.scss":
/*!**************************************************************!*\
  !*** ./src/components/AgentList/components/ContactCard.scss ***!
  \**************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  /* Font family */
  --font-family: var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial, sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "CiscoSansTT Light", "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
}

.agent-contact-card-container {
  width: 288px;
  height: 112px;
  display: inline-flex;
  flex-direction: column;
  gap: 4px;
  padding-left: 12px;
  color: var(--md-primary-text-color);
}

.contact-card-details {
  width: 95%;
  font-family: var(--brand-font-regular, "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial, sans-serif);
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-bottom: 5px;
}

.contact-card-title {
  font-weight: var(--brand-font-weight-bold);
  font-size: var(--font-size-body-midsize);
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.email-container {
  font-weight: var(--brand-font-weight-regular);
  font-size: var(--font-size-body-small);
  display: block;
}

md-avatar {
  margin-top: 8px;
  align-self: flex-start;
}
/*# sourceURL=/home/jenkins/agent/workspace/cicd-jobs/wxcc-common-CI-Builder/packages/@uuip/unified-ui-platform-common-components/src/assets/styles/variables.scss */
/*# sourceURL=ContactCard.scss */
/*# sourceURL=/home/jenkins/agent/workspace/cicd-jobs/wxcc-common-CI-Builder/packages/@uuip/unified-ui-platform-common-components/src/components/AgentList/components/ContactCard.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/AgentList/components/ContactCard.ts":
/*!************************************************************!*\
  !*** ./src/components/AgentList/components/ContactCard.ts ***!
  \************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ContactCard: () => (/* binding */ ContactCard)
/* harmony export */ });
/* harmony import */ var _mixins_i18n__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18n */ "./src/mixins/i18n.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _ContactCard_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./ContactCard.scss */ "./src/components/AgentList/components/ContactCard.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var ContactCard;
(function (ContactCard) {
    /**
     * @element uuip-wc-contact-card
     */
    let Element = class Element extends (0,_mixins_i18n__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_1__.LitElement) {
        constructor() {
            super(...arguments);
            this.agentName = "";
            this.avatarUrl = "";
            this.agentEmail = "";
            this.localization = {};
            this.t = {
                emailLabel: "Email:"
            };
        }
        static get styles() {
            return _ContactCard_scss__WEBPACK_IMPORTED_MODULE_2__["default"];
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
      <div class="agent-contact-card-container">
        <md-avatar
          alt="avatar"
          title="${this.agentName}"
          size="48"
          src=${this.avatarUrl}
        ></md-avatar>
        <div class="contact-card-details">
          <div class="contact-card-title"> 
            ${this.agentName}
          </div>
          <div class="email-container">
            ${this.t.emailLabel}
            <md-link
              class="email-link"
              aria-label=${this.agentEmail}
              tag="a"
              href=mailto:${this.agentEmail}
            >${this.agentEmail}<md-link>
          </div>
        </div>
      </div>
    `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: String })
    ], Element.prototype, "agentName", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: String })
    ], Element.prototype, "avatarUrl", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: String })
    ], Element.prototype, "agentEmail", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Object })
    ], Element.prototype, "localization", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "t", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.customElement)("uuip-wc-contact-card")
    ], Element);
    ContactCard.Element = Element;
})(ContactCard || (ContactCard = {}));


/***/ }),

/***/ "./src/components/ChatMessageList/ChatMessageList.scss":
/*!*************************************************************!*\
  !*** ./src/components/ChatMessageList/ChatMessageList.scss ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`.chat-message-list-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  gap: 8px;
  margin-bottom: 12px;
}

.message-list-wrapper {
  padding: 0px;
  margin: 0px;
  flex-grow: 1;
  position: relative;
}

.virtualizer-container {
  width: 100%;
  height: 100%;
  display: inline-block;
  vertical-align: middle;
}

.message-list {
  width: calc(100% - 4px - 24px);
  height: calc(100% - 4px);
  margin: 2px;
  padding: 0px 12px;
  border-radius: 8px;
}

.message-container {
  width: calc(100% - 8px - 12px - 12px);
  padding: 0px;
  padding-left: 8px;
  padding-right: 12px;
  margin-top: 8px;
  border-radius: 8px;
}

.message-content {
  margin: 0px;
  padding: 0px;
}

.message-content.is-active {
  font-weight: bold !important;
}

.chat-announcement {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  margin: 8px;
}
.chat-announcement span {
  font-size: 12px;
  line-height: 16px;
  font-family: var(--font-family);
  color: var(--md-secondary-text-color);
}

.feedback-container {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.feedback-divider {
  width: 100%;
  height: 1px;
  background: linear-gradient(to right, transparent 0%, rgb(from var(--md-primary-text-color) r g b/0.2) 20%, rgb(from var(--md-primary-text-color) r g b/0.2) 80%, transparent 100%);
}

.chat-feedback {
  width: calc(100% - 8px - 12px - 24px);
  margin-left: 12px;
  padding-left: 8px;
}

.feedback-icons-wrapper {
  display: flex;
  flex-direction: row;
  gap: 8px;
  padding-left: 5px;
  padding-right: 5px;
}

.scroll-to-bottom-button {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
  opacity: 0%;
  bottom: 0px;
  animation-duration: var(--quick-animation-duration, 150ms);
  animation-timing-function: var(--ease-in-out-quint, cubic-bezier(0.83, 0, 0.17, 1));
}

.slide-up {
  bottom: 24px;
  opacity: 100%;
  animation-name: slide-up;
}

.slide-down {
  bottom: 0px;
  opacity: 0%;
  animation-name: slide-down;
}

@keyframes slide-up {
  from {
    bottom: 0px;
    opacity: 0%;
  }
  to {
    bottom: 24px;
    opacity: 100%;
  }
}
@keyframes slide-down {
  from {
    bottom: 24px;
    opacity: 100%;
  }
  to {
    bottom: 0px;
    opacity: 0%;
  }
}
/*# sourceURL=/home/jenkins/agent/workspace/cicd-jobs/wxcc-common-CI-Builder/packages/@uuip/unified-ui-platform-common-components/src/components/ChatMessageList/ChatMessageList.scss */
/*# sourceURL=ChatMessageList.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/ChatMessageList/ChatMessageList.ts":
/*!***********************************************************!*\
  !*** ./src/components/ChatMessageList/ChatMessageList.ts ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ChatMessageList: () => (/* binding */ ChatMessageList)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _ChatMessageList_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./ChatMessageList.scss */ "./src/components/ChatMessageList/ChatMessageList.scss");
/* harmony import */ var _components_ChatMessage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./components/ChatMessage */ "./src/components/ChatMessageList/components/ChatMessage.ts");
/* harmony import */ var _components_ChatAnnouncement__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./components/ChatAnnouncement */ "./src/components/ChatMessageList/components/ChatAnnouncement.ts");
/* harmony import */ var lit_virtualizer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lit-virtualizer */ "lit-virtualizer");
/* harmony import */ var lit_virtualizer__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lit_virtualizer__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lit_html_lit_html__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! lit-html/lit-html */ "lit-html/lit-html");
/* harmony import */ var lit_html_lit_html__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lit_html_lit_html__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _mixins_i18n__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @/mixins/i18n */ "./src/mixins/i18n.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};







var ChatMessageList;
(function (ChatMessageList) {
    /**
     * @element uuip-wc-chat-message-list
     * @fires feedback-clicked
     * @fires jump-to-bottom-clicked
     * @fires timestamp-message-list-clicked
     */
    let Element = class Element extends (0,_mixins_i18n__WEBPACK_IMPORTED_MODULE_6__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_0__.LitElement) {
        constructor() {
            super(...arguments);
            this.messageList = [];
            this.interactionId = "";
            this.showScrollButton = false;
            this.showFeedback = true;
            this.scrollToSeekTimeEnabled = false;
            this.makeActiveMessageBold = false;
            this.disableAutoScroll = false;
            this.seekTime = 0;
            this.localization = {};
            this.t = {
                feedbackText: "Rate this transcript. Your feedback helps us improve",
                tooltipHelpful: "This is helpful",
                tooltipNotHelpful: "This isn't helpful"
            };
            this.resizeObserver = null;
            this.renderMessage = (message) => {
                var _a;
                if (message.displayType === "CHAT" || message.displayType === "SELF") {
                    return (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.html) ` <uuip-wc-chat-message
          class="message-container"
          .message=${message}
          .makeActiveMessageBold=${this.makeActiveMessageBold}
          .isRelativeTimeStamp=${(_a = message.isRelativeTimeStamp) !== null && _a !== void 0 ? _a : false}
          @timestamp-message-clicked=${this.emitTimestampClicked}
        ></uuip-wc-chat-message>`;
                }
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.html) `<uuip-wc-chat-announcement
        class="message-container"
        .message=${message}
      ></uuip-wc-chat-announcement>`;
            };
            this.jumpToBottomClicked = () => {
                this.scrollToBottom();
                this.virtualizer.focus();
                this.dispatchEvent(new CustomEvent("jump-to-bottom-clicked", { bubbles: true, composed: true }));
            };
            this.handleScroll = () => {
                const { scrollTop, scrollHeight, clientHeight } = this.virtualizer;
                // amount of scroll distance to bottom to be considered a deliberate user action in order to stop auto scrolling
                // higher value of the threshold limits autoscroll stopping/jump-to-bottom button visibility sensitivity in case of higher rate message flows
                const manualScrollUpThreshold = 150;
                const thresholdExceeded = Math.abs(scrollHeight - clientHeight - scrollTop) > manualScrollUpThreshold;
                if (thresholdExceeded !== this.showScrollButton) {
                    const toggleClass = (toAdd, toRemove) => {
                        var _a;
                        const jumpToBottomButton = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(".scroll-to-bottom-button");
                        jumpToBottomButton === null || jumpToBottomButton === void 0 ? void 0 : jumpToBottomButton.classList.remove(toRemove);
                        jumpToBottomButton === null || jumpToBottomButton === void 0 ? void 0 : jumpToBottomButton.classList.add(toAdd);
                    };
                    if (thresholdExceeded) {
                        this.showScrollButton = thresholdExceeded;
                        setTimeout(() => toggleClass("slide-up", "slide-down"), 0);
                    }
                    else {
                        toggleClass("slide-down", "slide-up");
                        setTimeout(() => (this.showScrollButton = false), 150);
                    }
                }
            };
            this.autoScroll = () => {
                if (!this.showScrollButton && !this.disableAutoScroll) {
                    this.scrollToBottom();
                }
            };
        }
        static get styles() {
            return _ChatMessageList_scss__WEBPACK_IMPORTED_MODULE_1__["default"];
        }
        get feedbackMessage() {
            return {
                id: "",
                displayType: "FEEDBACK",
                rawTimestamp: 0,
                title: "",
                content: "",
                timestamp: "",
                avatarUrl: "",
                status: ""
            };
        }
        disconnectedCallback() {
            var _a;
            super.disconnectedCallback();
            (_a = this.resizeObserver) === null || _a === void 0 ? void 0 : _a.disconnect();
            this.resizeObserver = null;
        }
        evt(name, detail) {
            this.dispatchEvent(new CustomEvent(name, { bubbles: true, composed: true, detail }));
        }
        emitFeedbackClick(isUp) {
            this.evt("feedback-clicked", {
                interactionId: this.interactionId,
                type: isUp ? "THUMBS_UP" : "THUMBS_DOWN"
            });
        }
        emitTimestampClicked(event) {
            this.dispatchEvent(new CustomEvent("timestamp-message-list-clicked", {
                detail: { milliseconds: event.detail.milliseconds },
                bubbles: true,
                composed: true
            }));
        }
        renderFeedback() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.html) `
        <div class="feedback-container">
          <div class="feedback-divider"></div>
          <uuip-wc-chat-announcement
            class="chat-feedback"
            .message=${this.feedbackMessage}
            .localization=${{
                feedbackText: this.t.feedbackText,
                tooltipHelpful: this.t.tooltipHelpful,
                tooltipNotHelpful: this.t.tooltipNotHelpful
            }}
            @thumbs-up-clicked=${() => {
                this.emitFeedbackClick(true);
            }}
            @thumbs-down-clicked=${() => {
                this.emitFeedbackClick(false);
            }}
          ></uuip-wc-chat-announcement>
        </div>
      `;
        }
        scrollToBottom() {
            this.virtualizer.scrollToIndex(this.messageList.length - 1, "end");
            // scrollToIndex didn't prove enough to completely scroll the content
            // schedule another try to give the ui some time to update its values, this time alter scrollTop property directly
            setTimeout(() => {
                this.virtualizer.scrollTop = this.virtualizer.scrollHeight;
            }, 0);
        }
        firstUpdated() {
            var _a;
            this.virtualizer.addEventListener("scroll", this.handleScroll);
            this.resizeObserver = new ResizeObserver(this.autoScroll);
            (_a = this.resizeObserver) === null || _a === void 0 ? void 0 : _a.observe(this.messageListWrapper);
        }
        updated(changedProperties) {
            if (changedProperties.has("messageList") && this.messageList.length > 0) {
                this.updateComplete.then(() => {
                    requestAnimationFrame(this.autoScroll);
                });
            }
            if (changedProperties.has("seekTime") && this.scrollToSeekTimeEnabled) {
                this.scrollToSentenceAtSeekTime();
            }
        }
        scrollToSentenceAtSeekTime() {
            const activeMessageIndex = this.messageList.findIndex((message) => {
                var _a, _b;
                const startTime = (_a = message.messageStartTime) !== null && _a !== void 0 ? _a : 0;
                const endTime = (_b = message.messageEndTime) !== null && _b !== void 0 ? _b : startTime;
                return this.seekTime >= startTime && this.seekTime <= endTime;
            });
            if (activeMessageIndex !== -1) {
                this.updateComplete.then(() => {
                    requestAnimationFrame(() => {
                        this.virtualizer.scrollToIndex(activeMessageIndex, "center");
                    });
                });
            }
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.html) `
        <div class="chat-message-list-container">
          <div class="message-list-wrapper">
            <div class="virtualizer-container">
              <lit-virtualizer
                tabindex=0
                class="message-list"
                .items=${this.messageList}
                .renderItem=${this.renderMessage}
              </lit-virtualizer>
            </div>
            ${this.showScrollButton
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.html) `
                    <md-button
                      variant="primary"
                      circle
                      size="28"
                      class="scroll-to-bottom-button"
                      @click=${this.jumpToBottomClicked}
                      ><md-icon slot="icon" name="arrow-down_16"></md-icon
                    ></md-button>
                  `
                : lit_html_lit_html__WEBPACK_IMPORTED_MODULE_5__.nothing}
          </div>
          ${this.showFeedback && this.messageList.length > 0 ? this.renderFeedback() : lit_html_lit_html__WEBPACK_IMPORTED_MODULE_5__.nothing}
        </div>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.property)({ type: Array })
    ], Element.prototype, "messageList", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.property)({ type: String })
    ], Element.prototype, "interactionId", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.property)({ type: Boolean })
    ], Element.prototype, "showScrollButton", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.property)({ type: Boolean })
    ], Element.prototype, "showFeedback", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.property)({ type: Boolean })
    ], Element.prototype, "scrollToSeekTimeEnabled", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.property)({ type: Boolean })
    ], Element.prototype, "makeActiveMessageBold", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.property)({ type: Boolean })
    ], Element.prototype, "disableAutoScroll", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.property)({ type: Number })
    ], Element.prototype, "seekTime", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.property)({ type: Object })
    ], Element.prototype, "localization", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.internalProperty)()
    ], Element.prototype, "t", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.query)("lit-virtualizer")
    ], Element.prototype, "virtualizer", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.query)(".message-list-wrapper")
    ], Element.prototype, "messageListWrapper", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.customElement)("uuip-wc-chat-message-list")
    ], Element);
    ChatMessageList.Element = Element;
})(ChatMessageList || (ChatMessageList = {}));


/***/ }),

/***/ "./src/components/ChatMessageList/components/ChatAnnouncement.ts":
/*!***********************************************************************!*\
  !*** ./src/components/ChatMessageList/components/ChatAnnouncement.ts ***!
  \***********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ChatAnnouncement: () => (/* binding */ ChatAnnouncement)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _ChatMessageList_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./../ChatMessageList.scss */ "./src/components/ChatMessageList/ChatMessageList.scss");
/* harmony import */ var _mixins_i18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @/mixins/i18n */ "./src/mixins/i18n.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var ChatAnnouncement;
(function (ChatAnnouncement) {
    /**
     * @element uuip-wc-chat-announcement
     * @fires thumbs-up-clicked
     * @fires thumbs-down-clicked
     */
    let Element = class Element extends (0,_mixins_i18n__WEBPACK_IMPORTED_MODULE_2__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_0__.LitElement) {
        constructor() {
            super(...arguments);
            this.message = {
                id: "",
                displayType: "INFO",
                rawTimestamp: 0,
                title: "",
                content: "",
                timestamp: "",
                avatarUrl: "",
                status: ""
            };
            this.localization = {};
            this.t = {
                feedbackText: "Rate this transcript. Your feedback helps us improve",
                tooltipHelpful: "This is helpful",
                tooltipNotHelpful: "This isn't helpful"
            };
            this.thumbsUpClicked = false;
            this.thumbsDownClicked = false;
        }
        static get styles() {
            return _ChatMessageList_scss__WEBPACK_IMPORTED_MODULE_1__["default"];
        }
        emitThumbClick(isUp) {
            const eventName = isUp ? "thumbs-up-clicked" : "thumbs-down-clicked";
            this.dispatchEvent(new CustomEvent(eventName, { bubbles: true, composed: true }));
            if (isUp) {
                this.thumbsUpClicked = !this.thumbsUpClicked;
                this.thumbsDownClicked = false;
            }
            else {
                this.thumbsDownClicked = !this.thumbsDownClicked;
                this.thumbsUpClicked = false;
            }
        }
        getIconName(isUp) {
            if (isUp) {
                return this.thumbsUpClicked ? "like-filled" : "like-regular";
            }
            return this.thumbsDownClicked ? "dislike-filled" : "dislike-regular";
        }
        renderThumbsUpDown(isUp) {
            const thumbsUpButtonAriaLabel = isUp ? "thumbs up" : "thumbs down";
            const tooltipMessage = isUp ? this.t.tooltipHelpful : this.t.tooltipNotHelpful;
            const iconName = this.getIconName(isUp);
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.html) ` <md-tooltip placement="bottom" message=${tooltipMessage}>
        <md-button
          circle
          variant="ghost"
          aria-label=${thumbsUpButtonAriaLabel}
          size="size-none"
          @click=${() => this.emitThumbClick(isUp)}
        >
          <md-icon slot="icon" size="16" name=${iconName} iconSet="momentumDesign"></md-icon>
        </md-button>
      </md-tooltip>`;
        }
        renderFeedback() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.html) `<div class="chat-announcement">
        <span>${this.t.feedbackText}</span>
        <div class="feedback-icons-wrapper">
          <md-icon name="shape-circle-sm-filled" size="16" iconSet="momentumDesign" color="var(--md-gray-40)"></md-icon>
          ${this.renderThumbsUpDown(true)} ${this.renderThumbsUpDown(false)}
        </div>
      </div>`;
        }
        renderSimpleAnnouncement() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.html) ` <div class="chat-announcement">
        <span>
          <p class="message-content">${this.message.content} ${this.message.timestamp}</p>
        </span>
      </div>`;
        }
        renderAnnouncement() {
            if (this.message.displayType === "FEEDBACK") {
                return this.renderFeedback();
            }
            if (this.message.displayType === "START" ||
                this.message.displayType === "END" ||
                this.message.displayType === "INFO" ||
                this.message.displayType === "WARNING" ||
                this.message.displayType === "ERROR") {
                return this.renderSimpleAnnouncement();
            }
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.html) ``;
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.html) `<div>${this.renderAnnouncement()}</div>`;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.property)({ type: Object })
    ], Element.prototype, "message", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.property)({ type: Object })
    ], Element.prototype, "localization", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.internalProperty)()
    ], Element.prototype, "t", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.internalProperty)()
    ], Element.prototype, "thumbsUpClicked", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.internalProperty)()
    ], Element.prototype, "thumbsDownClicked", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.customElement)("uuip-wc-chat-announcement")
    ], Element);
    ChatAnnouncement.Element = Element;
})(ChatAnnouncement || (ChatAnnouncement = {}));


/***/ }),

/***/ "./src/components/ChatMessageList/components/ChatMessage.ts":
/*!******************************************************************!*\
  !*** ./src/components/ChatMessageList/components/ChatMessage.ts ***!
  \******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ChatMessage: () => (/* binding */ ChatMessage)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _ChatMessageList_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./../ChatMessageList.scss */ "./src/components/ChatMessageList/ChatMessageList.scss");
/* harmony import */ var lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-html/directives/if-defined */ "lit-html/directives/if-defined");
/* harmony import */ var lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @/utils/helpers */ "./src/utils/helpers.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var ChatMessage;
(function (ChatMessage) {
    /**
     * @element uuip-wc-chat-message
     * @fires timestamp-message-clicked
     */
    let Element = class Element extends lit_element__WEBPACK_IMPORTED_MODULE_0__.LitElement {
        constructor() {
            super(...arguments);
            this.message = {
                id: "",
                displayType: "CHAT",
                rawTimestamp: 0,
                title: "",
                content: "",
                timestamp: "",
                avatarUrl: "",
                status: "",
                isActive: false
            };
            this.isRelativeTimeStamp = false;
            this.makeActiveMessageBold = false;
        }
        get formattedTime() {
            if (this.isRelativeTimeStamp && this.message.messageStartTime) {
                return (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_3__.relativeTimeFormatter)(this.message.messageStartTime);
            }
            return this.message.timestamp;
        }
        propagateTimestampClickedEvent(milliseconds) {
            this.dispatchEvent(new CustomEvent("timestamp-message-clicked", {
                detail: { milliseconds },
                bubbles: true,
                composed: true
            }));
        }
        get getIsActive() {
            var _a;
            return this.makeActiveMessageBold && ((_a = this.message.isActive) !== null && _a !== void 0 ? _a : false);
        }
        static get styles() {
            return _ChatMessageList_scss__WEBPACK_IMPORTED_MODULE_1__["default"];
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.html) `
        <md-chat-message
          time=${this.formattedTime}
          title=${this.message.title}
          .status=${this.message.status}
          .src=${this.message.avatarUrl}
          ?self=${this.message.displayType === "SELF"}
          .avatarSize=${32}
          .avatarColor=${(0,lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_2__.ifDefined)(this.message.avatarColor)}
          ?clickableTimestamp=${this.isRelativeTimeStamp}
          @timestamp-clicked=${() => { var _a; return this.propagateTimestampClickedEvent((_a = this.message.messageStartTime) !== null && _a !== void 0 ? _a : 0); }}
        >
          <p class="message-content ${this.getIsActive ? "is-active" : ""}" slot="message">${this.message.content}</p>
        </md-chat-message>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.property)({ type: Object })
    ], Element.prototype, "message", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.property)({ type: Boolean })
    ], Element.prototype, "isRelativeTimeStamp", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.property)({ type: Boolean })
    ], Element.prototype, "makeActiveMessageBold", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.customElement)("uuip-wc-chat-message")
    ], Element);
    ChatMessage.Element = Element;
})(ChatMessage || (ChatMessage = {}));


/***/ }),

/***/ "./src/components/CollapseArea/CollapseArea.scss":
/*!*******************************************************!*\
  !*** ./src/components/CollapseArea/CollapseArea.scss ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  display: block;
  height: 100%;
  position: relative;
  transition: width 350ms ease-in-out;
  width: auto;
  will-change: width;
  /**
  * WARNING!!!
  * Do NOT use transform: translateX/Y/X/3d to not break fixed positioning maximized widget inside collapse area.
  * "will-change" rule is enough for gpu animation
  */
}
:host .collapse-area {
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
}
:host .collapse-area .collapse-area-inner {
  bottom: 0;
  left: 0;
  overflow: hidden;
  position: absolute;
  right: 0;
  top: 0;
}

:host([direction=left]) .collapse-area {
  border-right: 2px solid var(--md-quaternary-bg-color, --md-quaternary-bg-color-default);
}
:host([direction=left]) .collapse-area.hovered {
  border-right: 2px solid var(--md-primary-seperator-color, --md-primary-seperator-color-default);
}

:host([direction=right]) .collapse-area {
  border-left: 2px solid var(--md-quaternary-bg-color, --md-quaternary-bg-color-default);
}
:host([direction=right]) .collapse-area.hovered {
  border-left: 2px solid var(--md-primary-seperator-color, --md-primary-seperator-color-default);
}

:host([collapsed]) {
  width: 0 !important;
}

:host([collapsed][direction=left]) .collapse-area {
  border-right: 0;
}

:host([collapsed][direction=right]) .collapse-area {
  border-left: 0;
}
/*# sourceURL=/home/jenkins/agent/workspace/cicd-jobs/wxcc-common-CI-Builder/packages/@uuip/unified-ui-platform-common-components/src/components/CollapseArea/CollapseArea.scss */
/*# sourceURL=CollapseArea.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/CollapseArea/CollapseArea.ts":
/*!*****************************************************!*\
  !*** ./src/components/CollapseArea/CollapseArea.ts ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   CollapseArea: () => (/* binding */ CollapseArea)
/* harmony export */ });
/* harmony import */ var _components_CollapseArea_components_CollapseToggler__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../components/CollapseArea/components/CollapseToggler */ "./src/components/CollapseArea/components/CollapseToggler.ts");
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/utils/helpers */ "./src/utils/helpers.ts");
/* harmony import */ var _utils_WindowListenersHub__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @/utils/WindowListenersHub */ "./src/utils/WindowListenersHub.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lit-html/directives/class-map */ "lit-html/directives/class-map");
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _CollapseArea_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./CollapseArea.scss */ "./src/components/CollapseArea/CollapseArea.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};






var CollapseArea;
(function (CollapseArea) {
    CollapseArea.TRANSITION_FAILED_TIMEOUT = 2000; //ms
    const DEFAULT_TOGGLER_MOUSE_VISIBLE_DISTANCE = 100; //px
    let Direction;
    (function (Direction) {
        Direction["Left"] = "left";
        Direction["Right"] = "right";
    })(Direction = CollapseArea.Direction || (CollapseArea.Direction = {}));
    let Events;
    (function (Events) {
        Events["Toggle"] = "toggle";
        Events["ExpandTransitionStart"] = "expand-transition-start";
        Events["ExpandTransitionEnd"] = "expand-transition-end";
        Events["CollapseTransitionStart"] = "collapse-transition-start";
        Events["CollapseTransitionEnd"] = "collapse-transition-end";
    })(Events = CollapseArea.Events || (CollapseArea.Events = {}));
    /**
     * @element uuip-wc-collapse-area
     *
     * @fires toggle
     *
     * @fires expand-transition-start
     * @fires expand-transition-end
     * @fires collapse-transition-start
     * @fires collapse-transition-end
     */
    let Element = class Element extends lit_element__WEBPACK_IMPORTED_MODULE_3__.LitElement {
        constructor() {
            super(...arguments);
            this.collapsed = false;
            this.direction = Direction.Left;
            // Display toggler on mouse over selectors that are not in collpase-area
            this.forceTogglerVisibilityOnMouseOverSelectors = "";
            // Distance to display toggler when mouse close to it in px
            this.togglerMouseVisibleDistance = DEFAULT_TOGGLER_MOUSE_VISIBLE_DISTANCE;
            this.isMouseCloseToToggler = false;
            this.isMouseInSelfArea = false;
            this.isMouseOverSelector = false;
            this.isMouseOverOnToggler = false;
            this.onSelfMouseEnter = (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_1__.throttle)(() => (this.isMouseInSelfArea = true));
            this.onSelfMouseLeave = (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_1__.throttle)(() => (this.isMouseInSelfArea = false));
            this.onWindowMouseMove = (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_1__.throttle)((e) => {
                const _path = e.composedPath();
                const _selectors = Array.isArray(this.forceTogglerVisibilityOnMouseOverSelectors)
                    ? this.forceTogglerVisibilityOnMouseOverSelectors
                    : this.forceTogglerVisibilityOnMouseOverSelectors.split(" ");
                if (_path.length) {
                    this.isMouseOverSelector = !!_selectors.find(selector => !!_path.find((eventTarget) => {
                        return (eventTarget && eventTarget.matches && eventTarget.matches(selector));
                    }));
                }
                const { clientX: x, clientY: y } = e;
                const { top, right, bottom, left } = this.toggler.getBoundingClientRect();
                this.isMouseCloseToToggler = (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_1__.isCoordCloseToRect)({ x, y }, { top, right, bottom, left }, this.togglerMouseVisibleDistance);
            });
            this.onWindowMouseLeave = (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_1__.throttle)(() => {
                this.isMouseOverSelector = false;
                this.isMouseCloseToToggler = false;
            });
            this.onTogglerMouseOver = (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_1__.throttle)(() => (this.isMouseOverOnToggler = true));
            this.onTogglerMouseOut = (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_1__.throttle)(() => (this.isMouseOverOnToggler = false));
        }
        get isTogglerVisible() {
            return this.isMouseCloseToToggler || this.isMouseInSelfArea || this.isMouseOverSelector;
        }
        connectedCallback() {
            super.connectedCallback();
            this.addEventListener("mouseenter", this.onSelfMouseEnter);
            this.addEventListener("mouseleave", this.onSelfMouseLeave);
            _utils_WindowListenersHub__WEBPACK_IMPORTED_MODULE_2__.WINDOW_LISTENERS_HUB.on("mouseenter", this.onWindowMouseMove);
            _utils_WindowListenersHub__WEBPACK_IMPORTED_MODULE_2__.WINDOW_LISTENERS_HUB.on("mousemove", this.onWindowMouseMove);
            _utils_WindowListenersHub__WEBPACK_IMPORTED_MODULE_2__.WINDOW_LISTENERS_HUB.on("mouseleave", this.onWindowMouseLeave);
        }
        disconnectedCallback() {
            super.disconnectedCallback();
            this.removeEventListener("mouseenter", this.onSelfMouseEnter);
            this.removeEventListener("mouseleave", this.onSelfMouseLeave);
            _utils_WindowListenersHub__WEBPACK_IMPORTED_MODULE_2__.WINDOW_LISTENERS_HUB.off("mouseenter", this.onWindowMouseMove);
            _utils_WindowListenersHub__WEBPACK_IMPORTED_MODULE_2__.WINDOW_LISTENERS_HUB.off("mousemove", this.onWindowMouseMove);
            _utils_WindowListenersHub__WEBPACK_IMPORTED_MODULE_2__.WINDOW_LISTENERS_HUB.off("mouseleave", this.onWindowMouseLeave);
        }
        update(changedProperties) {
            super.update(changedProperties);
            changedProperties.forEach((oldValue, name) => {
                if (name === "collapsed") {
                    if (oldValue !== this.collapsed && typeof oldValue === "boolean") {
                        this.dispatchTransitionStateUpdates();
                    }
                }
            });
        }
        static get styles() {
            return [_CollapseArea_scss__WEBPACK_IMPORTED_MODULE_5__["default"]];
        }
        emitComponentUpdate(eventName, detail) {
            this.dispatchEvent(new CustomEvent(eventName, { detail }));
        }
        //this dispatch have to be called in "update" (not in "updated") - before DOM udpates
        dispatchTransitionStateUpdates() {
            return __awaiter(this, void 0, void 0, function* () {
                const { collapsed, direction } = this;
                const detail = { collapsed, direction };
                // Emit start
                this.emitComponentUpdate(collapsed ? Events.CollapseTransitionStart : Events.ExpandTransitionStart, detail);
                // Bind & resolve "width" transition animation promise
                yield (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_1__.createElementTransitionEndPromise)(this, "width", CollapseArea.TRANSITION_FAILED_TIMEOUT);
                // Emit end
                this.emitComponentUpdate(collapsed ? Events.CollapseTransitionEnd : Events.ExpandTransitionEnd, detail);
            });
        }
        toggle(e) {
            this.emitComponentUpdate(CollapseArea.Events.Toggle, {
                collapsed: e.detail.collapsed,
                direction: this.direction
            });
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
        <div class="collapse-area ${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_4__.classMap)({ hovered: this.isMouseOverOnToggler })}">
          <div class="collapse-area-inner">
            <slot></slot>
          </div>
          <uuip-wc-collapse-toggler
            .direction="${this.direction}"
            .collapsed="${this.collapsed}"
            .visible="${this.isTogglerVisible}"
            @toggle="${(e) => this.toggle(e)}"
            @mouseover="${() => this.onTogglerMouseOver()}"
            @mouseout="${() => this.onTogglerMouseOut()}"
          ></uuip-wc-collapse-toggler>
        </div>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Boolean, reflect: true })
    ], Element.prototype, "collapsed", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: String, reflect: true })
    ], Element.prototype, "direction", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: String })
    ], Element.prototype, "forceTogglerVisibilityOnMouseOverSelectors", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({
            type: Number,
            attribute: "toggler-mouse-visible-distance"
        })
    ], Element.prototype, "togglerMouseVisibleDistance", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "isMouseCloseToToggler", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "isMouseInSelfArea", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "isMouseOverSelector", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "isMouseOverOnToggler", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.query)("uuip-wc-collapse-toggler")
    ], Element.prototype, "toggler", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.customElement)("uuip-wc-collapse-area")
    ], Element);
    CollapseArea.Element = Element;
})(CollapseArea || (CollapseArea = {}));


/***/ }),

/***/ "./src/components/CollapseArea/components/CollapseToggler.scss":
/*!*********************************************************************!*\
  !*** ./src/components/CollapseArea/components/CollapseToggler.scss ***!
  \*********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  /* Font family */
  --font-family: var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial, sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "CiscoSansTT Light", "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
}

:host {
  --column-toggler-height: 40px;
  --column-toggler-width: 12px;
  --column-toggler-background-color: #b4b6b8;
  --column-toggler-border-radius: 16px;
  background-color: transparent;
  cursor: pointer;
  display: flex;
  height: var(--column-toggler-height);
  overflow: hidden;
  position: absolute;
  top: calc(50% - var(--column-toggler-height) / 2);
  width: var(--column-toggler-width);
}
:host .toggler {
  align-items: center;
  background-color: var(--md-quaternary-bg-color, --md-quaternary-bg-color-default);
  color: var(--md-secondary-text-color, --md-secondary-text-color-default);
  bottom: 0;
  display: flex;
  justify-content: center;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  transition: 150ms ease-in-out;
}
:host .toggler.visible {
  transform: translate3d(0, 0, 0) !important;
}
:host .toggler:hover {
  background-color: var(--md-primary-seperator-color, --md-primary-seperator-color-default);
}

:host([direction=left]) {
  left: auto;
  right: calc(var(--column-toggler-width) * -1);
}
:host([direction=left]) .toggler {
  border-bottom-right-radius: var(--column-toggler-border-radius);
  border-top-right-radius: var(--column-toggler-border-radius);
  transform: translate3d(calc(var(--column-toggler-width) * -1), 0, 0);
}

:host([direction=right]) {
  left: calc(var(--column-toggler-width) * -1);
  right: auto;
}
:host([direction=right]) .toggler {
  border-bottom-left-radius: var(--column-toggler-border-radius);
  border-top-left-radius: var(--column-toggler-border-radius);
  transform: translate3d(var(--column-toggler-width), 0, 0);
}
/*# sourceURL=/home/jenkins/agent/workspace/cicd-jobs/wxcc-common-CI-Builder/packages/@uuip/unified-ui-platform-common-components/src/assets/styles/variables.scss */
/*# sourceURL=CollapseToggler.scss */
/*# sourceURL=/home/jenkins/agent/workspace/cicd-jobs/wxcc-common-CI-Builder/packages/@uuip/unified-ui-platform-common-components/src/components/CollapseArea/components/CollapseToggler.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/CollapseArea/components/CollapseToggler.ts":
/*!*******************************************************************!*\
  !*** ./src/components/CollapseArea/components/CollapseToggler.ts ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   CollapseToggler: () => (/* binding */ CollapseToggler)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-html/directives/class-map */ "lit-html/directives/class-map");
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _CollapseToggler_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./CollapseToggler.scss */ "./src/components/CollapseArea/components/CollapseToggler.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var CollapseToggler;
(function (CollapseToggler) {
    let Event;
    (function (Event) {
        Event["Toggle"] = "toggle";
    })(Event = CollapseToggler.Event || (CollapseToggler.Event = {}));
    let Direction;
    (function (Direction) {
        Direction["Left"] = "left";
        Direction["Right"] = "right";
    })(Direction = CollapseToggler.Direction || (CollapseToggler.Direction = {}));
    /**
     * @element uuip-wc-collapse-toggler
     * @fires toggle
     */
    let Element = class Element extends lit_element__WEBPACK_IMPORTED_MODULE_0__.LitElement {
        constructor() {
            super(...arguments);
            this.collapsed = false;
            this.direction = Direction.Left;
            this.visible = true;
            this.hovered = false;
        }
        toggle() {
            this.dispatchEvent(new CustomEvent(CollapseToggler.Event.Toggle, {
                detail: {
                    collapsed: !this.collapsed
                }
            }));
        }
        static get styles() {
            return [_CollapseToggler_scss__WEBPACK_IMPORTED_MODULE_2__["default"]];
        }
        get iconName() {
            const ICON_NAME_LEFT = "arrow-left-regular";
            const ICON_NAME_RIGHT = "arrow-right-regular";
            if (this.collapsed) {
                if (this.direction === Direction.Left) {
                    return ICON_NAME_RIGHT;
                }
                if (this.direction === Direction.Right) {
                    return ICON_NAME_LEFT;
                }
            }
            else {
                if (this.direction === Direction.Left) {
                    return ICON_NAME_LEFT;
                }
                if (this.direction === Direction.Right) {
                    return ICON_NAME_RIGHT;
                }
            }
            return "";
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.html) `
        <span class="toggler ${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_1__.classMap)({ visible: this.visible || this.collapsed })}" @click="${() => this.toggle()}">
          <md-icon name="${this.iconName}" size="8" iconSet="momentumDesign"></md-icon>
        </span>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.property)({ type: Boolean })
    ], Element.prototype, "collapsed", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.property)({ type: String, reflect: true })
    ], Element.prototype, "direction", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.property)({ type: Boolean })
    ], Element.prototype, "visible", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.property)({ type: Boolean })
    ], Element.prototype, "hovered", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.customElement)("uuip-wc-collapse-toggler")
    ], Element);
    CollapseToggler.Element = Element;
})(CollapseToggler || (CollapseToggler = {}));


/***/ }),

/***/ "./src/components/ContentState/ContentError.scss":
/*!*******************************************************!*\
  !*** ./src/components/ContentState/ContentError.scss ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`.content-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  background-color: #fff2f5;
}
.content-error .content-error-text {
  margin-top: 3rem;
}
/*# sourceURL=/home/jenkins/agent/workspace/cicd-jobs/wxcc-common-CI-Builder/packages/@uuip/unified-ui-platform-common-components/src/components/ContentState/ContentError.scss */
/*# sourceURL=ContentError.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL2plbmtpbnMvYWdlbnQvd29ya3NwYWNlL2NpY2Qtam9icy93eGNjLWNvbW1vbi1DSS1CdWlsZGVyL3BhY2thZ2VzL0B1dWlwL3VuaWZpZWQtdWktcGxhdGZvcm0tY29tbW9uLWNvbXBvbmVudHMvc3JjL2NvbXBvbmVudHMvQ29udGVudFN0YXRlL0NvbnRlbnRFcnJvci5zY3NzIiwiQ29udGVudEVycm9yLnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRSxhQUFBO0VBQ0Esc0JBQUE7RUFDQSxtQkFBQTtFQUNBLHVCQUFBO0VBQ0EsWUFBQTtFQUNBLFdBQUE7RUFDQSx5QkFBQTtBQ0NGO0FEQ0U7RUFDRSxnQkFBQTtBQ0NKIiwiZmlsZSI6IkNvbnRlbnRFcnJvci5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLmNvbnRlbnQtZXJyb3Ige1xyXG4gIGRpc3BsYXk6IGZsZXg7XHJcbiAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcclxuICBhbGlnbi1pdGVtczogY2VudGVyO1xyXG4gIGp1c3RpZnktY29udGVudDogY2VudGVyO1xyXG4gIGhlaWdodDogMTAwJTtcclxuICB3aWR0aDogMTAwJTtcclxuICBiYWNrZ3JvdW5kLWNvbG9yOiAjZmZmMmY1O1xyXG5cclxuICAuY29udGVudC1lcnJvci10ZXh0IHtcclxuICAgIG1hcmdpbi10b3A6IDNyZW07XHJcbiAgfVxyXG59XHJcbiIsIi5jb250ZW50LWVycm9yIHtcbiAgZGlzcGxheTogZmxleDtcbiAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XG4gIGhlaWdodDogMTAwJTtcbiAgd2lkdGg6IDEwMCU7XG4gIGJhY2tncm91bmQtY29sb3I6ICNmZmYyZjU7XG59XG4uY29udGVudC1lcnJvciAuY29udGVudC1lcnJvci10ZXh0IHtcbiAgbWFyZ2luLXRvcDogM3JlbTtcbn0iXX0= */`);
    

/***/ }),

/***/ "./src/components/ContentState/ContentError.ts":
/*!*****************************************************!*\
  !*** ./src/components/ContentState/ContentError.ts ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ContentError: () => (/* binding */ ContentError)
/* harmony export */ });
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _ContentError_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./ContentError.scss */ "./src/components/ContentState/ContentError.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var ContentError;
(function (ContentError) {
    ContentError.DEFAULT_ERROR_TEXT = "An error occured";
    /**
     * @element uuip-wc-content-error
     */
    let Element = class Element extends lit_element__WEBPACK_IMPORTED_MODULE_1__.LitElement {
        static get styles() {
            return [_ContentError_scss__WEBPACK_IMPORTED_MODULE_2__["default"]];
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
        <div class="content-error">
          <div class="content-error-text">
            <slot>${ContentError.DEFAULT_ERROR_TEXT}</slot>
          </div>
          <md-icon ariaLabel="error-legacy" color="black" name="error-legacy-regular" size="24" iconSet="momentumDesign" title="Error"></md-icon>
        </div>
      `;
        }
    };
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.customElement)("uuip-wc-content-error")
    ], Element);
    ContentError.Element = Element;
})(ContentError || (ContentError = {}));


/***/ }),

/***/ "./src/components/ContentState/ContentLoading.scss":
/*!*********************************************************!*\
  !*** ./src/components/ContentState/ContentLoading.scss ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`.content-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
}
.content-loading .content-loading-text {
  margin-top: 3rem;
}
/*# sourceURL=/home/jenkins/agent/workspace/cicd-jobs/wxcc-common-CI-Builder/packages/@uuip/unified-ui-platform-common-components/src/components/ContentState/ContentLoading.scss */
/*# sourceURL=ContentLoading.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL2plbmtpbnMvYWdlbnQvd29ya3NwYWNlL2NpY2Qtam9icy93eGNjLWNvbW1vbi1DSS1CdWlsZGVyL3BhY2thZ2VzL0B1dWlwL3VuaWZpZWQtdWktcGxhdGZvcm0tY29tbW9uLWNvbXBvbmVudHMvc3JjL2NvbXBvbmVudHMvQ29udGVudFN0YXRlL0NvbnRlbnRMb2FkaW5nLnNjc3MiLCJDb250ZW50TG9hZGluZy5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0UsYUFBQTtFQUNBLHNCQUFBO0VBQ0EsbUJBQUE7RUFDQSx1QkFBQTtFQUNBLFlBQUE7RUFDQSxXQUFBO0FDQ0Y7QURDRTtFQUNFLGdCQUFBO0FDQ0oiLCJmaWxlIjoiQ29udGVudExvYWRpbmcuc2NzcyIsInNvdXJjZXNDb250ZW50IjpbIi5jb250ZW50LWxvYWRpbmcge1xyXG4gIGRpc3BsYXk6IGZsZXg7XHJcbiAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcclxuICBhbGlnbi1pdGVtczogY2VudGVyO1xyXG4gIGp1c3RpZnktY29udGVudDogY2VudGVyO1xyXG4gIGhlaWdodDogMTAwJTtcclxuICB3aWR0aDogMTAwJTtcclxuXHJcbiAgLmNvbnRlbnQtbG9hZGluZy10ZXh0IHtcclxuICAgIG1hcmdpbi10b3A6IDNyZW07XHJcbiAgfVxyXG59IiwiLmNvbnRlbnQtbG9hZGluZyB7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gIGp1c3RpZnktY29udGVudDogY2VudGVyO1xuICBoZWlnaHQ6IDEwMCU7XG4gIHdpZHRoOiAxMDAlO1xufVxuLmNvbnRlbnQtbG9hZGluZyAuY29udGVudC1sb2FkaW5nLXRleHQge1xuICBtYXJnaW4tdG9wOiAzcmVtO1xufSJdfQ== */`);
    

/***/ }),

/***/ "./src/components/ContentState/ContentLoading.ts":
/*!*******************************************************!*\
  !*** ./src/components/ContentState/ContentLoading.ts ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ContentLoading: () => (/* binding */ ContentLoading)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _ContentLoading_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./ContentLoading.scss */ "./src/components/ContentState/ContentLoading.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var ContentLoading;
(function (ContentLoading) {
    ContentLoading.DEFAULT_LOADING_TEXT = "Please wait while the data is loading";
    /**
     * @element uuip-wc-content-loading
     */
    let Element = class Element extends lit_element__WEBPACK_IMPORTED_MODULE_0__.LitElement {
        static get styles() {
            return [_ContentLoading_scss__WEBPACK_IMPORTED_MODULE_1__["default"]];
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.html) `
        <div class="content-loading">
          <div class="content-loading-text">
            <slot>${ContentLoading.DEFAULT_LOADING_TEXT}</slot>
          </div>
          <md-loading class="md-loading"></md-loading>
        </div>
      `;
        }
    };
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.customElement)("uuip-wc-content-loading")
    ], Element);
    ContentLoading.Element = Element;
})(ContentLoading || (ContentLoading = {}));


/***/ }),

/***/ "./src/components/EmergencyNotification/EmergencyNotificationContent.scss":
/*!********************************************************************************!*\
  !*** ./src/components/EmergencyNotification/EmergencyNotificationContent.scss ***!
  \********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  /* Font family */
  --font-family: var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial, sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "CiscoSansTT Light", "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
}

.emergency-notification-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.emergency-notification-content {
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  font-family: var(--font-family);
}

.heading {
  font-weight: 700;
  margin-bottom: 4px;
}

label {
  color: var(--md-secondary-text-color);
}

md-link::part(link) {
  color: var(--alert-banner-warning-text-color);
}

.emergency-modal-warning-content {
  display: flex;
  gap: 12px;
  text-align: start;
  align-items: flex-start;
}
/*# sourceURL=/home/jenkins/agent/workspace/cicd-jobs/wxcc-common-CI-Builder/packages/@uuip/unified-ui-platform-common-components/src/assets/styles/variables.scss */
/*# sourceURL=EmergencyNotificationContent.scss */
/*# sourceURL=/home/jenkins/agent/workspace/cicd-jobs/wxcc-common-CI-Builder/packages/@uuip/unified-ui-platform-common-components/src/components/EmergencyNotification/EmergencyNotificationContent.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/EmergencyNotification/EmergencyNotificationContent.ts":
/*!******************************************************************************!*\
  !*** ./src/components/EmergencyNotification/EmergencyNotificationContent.ts ***!
  \******************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   EmergencyNotificationContent: () => (/* binding */ EmergencyNotificationContent)
/* harmony export */ });
/* harmony import */ var _mixins_i18n__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18n */ "./src/mixins/i18n.ts");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _EmergencyNotificationContent_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./EmergencyNotificationContent.scss */ "./src/components/EmergencyNotification/EmergencyNotificationContent.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};




var EmergencyNotificationContent;
(function (EmergencyNotificationContent) {
    /**
     * @element uuip-wc-emergency-notification-content
     * @fires read-notification-change
     */
    let Element = class Element extends (0,_mixins_i18n__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_2__.LitElement) {
        constructor() {
            super(...arguments);
            this.warningLinkUrl = "";
            this.localization = {};
            this.t = {
                notificationTitle: "Dialing Emergency Services",
                notificationContent: 
                // eslint-disable-next-line max-len
                "Use the Desktop outdial dial pad, when using the Desktop Telephony option for dialling emergency services (e.g. 999). Emergency services may not be accessible outside of your home country.",
                warningMessage: 
                // eslint-disable-next-line max-len
                "When working outside the corporate location, make sure to update your current address in the Emergency service section. Not adding your current address may delay emergency services in locating you.",
                warningLinkText: "See help section",
                readNotification: "I have read the notification."
            };
        }
        static get styles() {
            return _EmergencyNotificationContent_scss__WEBPACK_IMPORTED_MODULE_3__["default"];
        }
        firstUpdated() {
            var _a, _b;
            return __awaiter(this, void 0, void 0, function* () {
                const link = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector("md-link");
                if (link) {
                    yield link.updateComplete;
                    const linkAnchor = (_b = link.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector("a");
                    linkAnchor === null || linkAnchor === void 0 ? void 0 : linkAnchor.focus();
                }
            });
        }
        handleCheckboxChange(event) {
            const checkbox = event.target;
            const isRead = checkbox.checked;
            this.dispatchEvent(new CustomEvent("read-notification-change", { bubbles: true, composed: true, detail: { isRead } }));
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
        <div class="emergency-notification-container">
          <div class="emergency-notification-content">
            <md-alert-banner class="md-alert-banner-wrapper" show type="warning">
              <div class="emergency-modal-warning-content">
                <md-icon aria-hidden="true" name="warning-badge-filled" size="16" iconSet="momentumDesign"></md-icon>
                <div class="emergency-modal-warning-text" aria-label="${this.t.warningMessage}">
                  ${this.t.warningMessage}
                  <md-link
                    inline
                    class="help-section-link"
                    aria-label=${this.t.warningLinkText}
                    tag="a"
                    href=${this.warningLinkUrl}
                    target="_blank"
                    >${this.t.warningLinkText}</md-link
                  >
                </div>
              </div>
            </md-alert-banner>
          </div>
          <div class="emergency-notification-content">
            <div class="heading">${this.t.notificationTitle}</div>
            <label>${this.t.notificationContent}</label>
          </div>
          <md-checkbox
            id="readNotificationCheckbox"
            slot="checkbox"
            class="read-the-notification"
            @checkbox-change=${this.handleCheckboxChange}
          >
            ${this.t.readNotification}
          </md-checkbox>
        </div>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: String })
    ], Element.prototype, "warningLinkUrl", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Object })
    ], Element.prototype, "localization", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.internalProperty)()
    ], Element.prototype, "t", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.customElement)("uuip-wc-emergency-notification-content")
    ], Element);
    EmergencyNotificationContent.Element = Element;
})(EmergencyNotificationContent || (EmergencyNotificationContent = {}));


/***/ }),

/***/ "./src/components/EmptyState/EmptyState.scss":
/*!***************************************************!*\
  !*** ./src/components/EmptyState/EmptyState.scss ***!
  \***************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  /* Font family */
  --font-family: var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial, sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "CiscoSansTT Light", "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
}

:host {
  height: 100%;
  width: 100%;
  display: grid;
}

.empty-state {
  align-items: center;
  display: flex;
  justify-content: center;
  height: 100%;
  width: 100%;
  color: var(--md-secondary-text-color);
  background-color: var(--md-secondary-bg-color);
}
.empty-state__container {
  align-items: center;
  display: flex;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  font-size: var(--font-size-medium);
}
.empty-state__illustration {
  display: flex;
  width: 100%;
  height: auto;
}
/*# sourceURL=/home/jenkins/agent/workspace/cicd-jobs/wxcc-common-CI-Builder/packages/@uuip/unified-ui-platform-common-components/src/assets/styles/variables.scss */
/*# sourceURL=EmptyState.scss */
/*# sourceURL=/home/jenkins/agent/workspace/cicd-jobs/wxcc-common-CI-Builder/packages/@uuip/unified-ui-platform-common-components/src/components/EmptyState/EmptyState.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/EmptyState/EmptyState.ts":
/*!*************************************************!*\
  !*** ./src/components/EmptyState/EmptyState.ts ***!
  \*************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   EmptyState: () => (/* binding */ EmptyState)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _EmptyState_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./EmptyState.scss */ "./src/components/EmptyState/EmptyState.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


let EmptyState = class EmptyState extends lit_element__WEBPACK_IMPORTED_MODULE_0__.LitElement {
    constructor() {
        super(...arguments);
        this.illustrationName = "four_managers";
        this.illustrationAlt = "";
        this.illustrationSrc = "";
    }
    get imagePath() {
        if (this.illustrationSrc && this.illustrationSrc.trim().length !== 0) {
            return this.illustrationSrc.trim();
        }
        return __webpack_require__("./src/assets/images sync recursive ^\\.\\/.*\\.svg$")(`./${this.illustrationName}.svg`);
    }
    render() {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.html) `
      <div class="empty-state" part="container">
        <div class="empty-state__container">
          <img
            part="img"
            aria-hidden="true"
            src="${this.imagePath}"
            alt="${this.illustrationAlt}"
            class="empty-state__illustration"
          />
          <slot></slot>
        </div>
      </div>
    `;
    }
    static get styles() {
        return [_EmptyState_scss__WEBPACK_IMPORTED_MODULE_1__["default"]];
    }
};
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.property)({ type: String, attribute: "illustration-name" })
], EmptyState.prototype, "illustrationName", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.property)({ type: String, attribute: "illustration-alt" })
], EmptyState.prototype, "illustrationAlt", void 0);
__decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.property)({ type: String, attribute: "illustration-src" })
], EmptyState.prototype, "illustrationSrc", void 0);
EmptyState = __decorate([
    (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.customElement)("uuip-wc-empty-state")
], EmptyState);



/***/ }),

/***/ "./src/components/ErrorDetail/ErrorDetail.scss":
/*!*****************************************************!*\
  !*** ./src/components/ErrorDetail/ErrorDetail.scss ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  /* Font family */
  --font-family: var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial, sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "CiscoSansTT Light", "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
}

:host {
  --trackingid-detail-max-width: 405px;
  --toaster-icon-line-height: 24px;
  --details-hidden-height: 1px;
  --default-details-show-height: 120px;
  --toaster-details-show-height: 35px;
}

.error-details summary::-webkit-details-marker {
  display: none;
}

.error-details summary {
  list-style-type: none !important;
  cursor: pointer;
}

.trackingid-container {
  font-size: var(--font-size-small);
  color: var(--md-secondary-text-color, --color-gray-100);
}

.trackingid-description {
  margin-top: calc(var(--space-token-cardinal) * 2);
}

.error-details {
  max-width: var(--trackingid-detail-max-width);
}
.error-details.centered {
  display: flex;
  flex-direction: column;
  align-content: center;
  align-items: center;
  justify-content: center;
}
.error-details.centered md-icon[name=clear-bold] {
  display: none;
}
.error-details.centered .trackingid-summary {
  text-align: center;
  padding: 0 var(--space-token-cardinal);
}
.error-details.centered .trackingid-description {
  text-align: center;
  margin: calc(var(--space-token-even) * 8) 0;
  font-size: var(--font-size-small);
}

:host([format=toaster]) .error-details {
  margin: calc(var(--space-token-even) * 4) var(--space-token-cardinal) 0 var(--space-token-even);
}

.trackingid-summary {
  color: var(--md-alert-error-text-color, --color-error-text);
  display: inline-flex;
  align-items: center;
  gap: calc(var(--space-token-even) * 3);
}
.trackingid-summary .failed-details-link {
  text-decoration: underline;
  cursor: pointer;
}

.copy-trackingid-icon {
  cursor: pointer;
  padding-top: calc(var(--space-token-even) * 2);
}

.trackingid-error-details-wrap {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-top: calc(var(--space-token-cardinal) * 2);
  position: relative;
}
.trackingid-error-details-wrap .tracking-input-wrap {
  display: flex;
  min-width: 0;
}
.trackingid-error-details-wrap .tracking-input-wrap .trackingid-label {
  flex: 1 0 auto;
  padding-right: var(--space-token-cardinal);
  display: inline;
  align-self: center;
}
.trackingid-error-details-wrap .tracking-input-wrap .trackingid-input {
  display: inline;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 0 1 auto;
}
.trackingid-error-details-wrap.modal .tracking-input-wrap .trackingid-input {
  display: inline-block;
  padding: calc(var(--space-token-even) * 2) calc(var(--space-token-even) * 4);
  border: 1px solid var(--color-gray-border);
  box-sizing: border-box;
  border-radius: var(--border-radius-small);
}
.trackingid-error-details-wrap.toaster {
  align-items: center;
  margin-top: var(--space-token-even);
}
.trackingid-error-details-wrap.toaster .copy-trackingid-icon {
  padding: calc(var(--space-token-even) * 2) calc(var(--space-token-even) * 4);
  border-radius: 50%;
}
.trackingid-error-details-wrap.toaster .copy-trackingid-icon:hover {
  background: var(--md-tertiary-bg-color, --color-gray-10);
}
.trackingid-error-details-wrap.toaster md-icon::part(icon) {
  line-height: var(--toaster-icon-line-height);
}
.trackingid-error-details-wrap.default .tracking-input-wrap {
  margin-top: var(--space-token-cardinal);
}

.error-details-link {
  width: fit-content;
  list-style-type: none !important;
  cursor: pointer;
  color: var(--md-alert-info-text-color, --color-blue-70);
  text-decoration: underline;
  margin-bottom: var(--space-token-even);
}

.error-details[open] .trackingid-container {
  animation: show 0.5s;
  height: var(--default-details-show-height);
}
.error-details[open] .trackingid-container.toaster {
  height: var(--toaster-details-show-height);
}
.error-details[open] .trackingid-container.default .error-details[open] .trackingid-container.modal {
  display: block;
  animation: show 1s;
}

.error-details:not([open]) .trackingid-container {
  animation: hide 0.5s;
  height: var(--details-hidden-height);
}
.error-details:not([open]) .trackingid-container.modal {
  display: block;
  animation: hide 1s;
}

@keyframes show {
  0% {
    opacity: 0;
    height: var(--details-hidden-height);
  }
  100% {
    opacity: 1;
  }
}
@keyframes hide {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    height: var(--details-hidden-height);
  }
}
.copy-button-container {
  margin-left: calc(var(--space-token-cardinal) * 2);
  align-self: center;
  transition: opacity 250ms linear;
}
/*# sourceURL=/home/jenkins/agent/workspace/cicd-jobs/wxcc-common-CI-Builder/packages/@uuip/unified-ui-platform-common-components/src/assets/styles/variables.scss */
/*# sourceURL=ErrorDetail.scss */
/*# sourceURL=/home/jenkins/agent/workspace/cicd-jobs/wxcc-common-CI-Builder/packages/@uuip/unified-ui-platform-common-components/src/components/ErrorDetail/ErrorDetail.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/ErrorDetail/ErrorDetail.ts":
/*!***************************************************!*\
  !*** ./src/components/ErrorDetail/ErrorDetail.ts ***!
  \***************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ErrorDetail: () => (/* binding */ ErrorDetail)
/* harmony export */ });
/* harmony import */ var _mixins_i18n__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18n */ "./src/mixins/i18n.ts");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lit-html/directives/class-map */ "lit-html/directives/class-map");
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _ErrorDetail_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./ErrorDetail.scss */ "./src/components/ErrorDetail/ErrorDetail.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};






var ErrorDetail;
(function (ErrorDetail) {
    const COPY_TIMEOUT = 1000;
    let Element = class Element extends (0,_mixins_i18n__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_2__.LitElement) {
        constructor() {
            super(...arguments);
            this.show = false;
            this.isCopied = false;
            this.header = "";
            this.message = "";
            this.trackingId = "";
            this.localization = {};
            this.t = {
                errorLessButtonText: "Show Less",
                errorMoreButtonText: "Show More",
                errorDetailsText: "Error Details",
                trackingIdTitleText: "Copy trackingId",
                trackingIdDescriptionText: "Please share the Tracking ID with your administrator to investigate the issue.",
                trackingIdLabelText: "Tracking ID",
                copyText: "Copy",
                copiedText: "Copied"
            };
            this.handleDetailToggle = () => {
                var _a;
                this.show = (_a = this.details) === null || _a === void 0 ? void 0 : _a.open;
                this.isCopied = false;
            };
        }
        firstUpdated(changedProperties) {
            super.firstUpdated(changedProperties);
            if (this.details) {
                this.details.addEventListener("toggle", this.handleDetailToggle);
                this.details.open = this.show;
            }
        }
        disconnectedCallback() {
            super.disconnectedCallback();
            this.details.removeEventListener("toggle", this.handleDetailToggle);
        }
        copyTrackingId() {
            const text = this.trackID.innerText;
            const input_temp = document.createElement("input");
            input_temp.value = text;
            document.body.appendChild(input_temp);
            input_temp.select();
            document.execCommand("copy");
            document.body.removeChild(input_temp);
            this.isCopied = true;
            setTimeout(() => {
                this.isCopied = false;
            }, COPY_TIMEOUT);
        }
        static get styles() {
            return [_ErrorDetail_scss__WEBPACK_IMPORTED_MODULE_5__["default"]];
        }
        renderSummary() {
            if (this.format === "toaster" || this.format === "default") {
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
          <summary role="button" class="trackingid-summary" tabindex="0">
            <md-icon
              aria-hidden="true"
              name="clear-bold"
              size="14"
              iconSet="momentumDesign"
              title="failed icon"
            ></md-icon>
            <span class="failed-details-text">${this.header}</span>
            <span part="error-more-btn" class="failed-details-link">
              ${this.show ? this.t.errorLessButtonText : this.t.errorMoreButtonText}
            </span>
          </summary>
        `;
            }
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
        <summary class="trackingid-summary error-details-link" tabindex="0">${this.t.errorDetailsText}</summary>
      `;
        }
        renderDescription() {
            if (this.format !== "toaster") {
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) ` <div class="trackingid-description">${this.t.trackingIdDescriptionText}</div> `;
            }
            return lit_html__WEBPACK_IMPORTED_MODULE_3__.nothing;
        }
        renderCopyButtonIcon() {
            const size = this.format === "modal" ? "14" : "12";
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
        <md-icon
          name=${this.isCopied ? "check-regular" : "copy-regular"}
          size="${size}"
          iconSet="momentumDesign"
        ></md-icon>
      `;
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
        <details
          class="${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_4__.classMap)({
                "error-details": true,
                centered: this.format === "default" || this.format === undefined
            })}"
        >
          ${this.renderSummary()}

          <div
            class="${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_4__.classMap)({
                "trackingid-container": true,
                [`${this.format}`]: true
            })}"
          >
            ${this.renderDescription()}

            <div
              class="${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_4__.classMap)({
                "trackingid-error-details-wrap": true,
                [`${this.format}`]: true
            })}"
            >
              <div class="tracking-input-wrap">
                <label class="trackingid-label">${this.t.trackingIdLabelText}:</label>
                <div id="trackingid-input" class="trackingid-input">${this.trackingId}</div>
              </div>
              <span class="copy-button-container">
                <md-tooltip placement="top" message="${!this.isCopied ? this.t.copyText : this.t.copiedText}">
                  <md-button
                    id="copy-trackingid-icon"
                    class="copy-tracking-icon"
                    circle
                    @click=${() => this.copyTrackingId()}
                    ariaLabel=${this.isCopied ? this.t.copiedText : this.t.copyText}
                    ariaLive="assertive"
                    variant="${this.isCopied ? "green" : "white"}"
                  >
                    ${this.renderCopyButtonIcon()}
                  </md-button>
                </md-tooltip>
              </span>
            </div>
          </div>
        </details>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: String })
    ], Element.prototype, "format", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Boolean })
    ], Element.prototype, "show", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Boolean })
    ], Element.prototype, "isCopied", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: String })
    ], Element.prototype, "header", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: String })
    ], Element.prototype, "message", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: String })
    ], Element.prototype, "trackingId", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Object })
    ], Element.prototype, "localization", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.internalProperty)()
    ], Element.prototype, "t", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.query)(".error-details")
    ], Element.prototype, "details", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.query)(".trackingid-input")
    ], Element.prototype, "trackID", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.customElement)("uuip-wc-error-detail")
    ], Element);
    ErrorDetail.Element = Element;
})(ErrorDetail || (ErrorDetail = {}));


/***/ }),

/***/ "./src/components/ErrorModal/ErrorModal.scss":
/*!***************************************************!*\
  !*** ./src/components/ErrorModal/ErrorModal.scss ***!
  \***************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  /* Font family */
  --font-family: var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial, sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "CiscoSansTT Light", "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
}

:host {
  --z-index-negative: -1;
  --z-index-base: 0;
  --z-overflow-scroll-button: 1;
  --z-index-expand-collapse: 2;
  --z-index-maximize-block: 3;
  --z-navigation-bar: 5;
  --z-index-task-list: 6;
  --z-index-task-collapse-area: 7;
  --z-index-wrap-up: 7;
  --z-index-menu-overlay: 8;
  --z-index-dynamic-area-overflow: 9;
  --z-index-notification: 1041;
  --z-index-sticky-header: 11;
  --z-index-popover: 1030;
  --z-index-modal: 1040;
  --z-index-full-overlay: 1050;
  --z-index-app-full-overlay: 1060;
  --z-index-modal-error: 1100;
  --z-index-connection-lost: 1150;
}

:host {
  position: absolute;
  z-index: var(--z-index-modal-error, 1100);
}

:focus {
  box-shadow: var(--box-shadow);
  outline: none;
  border-radius: 1.125rem;
}

.error-modal-footer {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

h2.modal-header {
  margin-block-start: 0;
  margin-block-end: 0;
}

.modal-body {
  color: var(--md-secondary-text-color);
  margin-top: calc(var(--space-token-cardinal) * 2);
  overflow: hidden;
}

md-modal::part(modal-body) {
  overflow: hidden;
}

.btn-ok {
  margin-bottom: var(--space-token-even);
}

.footer-btn {
  margin-left: 0.75rem;
}

@media screen and (max-height: 550px) {
  md-modal::part(modal-container) {
    top: 5%;
    max-height: calc(100vh - 5%);
  }
  md-modal::part(modal-content) {
    max-height: 100vh;
    overflow-y: auto;
  }
}
/*# sourceURL=/home/jenkins/agent/workspace/cicd-jobs/wxcc-common-CI-Builder/packages/@uuip/unified-ui-platform-common-components/src/assets/styles/variables.scss */
/*# sourceURL=ErrorModal.scss */
/*# sourceURL=/home/jenkins/agent/workspace/cicd-jobs/wxcc-common-CI-Builder/packages/@uuip/unified-ui-platform-common-components/src/assets/styles/z-index.scss */
/*# sourceURL=/home/jenkins/agent/workspace/cicd-jobs/wxcc-common-CI-Builder/packages/@uuip/unified-ui-platform-common-components/src/components/ErrorModal/ErrorModal.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/ErrorModal/ErrorModal.ts":
/*!*************************************************!*\
  !*** ./src/components/ErrorModal/ErrorModal.ts ***!
  \*************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ErrorModal: () => (/* binding */ ErrorModal)
/* harmony export */ });
/* harmony import */ var _components_ErrorDetail_ErrorDetail__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../components/ErrorDetail/ErrorDetail */ "./src/components/ErrorDetail/ErrorDetail.ts");
/* harmony import */ var _mixins_i18n__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/mixins/i18n */ "./src/mixins/i18n.ts");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _ErrorModal_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./ErrorModal.scss */ "./src/components/ErrorModal/ErrorModal.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};







var ErrorModal;
(function (ErrorModal) {
    let Element = class Element extends (0,_mixins_i18n__WEBPACK_IMPORTED_MODULE_1__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_4__.LitElement) {
        constructor() {
            super(...arguments);
            this.isModalOpen = false;
            this.detail = null;
            this.localization = {};
            this.t = {
                okButtonText: "OK",
                headerText: "Error",
                errorActionsText: "Please try again."
            };
            this.defaultOkMap = {
                type: "ok",
                label: this.t.okButtonText,
                onClick: () => {
                    _sdk__WEBPACK_IMPORTED_MODULE_2__.logger.info("[ErrorModal] Default error callback");
                }
            };
            this.okBtnMap = this.defaultOkMap;
        }
        get headerText() {
            var _a;
            return ((_a = this.detail) === null || _a === void 0 ? void 0 : _a.header) ? this.detail.header : this.t.headerText;
        }
        updated(changedProperties) {
            super.updated(changedProperties);
            changedProperties.forEach((oldValue, name) => {
                var _a, _b, _c, _d;
                if (name === "detail" && this.detail) {
                    this.okBtnMap = ((_a = this.detail.buttons) === null || _a === void 0 ? void 0 : _a.find((obj) => obj.type === "ok")) || this.defaultOkMap;
                }
                if (name === "isModalOpen") {
                    if (this.footerButton) {
                        const footerBtn = (_d = (_c = (_b = this.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector("md-button")) === null || _c === void 0 ? void 0 : _c.shadowRoot) === null || _d === void 0 ? void 0 : _d.querySelector("button");
                        setTimeout(() => footerBtn === null || footerBtn === void 0 ? void 0 : footerBtn.focus());
                    }
                }
            });
        }
        evt(name, detail) {
            this.dispatchEvent(new CustomEvent(name, { bubbles: true, composed: true, detail }));
            _sdk__WEBPACK_IMPORTED_MODULE_2__.logger.info("[ErrorModal] Dispatching", name, detail);
        }
        okHandler() {
            this.dispatchEvent(new CustomEvent("close-error", {
                composed: true,
                bubbles: true
            }));
            this.okBtnMap.onClick();
        }
        static get styles() {
            return [_ErrorModal_scss__WEBPACK_IMPORTED_MODULE_6__["default"]];
        }
        btnClickHandler(btn) {
            this.handleCloseModal();
            btn.onClick();
        }
        handleCloseModal() {
            this.isModalOpen = false;
            this.evt("errorModal-show", false);
            this.requestUpdate("isModalOpen");
        }
        renderButton(btn) {
            if (btn.color) {
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
          <md-button
            ariaLabel=${btn.label}
            class="footer-btn"
            color="${btn.color}"
            @click=${() => this.btnClickHandler(btn)}
            >${btn.label}
          </md-button>
        `;
            }
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
        <md-button
          ariaLabel=${btn.label}
          class="footer-btn"
          variant=${btn.variant ? btn.variant : "primary"}
          @click=${() => this.btnClickHandler(btn)}
          >${btn.label}
        </md-button>
      `;
        }
        renterCustomFooterButton(buttons) {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) ` ${buttons.map((btn) => this.renderButton(btn))} `;
        }
        renderModalFooter() {
            var _a, _b;
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
        <div slot="footer" class="error-modal-footer">
          ${((_a = this.detail) === null || _a === void 0 ? void 0 : _a.buttons)
                ? this.renterCustomFooterButton((_b = this.detail) === null || _b === void 0 ? void 0 : _b.buttons)
                : this.renderButton({ type: "button", label: this.t.okButtonText, onClick: this.okHandler.bind(this) })}
        </div>
      `;
        }
        renderErrorDetail() {
            var _a;
            if ((_a = this.detail) === null || _a === void 0 ? void 0 : _a.trackingId) {
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
          <uuip-wc-error-detail
            format="modal"
            .header="${this.detail.header ? this.detail.header : ""}"
            .trackingId="${this.detail.trackingId}"
            .message="${""}"
            .localization="${this.detail.localization ? this.detail.localization : {}}"
          ></uuip-wc-error-detail>
        `;
            }
            return lit_html__WEBPACK_IMPORTED_MODULE_5__.nothing;
        }
        render() {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
        <md-modal
          .show=${this.isModalOpen}
          size=${((_a = this.detail) === null || _a === void 0 ? void 0 : _a.modalType) ? (_b = this.detail) === null || _b === void 0 ? void 0 : _b.modalType : "dialog"}
          .hideFooter=${true}
          .headerLabel=${this.headerText}
          tabindex="0"
          aria-label=${this.headerText}
          ?showCloseButton=${!!((_c = this.detail) === null || _c === void 0 ? void 0 : _c.showCloseButton)}
          ?backdropClickExit=${!!((_d = this.detail) === null || _d === void 0 ? void 0 : _d.backdropClickExit)}
          ?noExitOnEsc=${!!((_e = this.detail) === null || _e === void 0 ? void 0 : _e.noExitOnEsc)}
          @close-modal=${() => this.handleCloseModal()}
          ariaDescription="modal-body"
        >
          <div class="modal-body">
            <span>
              ${((_f = this.detail) === null || _f === void 0 ? void 0 : _f.message)
                ? this.detail.message
                : ((_g = this.detail) === null || _g === void 0 ? void 0 : _g.htmlMessage)
                    ? (_h = this.detail) === null || _h === void 0 ? void 0 : _h.htmlMessage
                    : this.t.errorActionsText}
            </span>
          </div>
          ${this.renderErrorDetail()} ${this.renderModalFooter()}
        </md-modal>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: Boolean })
    ], Element.prototype, "isModalOpen", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: Object })
    ], Element.prototype, "detail", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: Object })
    ], Element.prototype, "localization", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.internalProperty)()
    ], Element.prototype, "t", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.query)(".footer-btn")
    ], Element.prototype, "footerButton", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.customElement)("uuip-wc-error-modal")
    ], Element);
    ErrorModal.Element = Element;
})(ErrorModal || (ErrorModal = {}));


/***/ }),

/***/ "./src/components/MaximizeArea/MaximizeAreaBlock.scss":
/*!************************************************************!*\
  !*** ./src/components/MaximizeArea/MaximizeAreaBlock.scss ***!
  \************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  --z-index-negative: -1;
  --z-index-base: 0;
  --z-overflow-scroll-button: 1;
  --z-index-expand-collapse: 2;
  --z-index-maximize-block: 3;
  --z-navigation-bar: 5;
  --z-index-task-list: 6;
  --z-index-task-collapse-area: 7;
  --z-index-wrap-up: 7;
  --z-index-menu-overlay: 8;
  --z-index-dynamic-area-overflow: 9;
  --z-index-notification: 1041;
  --z-index-sticky-header: 11;
  --z-index-popover: 1030;
  --z-index-modal: 1040;
  --z-index-full-overlay: 1050;
  --z-index-app-full-overlay: 1060;
  --z-index-modal-error: 1100;
  --z-index-connection-lost: 1150;
}

:host {
  --maximize-block-controls-height: 50px;
  --maximize-block-transition-type: 300ms ease-in-out;
  --maximize-block-transition-type-quick: 100ms linear;
  --maximize-block-background-color: var(--md-primary-bg-color);
  --maximize-block-controls-padding: 10px;
  --border: 1px solid var(--md-primary-seperator-color);
  will-change: width, height, transform;
  transform: translate3d(0, 0, 0);
  background-color: var(--maximize-block-background-color);
  transition: all 0.3s var(--maximize-block-transition-type-quick);
  transition-property: border-color, box-shadow;
  display: block;
  height: 100%;
  width: 100%;
  border: var(--border);
  border-color: transparent;
}
:host .maximize-controls {
  border-bottom: var(--border);
  height: var(--maximize-block-controls-height);
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
}
:host .maximize-controls-title {
  max-width: calc(100% - var(--maximize-block-controls-height));
  padding-right: var(--maximize-block-controls-padding)/2;
  width: calc(100% - var(--maximize-block-controls-height));
}
:host .maximize-controls-buttons {
  padding-left: var(--maximize-block-controls-padding)/2;
  padding-right: var(--maximize-block-controls-padding);
}
:host .maximize-controls-buttons md-button::part(button) {
  background: var(--md-primary-bg-color);
}
:host .maximize-content {
  height: calc(100% - var(--maximize-block-controls-height));
  width: 100%;
}

:host([maximize]) {
  position: fixed;
  z-index: var(--z-index-maximize-block, 2);
}

:host([toggling]) {
  transition: all var(--maximize-block-transition-type);
  pointer-events: none;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  border: var(--border);
}
/*# sourceURL=/home/jenkins/agent/workspace/cicd-jobs/wxcc-common-CI-Builder/packages/@uuip/unified-ui-platform-common-components/src/assets/styles/z-index.scss */
/*# sourceURL=MaximizeAreaBlock.scss */
/*# sourceURL=/home/jenkins/agent/workspace/cicd-jobs/wxcc-common-CI-Builder/packages/@uuip/unified-ui-platform-common-components/src/components/MaximizeArea/MaximizeAreaBlock.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/MaximizeArea/MaximizeAreaBlock.ts":
/*!**********************************************************!*\
  !*** ./src/components/MaximizeArea/MaximizeAreaBlock.ts ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   MaximizeAreaBlock: () => (/* binding */ MaximizeAreaBlock)
/* harmony export */ });
/* harmony import */ var _components_MaximizeArea_MaximizeAreaHost__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../components/MaximizeArea/MaximizeAreaHost */ "./src/components/MaximizeArea/MaximizeAreaHost.ts");
/* harmony import */ var _mixins_i18n__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/mixins/i18n */ "./src/mixins/i18n.ts");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @/utils/helpers */ "./src/utils/helpers.ts");
/* harmony import */ var _utils_WindowListenersHub__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @/utils/WindowListenersHub */ "./src/utils/WindowListenersHub.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _MaximizeAreaBlock_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./MaximizeAreaBlock.scss */ "./src/components/MaximizeArea/MaximizeAreaBlock.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};







var MaximizeAreaBlock;
(function (MaximizeAreaBlock) {
    MaximizeAreaBlock.TRANSITION_FAILED_TIMEOUT = 2000; //ms
    const FPS_TIMEOUT = 1000 / 60;
    // Block <=> Host communication events
    let AuxEvents;
    (function (AuxEvents) {
        AuxEvents["ToggleRequest"] = "toggle-maximizing-block-request";
        AuxEvents["DisconnectRequest"] = "disconnect-maximizing-block-request";
        AuxEvents["MaximizeStart"] = "maximizing-block-start-request";
        AuxEvents["MaximizeEnd"] = "maximizing-block-end-request";
        AuxEvents["MinimizeStart"] = "minimizing-block-start-request";
        AuxEvents["MinimizeEnd"] = "minimizing-block-end-request";
    })(AuxEvents = MaximizeAreaBlock.AuxEvents || (MaximizeAreaBlock.AuxEvents = {}));
    let counter = 0;
    /**
     * @element uuip-wc-maximize-area-block
     */
    let Element = class Element extends (0,_mixins_i18n__WEBPACK_IMPORTED_MODULE_1__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_5__.LitElement) {
        constructor() {
            super(...arguments);
            this.localization = {};
            this.t = {
                maximizeText: "Maximize",
                minimizeText: "Minimize"
            };
            this.isMaximized = false;
            this.onMaximizeAreaResponse = (e) => {
                const { areaName, blockName, rect } = e.detail;
                if (areaName && blockName && this.maximizeToAreaName === areaName && this.blockName === blockName) {
                    const selfRect = this.getBoundingClientRect();
                    Promise.resolve()
                        .then(() => {
                        // Aux hub start
                        this.dispatchAnimationState(AuxEvents.MaximizeStart, { areaName, blockName });
                    })
                        .then(() => {
                        // Setup as Fixed
                        this.setAttribute("maximize", "");
                        // Positioning on self initial coords
                        this.style.cssText = (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.unsafeCSS)(`
              top: ${selfRect.top}px;
              left: ${selfRect.left}px;
              width: ${selfRect.width}px;
              height: ${selfRect.height}px;
            `).cssText;
                    })
                        // delay for styles apply
                        .then(() => (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_3__.createTimeoutPromise)(FPS_TIMEOUT))
                        // Setup transition type
                        .then(() => {
                        this.setAttribute("toggling", "");
                    })
                        // delay for styles apply
                        .then(() => (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_3__.createTimeoutPromise)(FPS_TIMEOUT))
                        // Setup animation to host area coords
                        .then(() => {
                        this.style.cssText = (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.unsafeCSS)(`
              top: ${selfRect.top}px;
              left: ${selfRect.left}px;
              /**/
              transform: translate3d(${rect.left - selfRect.left}px, ${rect.top - selfRect.top}px, 0);
              width: ${rect.width}px;
              height: ${rect.height}px;
            `).cssText;
                    })
                        // awaiting transition end event
                        .then(() => (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_3__.createElementTransitionEndPromise)(this, "transform", MaximizeAreaBlock.TRANSITION_FAILED_TIMEOUT))
                        // delay for styles apply
                        .then(() => (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_3__.createTimeoutPromise)(FPS_TIMEOUT))
                        // Hold on host area coords
                        .then(() => {
                        const bodyRect = document.body.getBoundingClientRect();
                        this.removeAttribute("toggling");
                        this.style.cssText = (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.unsafeCSS)(`
              top: ${rect.top}px;
              left: ${rect.left}px;
              width: auto;
              height: auto;
              bottom: ${bodyRect.bottom - rect.bottom}px;
              right: ${bodyRect.right - rect.right}px;
            `).cssText;
                    })
                        // delay for styles apply
                        .then(() => (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_3__.createTimeoutPromise)(FPS_TIMEOUT))
                        .then(() => {
                        this.isMaximized = true;
                    })
                        .then(() => {
                        // Aux hub end
                        this.dispatchAnimationState(AuxEvents.MaximizeEnd, { areaName, blockName });
                    });
                }
            };
            this.onMinimizeAreaResponse = (e) => {
                var _a;
                const { areaName, blockName, rect } = e.detail;
                if (areaName && blockName && this.maximizeToAreaName === areaName && this.blockName === blockName) {
                    const parentRect = (_a = this.parentElement) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
                    if (parentRect) {
                        Promise.resolve()
                            .then(() => {
                            // Aux hub start
                            this.dispatchAnimationState(AuxEvents.MinimizeStart, { areaName, blockName });
                        })
                            .then(() => {
                            // Positioning on host area coords (fixed when maximized)
                            this.style.cssText = (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.unsafeCSS)(`
                top: ${rect.top}px;
                left: ${rect.left}px;
                width: ${rect.width}px;
                height: ${rect.height}px;
              `).cssText;
                        })
                            // delay for styles apply
                            .then(() => (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_3__.createTimeoutPromise)(FPS_TIMEOUT))
                            // Setup transition type
                            .then(() => {
                            this.setAttribute("toggling", "");
                        })
                            // delay for styles apply
                            .then(() => (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_3__.createTimeoutPromise)(FPS_TIMEOUT))
                            // Setup animation to self coords (by parent)
                            .then(() => {
                            this.style.cssText = (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.unsafeCSS)(`
                top: ${rect.top}px;
                left: ${rect.left}px;
                /**/
                transform: translate3d(${parentRect.left - rect.left}px, ${parentRect.top - rect.top}px, 0);
                width: ${parentRect.width}px;
                height: ${parentRect.height}px;
              `).cssText;
                        })
                            // awaiting transition end event
                            .then(() => (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_3__.createElementTransitionEndPromise)(this, "transform", MaximizeAreaBlock.TRANSITION_FAILED_TIMEOUT))
                            // delay for styles apply
                            .then(() => (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_3__.createTimeoutPromise)(FPS_TIMEOUT))
                            // Cleanup to self coords
                            .then(() => {
                            this.removeAttribute("toggling");
                            this.style.cssText = (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.css) ``.cssText;
                            this.removeAttribute("maximize");
                        })
                            // delay for styles apply
                            .then(() => (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_3__.createTimeoutPromise)(FPS_TIMEOUT))
                            .then(() => {
                            this.isMaximized = false;
                        })
                            .then(() => {
                            // Aux hub end
                            this.dispatchAnimationState(AuxEvents.MinimizeEnd, { areaName, blockName });
                        });
                    }
                }
            };
            this.onResizeAreaResponse = (e) => {
                const { areaName, blockName, rect } = e.detail;
                if (this.isMaximized &&
                    areaName &&
                    blockName &&
                    this.maximizeToAreaName === areaName &&
                    this.blockName === blockName) {
                    const bodyRect = document.body.getBoundingClientRect();
                    this.style.cssText = (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.unsafeCSS)(`
          top: ${rect.top}px;
          left: ${rect.left}px;
          width: auto;
          height: auto;
          bottom: ${bodyRect.bottom - rect.bottom}px;
          right: ${bodyRect.right - rect.right}px;
        `).cssText;
                }
            };
        }
        connectedCallback() {
            super.connectedCallback();
            this.blockName = `maximize-block-${counter}`;
            counter++;
            _utils_WindowListenersHub__WEBPACK_IMPORTED_MODULE_4__.WINDOW_LISTENERS_HUB.on(_components_MaximizeArea_MaximizeAreaHost__WEBPACK_IMPORTED_MODULE_0__.MaximizeAreaHost.AuxEvents.MaximizeResponse, this.onMaximizeAreaResponse);
            _utils_WindowListenersHub__WEBPACK_IMPORTED_MODULE_4__.WINDOW_LISTENERS_HUB.on(_components_MaximizeArea_MaximizeAreaHost__WEBPACK_IMPORTED_MODULE_0__.MaximizeAreaHost.AuxEvents.MinimizeResponse, this.onMinimizeAreaResponse);
            _utils_WindowListenersHub__WEBPACK_IMPORTED_MODULE_4__.WINDOW_LISTENERS_HUB.on(_components_MaximizeArea_MaximizeAreaHost__WEBPACK_IMPORTED_MODULE_0__.MaximizeAreaHost.AuxEvents.ResizeResponse, this.onResizeAreaResponse);
        }
        disconnectedCallback() {
            super.disconnectedCallback();
            this.dispatchDisconnectRequest();
            _utils_WindowListenersHub__WEBPACK_IMPORTED_MODULE_4__.WINDOW_LISTENERS_HUB.off(_components_MaximizeArea_MaximizeAreaHost__WEBPACK_IMPORTED_MODULE_0__.MaximizeAreaHost.AuxEvents.MaximizeResponse, this.onMaximizeAreaResponse);
            _utils_WindowListenersHub__WEBPACK_IMPORTED_MODULE_4__.WINDOW_LISTENERS_HUB.off(_components_MaximizeArea_MaximizeAreaHost__WEBPACK_IMPORTED_MODULE_0__.MaximizeAreaHost.AuxEvents.MinimizeResponse, this.onMinimizeAreaResponse);
            _utils_WindowListenersHub__WEBPACK_IMPORTED_MODULE_4__.WINDOW_LISTENERS_HUB.off(_components_MaximizeArea_MaximizeAreaHost__WEBPACK_IMPORTED_MODULE_0__.MaximizeAreaHost.AuxEvents.ResizeResponse, this.onResizeAreaResponse);
        }
        updated(changedProperties) {
            super.updated(changedProperties);
            changedProperties.forEach((oldValue, name) => {
                if (name === "blockName" && this.blockName) {
                    this.setAttribute("block-name", this.blockName);
                }
            });
        }
        static get styles() {
            return _MaximizeAreaBlock_scss__WEBPACK_IMPORTED_MODULE_6__["default"];
        }
        dispatchAuxHubUpdate(eventName, { areaName, blockName }) {
            _utils_WindowListenersHub__WEBPACK_IMPORTED_MODULE_4__.WINDOW_LISTENERS_HUB.dispatch(new CustomEvent(eventName, {
                detail: {
                    areaName,
                    blockName
                }
            }));
        }
        dispatchToggleRequest() {
            if (this.maximizeToAreaName && this.blockName) {
                this.dispatchAuxHubUpdate(AuxEvents.ToggleRequest, {
                    areaName: this.maximizeToAreaName,
                    blockName: this.blockName
                });
                const event = new CustomEvent("toggle-maximized-event", {
                    detail: {
                        isMaximized: this.isMaximized
                    }
                });
                window.dispatchEvent(event);
            }
            else {
                _sdk__WEBPACK_IMPORTED_MODULE_2__.logger.error(`[MaximizeAreaBlock] Maximizing/Minimizing Area or Block name is not defined...`);
            }
        }
        dispatchDisconnectRequest() {
            if (this.maximizeToAreaName && this.blockName) {
                this.dispatchAuxHubUpdate(AuxEvents.DisconnectRequest, {
                    areaName: this.maximizeToAreaName,
                    blockName: this.blockName
                });
            }
            else {
                _sdk__WEBPACK_IMPORTED_MODULE_2__.logger.error(`[MaximizeAreaBlock] Maximizing/Minimizing Area or Block name is not defined...`);
            }
        }
        dispatchAnimationState(eventName, { areaName, blockName }) {
            this.dispatchAuxHubUpdate(eventName, { areaName, blockName });
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
        <section class="maximize-controls">
          <section class="maximize-controls-title">
            <slot name="title"></slot>
          </section>
          <section class="maximize-controls-buttons">
            <md-button
              @click="${() => this.dispatchToggleRequest()}"
              variant="secondary"
              circle
              ariaLabel="${this.isMaximized ? this.t.minimizeText : this.t.maximizeText}"
            >
              <md-icon name="${this.isMaximized ? "minimize-regular" : "maximize-regular"}" size="20" iconSet="momentumDesign"></md-icon>
            </md-button>
          </section>
        </section>
        <section class="maximize-content">
          <slot></slot>
        </section>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: String })
    ], Element.prototype, "maximizeToAreaName", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Object })
    ], Element.prototype, "localization", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "t", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "blockName", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "isMaximized", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.customElement)("uuip-wc-maximize-area-block")
    ], Element);
    MaximizeAreaBlock.Element = Element;
})(MaximizeAreaBlock || (MaximizeAreaBlock = {}));


/***/ }),

/***/ "./src/components/MaximizeArea/MaximizeAreaHost.scss":
/*!***********************************************************!*\
  !*** ./src/components/MaximizeArea/MaximizeAreaHost.scss ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  --z-index-negative: -1;
  --z-index-base: 0;
  --z-overflow-scroll-button: 1;
  --z-index-expand-collapse: 2;
  --z-index-maximize-block: 3;
  --z-navigation-bar: 5;
  --z-index-task-list: 6;
  --z-index-task-collapse-area: 7;
  --z-index-wrap-up: 7;
  --z-index-menu-overlay: 8;
  --z-index-dynamic-area-overflow: 9;
  --z-index-notification: 1041;
  --z-index-sticky-header: 11;
  --z-index-popover: 1030;
  --z-index-modal: 1040;
  --z-index-full-overlay: 1050;
  --z-index-app-full-overlay: 1060;
  --z-index-modal-error: 1100;
  --z-index-connection-lost: 1150;
}

:host {
  display: block;
  visibility: hidden;
  position: fixed;
  z-index: var(--z-index-negative, -1);
}

:host([resizeanimate]) {
  transform: translate3d(0, 0, 0);
  will-change: left, right, top, bottom, width, height;
  transition-timing-function: ease-in-out;
  transition-duration: 350ms;
  transition-property: left, right, top, bottom, width, height;
}
/*# sourceURL=/home/jenkins/agent/workspace/cicd-jobs/wxcc-common-CI-Builder/packages/@uuip/unified-ui-platform-common-components/src/assets/styles/z-index.scss */
/*# sourceURL=MaximizeAreaHost.scss */
/*# sourceURL=/home/jenkins/agent/workspace/cicd-jobs/wxcc-common-CI-Builder/packages/@uuip/unified-ui-platform-common-components/src/components/MaximizeArea/MaximizeAreaHost.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/MaximizeArea/MaximizeAreaHost.ts":
/*!*********************************************************!*\
  !*** ./src/components/MaximizeArea/MaximizeAreaHost.ts ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   MaximizeAreaHost: () => (/* binding */ MaximizeAreaHost)
/* harmony export */ });
/* harmony import */ var _components_MaximizeArea_MaximizeAreaBlock__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../components/MaximizeArea/MaximizeAreaBlock */ "./src/components/MaximizeArea/MaximizeAreaBlock.ts");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @/utils/helpers */ "./src/utils/helpers.ts");
/* harmony import */ var _utils_WindowListenersHub__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @/utils/WindowListenersHub */ "./src/utils/WindowListenersHub.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _MaximizeAreaHost_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./MaximizeAreaHost.scss */ "./src/components/MaximizeArea/MaximizeAreaHost.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};







var MaximizeAreaHost;
(function (MaximizeAreaHost) {
    // Host <=> Block communication events
    let AuxEvents;
    (function (AuxEvents) {
        AuxEvents["MaximizeResponse"] = "maximize-host-response";
        AuxEvents["MinimizeResponse"] = "minimize-host-response";
        AuxEvents["ResizeResponse"] = "resize-host-response";
    })(AuxEvents = MaximizeAreaHost.AuxEvents || (MaximizeAreaHost.AuxEvents = {}));
    // Host outer events
    let Events;
    (function (Events) {
        Events["MaximizeTransitionStart"] = "maximize-transition-start";
        Events["MaximizeTransitionEnd"] = "maximize-transition-end";
        Events["MinimizeTransitionStart"] = "minimize-transition-start";
        Events["MinimizeTransitionEnd"] = "minimize-transition-end";
        Events["Resized"] = "resized";
    })(Events = MaximizeAreaHost.Events || (MaximizeAreaHost.Events = {}));
    const areasMap = new Map();
    /**
     * @element uuip-wc-maximize-area-host
     *
     * @fires maximize-transition-start
     * @fires maximize-transition-end
     * @fires minimize-transition-start
     * @fires minimize-transition-end
     *
     * @fires resized
     */
    let Element = class Element extends lit_element__WEBPACK_IMPORTED_MODULE_4__.LitElement {
        constructor() {
            super(...arguments);
            this.onToggleBlockRequest = (e) => this.toggleAreaResponse(e);
            this.onDisconnectBlockRequest = (e) => {
                const { areaName, blockName } = e.detail;
                if (this.areaName && this.areaName === areaName) {
                    if (blockName && this.currentMaximizedBlockName === blockName) {
                        this.currentMaximizedBlockName = undefined;
                    }
                }
            };
            this.onWindowResize = (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_2__.throttle)(() => {
                if (this.areaName && this.currentMaximizedBlockName) {
                    this.dispatchResized({ areaName: this.areaName, blockName: this.currentMaximizedBlockName });
                }
            });
            // Support resize area
            this.resizeObserver = new window.ResizeObserver(this.onWindowResize);
        }
        toggleAreaResponse(e) {
            const { areaName, blockName } = e.detail;
            if (this.areaName && this.areaName === areaName) {
                if (blockName) {
                    // No Blocks Maximized => maximizing blockName
                    if (!this.currentMaximizedBlockName) {
                        this.dispatchMaximized({ areaName, blockName });
                        this.currentMaximizedBlockName = blockName;
                    }
                    // Minimize current maximized block
                    else if (this.currentMaximizedBlockName === blockName) {
                        this.dispatchMinimized({ areaName, blockName });
                        this.currentMaximizedBlockName = undefined;
                    }
                    // Minimize current & maximize another
                    else if (this.currentMaximizedBlockName !== blockName) {
                        // Minimize current
                        this.dispatchMinimized({ areaName, blockName: this.currentMaximizedBlockName });
                        // Maximize next
                        this.dispatchMaximized({ areaName, blockName });
                        this.currentMaximizedBlockName = blockName;
                    }
                }
            }
        }
        // Emitting outer component events
        emitComponentUpdate(eventName, { areaName, blockName }) {
            this.dispatchEvent(new CustomEvent(eventName, {
                detail: {
                    areaName,
                    blockName
                }
            }));
        }
        // Dispatching through WINDOW_LISTENERS_HUB
        dispatchAuxHubUpdate(eventName, { areaName, blockName }) {
            _utils_WindowListenersHub__WEBPACK_IMPORTED_MODULE_3__.WINDOW_LISTENERS_HUB.dispatch(new CustomEvent(eventName, {
                detail: {
                    areaName,
                    blockName,
                    rect: this.getBoundingClientRect()
                }
            }));
        }
        dispatchMaximized({ areaName, blockName }) {
            this.emitComponentUpdate(Events.MaximizeTransitionStart, { areaName, blockName });
            const unsubscribers = [];
            // Awaiting race of (MaximizeTransitionStart + MaximizeTransitionEnd) OR (Timeout)
            Promise.race([
                // Awaiting same block maximize start + end events
                Promise.all([
                    new Promise(resolve => {
                        unsubscribers.push(_utils_WindowListenersHub__WEBPACK_IMPORTED_MODULE_3__.WINDOW_LISTENERS_HUB.once(_components_MaximizeArea_MaximizeAreaBlock__WEBPACK_IMPORTED_MODULE_0__.MaximizeAreaBlock.AuxEvents.MaximizeStart, () => resolve(), (e) => {
                            const { areaName: areaNameStart, blockName: blockNameStart } = e.detail;
                            return areaName === areaNameStart && blockName === blockNameStart;
                        }));
                    }),
                    new Promise(resolve => {
                        unsubscribers.push(_utils_WindowListenersHub__WEBPACK_IMPORTED_MODULE_3__.WINDOW_LISTENERS_HUB.once(_components_MaximizeArea_MaximizeAreaBlock__WEBPACK_IMPORTED_MODULE_0__.MaximizeAreaBlock.AuxEvents.MaximizeEnd, () => resolve(), (e) => {
                            const { areaName: areaNameEnd, blockName: blockNameEnd } = e.detail;
                            return areaName === areaNameEnd && blockName === blockNameEnd;
                        }));
                    })
                ]),
                // Or failing due to some animation issue
                (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_2__.createTimeoutPromise)(_components_MaximizeArea_MaximizeAreaBlock__WEBPACK_IMPORTED_MODULE_0__.MaximizeAreaBlock.TRANSITION_FAILED_TIMEOUT)
            ]).finally(() => {
                this.emitComponentUpdate(Events.MaximizeTransitionEnd, { areaName, blockName });
                unsubscribers.forEach(u => u());
                unsubscribers.length = 0;
            });
            this.dispatchAuxHubUpdate(AuxEvents.MaximizeResponse, { areaName, blockName });
        }
        dispatchMinimized({ areaName, blockName }) {
            this.emitComponentUpdate(Events.MinimizeTransitionStart, { areaName, blockName });
            const unsubscribers = [];
            // Awaiting race of (MinimizeTransitionStart + MinimizeTransitionEnd) OR (Timeout)
            Promise.race([
                // Awaiting same block minimize start + end events
                Promise.all([
                    new Promise(resolve => {
                        unsubscribers.push(_utils_WindowListenersHub__WEBPACK_IMPORTED_MODULE_3__.WINDOW_LISTENERS_HUB.once(_components_MaximizeArea_MaximizeAreaBlock__WEBPACK_IMPORTED_MODULE_0__.MaximizeAreaBlock.AuxEvents.MinimizeStart, () => resolve(), (e) => {
                            const { areaName: areaNameStart, blockName: blockNameStart } = e.detail;
                            return areaName === areaNameStart && blockName === blockNameStart;
                        }));
                    }),
                    new Promise(resolve => {
                        unsubscribers.push(_utils_WindowListenersHub__WEBPACK_IMPORTED_MODULE_3__.WINDOW_LISTENERS_HUB.once(_components_MaximizeArea_MaximizeAreaBlock__WEBPACK_IMPORTED_MODULE_0__.MaximizeAreaBlock.AuxEvents.MinimizeEnd, () => resolve(), (e) => {
                            const { areaName: areaNameEnd, blockName: blockNameEnd } = e.detail;
                            return areaName === areaNameEnd && blockName === blockNameEnd;
                        }));
                    })
                ]),
                // Or failing due to some animation issue
                (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_2__.createTimeoutPromise)(_components_MaximizeArea_MaximizeAreaBlock__WEBPACK_IMPORTED_MODULE_0__.MaximizeAreaBlock.TRANSITION_FAILED_TIMEOUT)
            ]).finally(() => {
                this.emitComponentUpdate(Events.MinimizeTransitionEnd, { areaName, blockName });
                unsubscribers.forEach(u => u());
                unsubscribers.length = 0;
            });
            this.dispatchAuxHubUpdate(AuxEvents.MinimizeResponse, { areaName, blockName });
        }
        dispatchResized({ areaName, blockName }) {
            this.dispatchAuxHubUpdate(AuxEvents.ResizeResponse, { areaName, blockName });
            this.emitComponentUpdate(Events.Resized, { areaName, blockName });
        }
        connectedCallback() {
            super.connectedCallback();
            _utils_WindowListenersHub__WEBPACK_IMPORTED_MODULE_3__.WINDOW_LISTENERS_HUB.on(_components_MaximizeArea_MaximizeAreaBlock__WEBPACK_IMPORTED_MODULE_0__.MaximizeAreaBlock.AuxEvents.ToggleRequest, this.onToggleBlockRequest);
            _utils_WindowListenersHub__WEBPACK_IMPORTED_MODULE_3__.WINDOW_LISTENERS_HUB.on(_components_MaximizeArea_MaximizeAreaBlock__WEBPACK_IMPORTED_MODULE_0__.MaximizeAreaBlock.AuxEvents.DisconnectRequest, this.onDisconnectBlockRequest);
            _utils_WindowListenersHub__WEBPACK_IMPORTED_MODULE_3__.WINDOW_LISTENERS_HUB.on("resize", this.onWindowResize);
            this.resizeObserver.observe(this);
        }
        disconnectedCallback() {
            super.disconnectedCallback();
            _utils_WindowListenersHub__WEBPACK_IMPORTED_MODULE_3__.WINDOW_LISTENERS_HUB.off(_components_MaximizeArea_MaximizeAreaBlock__WEBPACK_IMPORTED_MODULE_0__.MaximizeAreaBlock.AuxEvents.ToggleRequest, this.onToggleBlockRequest);
            _utils_WindowListenersHub__WEBPACK_IMPORTED_MODULE_3__.WINDOW_LISTENERS_HUB.off(_components_MaximizeArea_MaximizeAreaBlock__WEBPACK_IMPORTED_MODULE_0__.MaximizeAreaBlock.AuxEvents.DisconnectRequest, this.onDisconnectBlockRequest);
            _utils_WindowListenersHub__WEBPACK_IMPORTED_MODULE_3__.WINDOW_LISTENERS_HUB.off("resize", this.onWindowResize);
            this.resizeObserver.disconnect();
        }
        updated(changedProperties) {
            super.updated(changedProperties);
            changedProperties.forEach((oldValue, name) => {
                if (name === "areaName") {
                    if (oldValue) {
                        if (areasMap.has(oldValue)) {
                            areasMap.delete(oldValue);
                        }
                    }
                    if (this.areaName) {
                        if (!areasMap.has(this.areaName)) {
                            areasMap.set(this.areaName, this);
                        }
                        else {
                            _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error(`[MaximizeAreaHost] Area with name ${this.areaName} already exists!`);
                        }
                    }
                    else {
                        _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.error(`[MaximizeAreaHost] Area name is not defined`);
                    }
                }
            });
        }
        static get styles() {
            return [_MaximizeAreaHost_scss__WEBPACK_IMPORTED_MODULE_6__["default"]];
        }
        render() {
            return lit_html__WEBPACK_IMPORTED_MODULE_5__.nothing;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: String, reflect: true })
    ], Element.prototype, "areaName", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: Boolean, reflect: true })
    ], Element.prototype, "resizeAnimate", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.internalProperty)()
    ], Element.prototype, "currentMaximizedBlockName", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.customElement)("uuip-wc-maximize-area-host")
    ], Element);
    MaximizeAreaHost.Element = Element;
})(MaximizeAreaHost || (MaximizeAreaHost = {}));


/***/ }),

/***/ "./src/components/Navigation/Navigation.scss":
/*!***************************************************!*\
  !*** ./src/components/Navigation/Navigation.scss ***!
  \***************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  /* Font family */
  --font-family: var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial, sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "CiscoSansTT Light", "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
}

:host {
  --z-index-negative: -1;
  --z-index-base: 0;
  --z-overflow-scroll-button: 1;
  --z-index-expand-collapse: 2;
  --z-index-maximize-block: 3;
  --z-navigation-bar: 5;
  --z-index-task-list: 6;
  --z-index-task-collapse-area: 7;
  --z-index-wrap-up: 7;
  --z-index-menu-overlay: 8;
  --z-index-dynamic-area-overflow: 9;
  --z-index-notification: 1041;
  --z-index-sticky-header: 11;
  --z-index-popover: 1030;
  --z-index-modal: 1040;
  --z-index-full-overlay: 1050;
  --z-index-app-full-overlay: 1060;
  --z-index-modal-error: 1100;
  --z-index-connection-lost: 1150;
}

nav {
  --nav-size: 56px;
  --header-size: 64px;
  --mobile-logo-size: 28px;
  height: 100%;
  max-width: var(--nav-size);
}
nav .logo {
  align-items: center;
  display: flex;
  height: var(--header-size);
  justify-content: center;
  border-bottom: 1px solid var(--md-primary-seperator-color);
  background: var(--md-secondary-white-bg-color);
}
nav .logo--img {
  height: calc(var(--nav-size) / 2);
  width: calc(var(--nav-size) / 2);
}
nav .container {
  flex: 1;
  justify-content: space-between;
  max-height: calc(100vh - var(--nav-size));
  padding-bottom: calc(var(--space-token-cardinal) * 2);
  box-sizing: border-box;
}

.column {
  display: flex;
  flex-direction: column;
  width: var(--nav-size);
}

.nav-list {
  overflow-y: auto;
  margin: 0;
  text-indent: 0;
  list-style-type: none;
  padding: 4px 0;
}
.nav-list.primary {
  flex: 1;
  overflow: hidden;
  min-height: 50%;
}
.nav-list.secondary {
  height: auto;
  overflow: hidden;
}
.nav-list__item {
  padding-left: 4px;
}

.scroll-button-placer {
  max-height: 0;
  width: 100%;
  position: relative;
}

.nav-scroll-button {
  height: 40px;
  width: 100%;
  background-color: var(--color-gray-70);
  position: absolute;
  left: 0;
  z-index: var(--z-overflow-scroll-button, 1);
  display: flex;
  justify-content: center;
}
.nav-scroll-button.top {
  top: 0;
}
.nav-scroll-button.bottom {
  bottom: 100%;
}

.hamburger-container {
  width: var(--nav-size);
  height: var(--header-size);
  display: flex;
  align-items: center;
  justify-content: center;
}

.hamburger-container {
  display: none;
}

.hidable-container {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  background-color: var(--md-secondary-white-bg-color);
}
.hidable-container .logo {
  display: none;
}

.reload-button {
  display: flex;
  padding-left: 0.25rem;
  width: calc(var(--nav-size) - 8px);
  height: calc(var(--nav-size) - 8px);
}
.reload-button .reload-icon {
  width: calc(var(--nav-size) - 0.125rem);
  justify-content: center;
  color: var(--light-green-color);
}

@media (max-width: 736px) {
  :host {
    position: absolute;
    z-index: auto;
    height: calc(100% - 64px);
  }
  :host([shownavlist]) {
    z-index: var(--z-navigation-bar);
  }
  .shadow {
    box-shadow: var(--box-shadow-gray);
  }
  nav .logo--img {
    width: var(--mobile-logo-size);
    height: var(--mobile-logo-size);
    margin: calc(var(--space-token-cardinal) * 4);
  }
  nav .container {
    padding-bottom: 0;
  }
  nav .top-container .logo {
    display: none;
  }
  nav .hamburger-container {
    display: flex;
    background-color: var(--md-tertiary-white-bg-color);
    color: var(--md-primary-text-color);
    border-bottom: 1px solid var(--md-primary-seperator-color);
  }
  nav .hidable-container {
    position: relative;
    transition: left var(--default-animation-duration) var(--ease-in-out-quint);
    left: -100%;
    pointer-events: none;
  }
  nav .hidable-container.show-nav-list {
    left: 0;
    pointer-events: initial;
  }
  nav .hidable-container .logo {
    display: flex;
  }
  nav .hidable-container .nav-list .not-responsive {
    display: none;
  }
}
/*# sourceURL=/home/jenkins/agent/workspace/cicd-jobs/wxcc-common-CI-Builder/packages/@uuip/unified-ui-platform-common-components/src/assets/styles/variables.scss */
/*# sourceURL=Navigation.scss */
/*# sourceURL=/home/jenkins/agent/workspace/cicd-jobs/wxcc-common-CI-Builder/packages/@uuip/unified-ui-platform-common-components/src/assets/styles/z-index.scss */
/*# sourceURL=/home/jenkins/agent/workspace/cicd-jobs/wxcc-common-CI-Builder/packages/@uuip/unified-ui-platform-common-components/src/components/Navigation/Navigation.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/Navigation/Navigation.ts":
/*!*************************************************!*\
  !*** ./src/components/Navigation/Navigation.ts ***!
  \*************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Navigation: () => (/* binding */ Navigation)
/* harmony export */ });
/* harmony import */ var _mixins_i18n__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18n */ "./src/mixins/i18n.ts");
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/sdk */ "./src/sdk.ts");
/* harmony import */ var _img_webex_cc_logo_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @img/webex_cc_logo.svg */ "./src/assets/images/webex_cc_logo.svg");
/* harmony import */ var _img_webex_cc_logo_svg__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_img_webex_cc_logo_svg__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! lit-html/directives/class-map */ "lit-html/directives/class-map");
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! lit-html/directives/repeat */ "lit-html/directives/repeat");
/* harmony import */ var lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _comp_NavigationItem__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./comp/NavigationItem */ "./src/components/Navigation/comp/NavigationItem.ts");
/* harmony import */ var _Navigation_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./Navigation.scss */ "./src/components/Navigation/Navigation.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/* eslint-disable @typescript-eslint/no-explicit-any */










var Navigation;
(function (Navigation) {
    const DIRECTION = {
        UP: -1,
        DOWN: 1
    };
    const DEFAULT_SCROLL_MARGIN = 20; //px
    /**
     * @element uuip-wc-navigation
     * @fires item-selected
     */
    let Element = class Element extends (0,_mixins_i18n__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_4__.LitElement) {
        constructor() {
            super(...arguments);
            this.selectedNavigateTo = null;
            this.items = [];
            this.navtitle = "Cisco Systems Inc.";
            this.logo = (_img_webex_cc_logo_svg__WEBPACK_IMPORTED_MODULE_2___default());
            this.localization = {};
            this.t = {
                mainSectionLabelText: "Main Navigation List",
                secondarySectionLabelText: "Secondary Navigation List",
                scrollDownText: "Scroll down",
                scrollUpText: "Scroll up",
                hideNavText: "Hide",
                showNavText: "Show",
                reloadText: "Reload"
            };
            this.scrollMargin = DEFAULT_SCROLL_MARGIN; //px
            this.top = [];
            this.bottom = [];
            this.itemSelectedIdx = 0;
            this.showNavList = false;
            this.showTopScrollButton = false;
            this.showBottomScrollButton = false;
            this.bottomClickHandler = (item) => {
                if (item.icon.indexOf("help") >= 0) {
                    this.dispatchEvent(new CustomEvent("ax-help-content", {
                        detail: true,
                        bubbles: true,
                        composed: true
                    }));
                }
                else {
                    this.selected(item.navigateTo);
                }
            };
            this.onPrimaryScroll = (event) => {
                const target = event.target;
                this.showTopScrollButton = target.scrollTop >= this.scrollMargin;
                this.showBottomScrollButton = target.scrollHeight - target.clientHeight - this.scrollMargin >= target.scrollTop;
            };
            this.scrollNavList = (direction) => this.primaryNav.scrollBy({
                top: (direction * this.primaryNav.clientHeight) / 2,
                behavior: "smooth"
            });
            this.handleScrollButtonCreation = () => {
                // dispatching a custom event to initiate the scroll buttons
                if (this.primaryNav) {
                    this.primaryNav.dispatchEvent(new CustomEvent("scroll"));
                }
            };
        }
        connectedCallback() {
            super.connectedCallback();
            window.addEventListener("resize", this.handleScrollButtonCreation);
        }
        disconnectedCallback() {
            window.removeEventListener("resize", this.handleScrollButtonCreation);
            super.disconnectedCallback();
        }
        updated(changedProperties) {
            super.updated(changedProperties);
            changedProperties.forEach((oldValue, name) => {
                if (name === "items" || name === "selectedNavigateTo") {
                    // Updating render collections
                    if (name === "items") {
                        this.top = this.items.filter((i) => i.align === "top");
                        this.bottom = this.items.filter((i) => i.align === "bottom");
                    }
                    // Updating Select
                    if (this.selectedNavigateTo) {
                        this.itemSelectedIdx = this.items.findIndex((i) => i.navigateTo === this.selectedNavigateTo);
                    }
                }
            });
            if (this.showNavList !== changedProperties.get("showNavList")) {
                this.evt("navbar-toggled", { showNavList: this.showNavList });
            }
            // dispatching a custom event to initiate the scroll buttons
            this.handleScrollButtonCreation();
        }
        selected(navigateTo) {
            this.selectedNavigateTo = navigateTo;
            this.evt("item-selected", { navigateTo });
        }
        // ROST: create decorator fot custom event
        evt(name, detail) {
            this.dispatchEvent(new CustomEvent(name, { bubbles: true, composed: true, detail }));
            _sdk__WEBPACK_IMPORTED_MODULE_1__.logger.info("[Navigation]: Dispatching event", name, detail);
        }
        static get styles() {
            return _Navigation_scss__WEBPACK_IMPORTED_MODULE_9__["default"];
        }
        get logoImgSrc() {
            return this.logo ? this.logo : (_img_webex_cc_logo_svg__WEBPACK_IMPORTED_MODULE_2___default());
        }
        renderLogo() {
            if (this.logo !== (_img_webex_cc_logo_svg__WEBPACK_IMPORTED_MODULE_2___default())) {
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
          <picture class="logo" aria-label="${this.navtitle}">
            <md-tooltip message="${this.navtitle}">
              <img class="logo--img" src="${this.logoImgSrc}" />
            </md-tooltip>
          </picture>
        `;
            }
            return lit_html__WEBPACK_IMPORTED_MODULE_5__.nothing;
        }
        getScrollButtonTitle(dir) {
            return dir === DIRECTION.UP ? this.t.scrollUpText : this.t.scrollDownText;
        }
        renderScrollButton(dir) {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
        <md-button
          @click=${() => this.scrollNavList(dir)}
          ariaLabel="${this.getScrollButtonTitle(dir)}"
          role="scrollbar"
          title="${this.getScrollButtonTitle(dir)}"
          class="${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_6__.classMap)({ top: dir === DIRECTION.UP, bottom: DIRECTION.UP, "nav-scroll-button": true })}"
          expanded
          hasRemoveStyle
        >
          <md-icon
            class="nav-scroll-icon"
            name="${dir === DIRECTION.UP ? "arrow-up-regular" : "arrow-down-regular"}"
            size="24"
            iconSet="momentumDesign"
            title="${this.getScrollButtonTitle(dir)}"
          ></md-icon>
        </md-button>
      `;
        }
        renderHamburgerButton(isNavShown) {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
        <md-icon
          tabindex="0"
          ariaLabel="${isNavShown ? this.t.hideNavText : this.t.showNavText}"
          name="${isNavShown ? "cancel-regular" : "list-menu-regular"}"
          size="24"
          iconSet="momentumDesign"
          class="nav-button"
          @click=${() => {
                this.showNavList = !isNavShown;
                if (this.showNavList) {
                    this.setAttribute("showNavList", "");
                }
                else {
                    this.removeAttribute("showNavList");
                }
            }}
        ></md-icon>
      `;
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
        <nav class="column ${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_6__.classMap)({ shadow: this.showNavList })}">
          <div class="top-container">
            ${this.renderLogo()}
            <div class="hamburger-container">${this.renderHamburgerButton(this.showNavList)}</div>
          </div>
          <div class="${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_6__.classMap)({ "show-nav-list": this.showNavList, "hidable-container": true })}">
            <div class="column container">
              <div class="scroll-button-placer">
                ${this.showTopScrollButton ? this.renderScrollButton(DIRECTION.UP) : lit_html__WEBPACK_IMPORTED_MODULE_5__.nothing}
              </div>
              <ul
                @scroll=${this.onPrimaryScroll}
                id="primaryNav"
                aria-label="${this.t.mainSectionLabelText}"
                role="listbox"
                class="nav-list primary"
              >
                ${(0,lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_7__.repeat)(this.top, (item, index) => (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
                    <li class="nav-list__item">
                      <md-tooltip message="${item.label}">
                        <uuip-wc-navigation-item
                          .item="${item}"
                          ?selected="${this.itemSelectedIdx === index}"
                          @selected="${(e) => this.selected(e.detail.item.navigateTo)}"
                        ></uuip-wc-navigation-item>
                      </md-tooltip>
                    </li>
                  `)}
              </ul>

              <div class="scroll-button-placer">
                ${this.showBottomScrollButton ? this.renderScrollButton(DIRECTION.DOWN) : lit_html__WEBPACK_IMPORTED_MODULE_5__.nothing}
              </div>
              <div>
                <!-- Bottom of the navigation bar is designated for quick links - they will not have 'selected' state -->
                <ul aria-label="${this.t.secondarySectionLabelText}" role="listbox" class="nav-list secondary">
                  ${(0,lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_7__.repeat)(this.bottom, (item, _index) => (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
                      <li class="nav-list__item">
                        <md-tooltip message="${item.label}">
                          <uuip-wc-navigation-item
                            .item="${item}"
                            ?selected="${false}"
                            @selected="${(e) => this.bottomClickHandler(e.detail.item)}"
                          ></uuip-wc-navigation-item>
                        </md-tooltip>
                      </li>
                    `)}
                </ul>
                <!-- Display reload icon if uuip loaded in an iframe -->
                ${window !== window.top
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
                      <md-tooltip message="${this.t.reloadText}">
                        <md-button
                          @click=${() => location.reload()}
                          ariaLabel="${this.t.reloadText}"
                          class="reload-button"
                          expanded
                          hasRemoveStyle
                          tabindex="0"
                        >
                          <md-icon
                            aria-label="${this.t.reloadText}"
                            title="${this.t.reloadText}"
                            name="refresh-regular"
                            size="24"
                            iconSet="momentumDesign"
                            class="reload-icon"
                          ></md-icon>
                        </md-button>
                      </md-tooltip>
                    `
                : lit_html__WEBPACK_IMPORTED_MODULE_5__.nothing}
                <!-- webex icon for mobile/connectors view -->
                ${this.renderLogo()}
              </div>
            </div>
          </div>
        </nav>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: String })
    ], Element.prototype, "selectedNavigateTo", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: Array })
    ], Element.prototype, "items", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: String })
    ], Element.prototype, "navtitle", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: String })
    ], Element.prototype, "logo", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: Object })
    ], Element.prototype, "localization", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.internalProperty)()
    ], Element.prototype, "t", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: Number })
    ], Element.prototype, "scrollMargin", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.internalProperty)()
    ], Element.prototype, "top", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.internalProperty)()
    ], Element.prototype, "bottom", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.internalProperty)()
    ], Element.prototype, "itemSelectedIdx", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.internalProperty)()
    ], Element.prototype, "showNavList", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.internalProperty)()
    ], Element.prototype, "showTopScrollButton", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.internalProperty)()
    ], Element.prototype, "showBottomScrollButton", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.query)("#primaryNav")
    ], Element.prototype, "primaryNav", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.customElement)("uuip-wc-navigation")
    ], Element);
    Navigation.Element = Element;
})(Navigation || (Navigation = {}));


/***/ }),

/***/ "./src/components/Navigation/comp/NavigationItem.scss":
/*!************************************************************!*\
  !*** ./src/components/Navigation/comp/NavigationItem.scss ***!
  \************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  --z-index-negative: -1;
  --z-index-base: 0;
  --z-overflow-scroll-button: 1;
  --z-index-expand-collapse: 2;
  --z-index-maximize-block: 3;
  --z-navigation-bar: 5;
  --z-index-task-list: 6;
  --z-index-task-collapse-area: 7;
  --z-index-wrap-up: 7;
  --z-index-menu-overlay: 8;
  --z-index-dynamic-area-overflow: 9;
  --z-index-notification: 1041;
  --z-index-sticky-header: 11;
  --z-index-popover: 1030;
  --z-index-modal: 1040;
  --z-index-full-overlay: 1050;
  --z-index-app-full-overlay: 1060;
  --z-index-modal-error: 1100;
  --z-index-connection-lost: 1150;
}

:host {
  display: flex;
  width: auto;
  height: auto;
  padding: 0;
  margin: 0;
  text-indent: 0;
  list-style: none;
}

.nav-button {
  display: flex;
  height: auto;
  border-radius: 3px;
  color: var(--md-primary-text-color);
  width: calc(var(--nav-size) - 8px);
  height: calc(var(--nav-size) - 8px);
}
.nav-button:hover {
  background-color: var(--md-tertiary-bg-color, --md-tertiary-bg-color-default);
}
.nav-button.nav-button__selected {
  position: relative;
  background-color: var(--md-quaternary-bg-color, --md-quaternary-bg-color-default);
}
.nav-button.nav-button__selected::before {
  content: "";
  position: absolute;
  z-index: 2;
  width: 3px;
  height: 100%;
  background-color: var(--md-primary-text-color);
  top: 0;
  left: -3px;
  border-radius: 2px;
}
.nav-button .nav-scroll-icon {
  color: var(--md-primary-text-color);
}
.nav-button .wc-notification-count {
  position: absolute;
  left: 1.2rem;
  top: 0.4rem;
  transform: translate(-20%, -10%);
}
.nav-button .nav-button-content {
  width: calc(var(--nav-size) - 0.125rem);
  height: calc(var(--nav-size) - 0.75rem);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 !important;
}
.nav-button .nav-button-content.hidden {
  display: none;
}
.nav-button .nav-button-content.img-loading {
  background-image: linear-gradient(-45deg, rgba(255, 255, 255, 0.125) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.125) 50%, rgba(255, 255, 255, 0.125) 75%, transparent 75%, transparent);
  background-size: calc(var(--nav-size) / 2) calc(var(--nav-size) / 2);
  animation: cssProgressActive 1s linear infinite;
}
@keyframes cssProgressActive {
  0% {
    background-position: 0 0;
  }
  100% {
    background-position: calc(var(--nav-size) / 2) calc(var(--nav-size) / 2);
  }
}
/*# sourceURL=/home/jenkins/agent/workspace/cicd-jobs/wxcc-common-CI-Builder/packages/@uuip/unified-ui-platform-common-components/src/assets/styles/z-index.scss */
/*# sourceURL=NavigationItem.scss */
/*# sourceURL=/home/jenkins/agent/workspace/cicd-jobs/wxcc-common-CI-Builder/packages/@uuip/unified-ui-platform-common-components/src/components/Navigation/comp/NavigationItem.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/Navigation/comp/NavigationItem.ts":
/*!**********************************************************!*\
  !*** ./src/components/Navigation/comp/NavigationItem.ts ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   NavigationItem: () => (/* binding */ NavigationItem)
/* harmony export */ });
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-html/directives/class-map */ "lit-html/directives/class-map");
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lit_html_directives_style_map__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lit-html/directives/style-map */ "lit-html/directives/style-map");
/* harmony import */ var lit_html_directives_style_map__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_style_map__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _NavigationItem_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./NavigationItem.scss */ "./src/components/Navigation/comp/NavigationItem.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};






const DEFAULT_ICON_SIZE = 20;
const MAX_NOTIFICATION_COUNT = "99+";
const isImageUrl = (url) => {
    if (!url || url.length < 4) {
        return false;
    }
    const validImageExtensions = ["png", "gif", "jpg", "jpeg", "svg", "bmp", "ico"];
    const image = url.substring(url.lastIndexOf("/")).toLowerCase();
    return validImageExtensions.find((ext) => image.includes(ext));
};
var NavigationItem;
(function (NavigationItem) {
    let _uid = 0;
    /**
     * @element uuip-wc-navigation-item
     * @fires selected
     */
    let Element = class Element extends lit_element__WEBPACK_IMPORTED_MODULE_1__.LitElement {
        constructor() {
            super(...arguments);
            this.selected = false;
            this.popoverCount = null;
            this.uid = _uid++;
            this.isImgLoaded = false;
            this.isImgError = false;
        }
        connectedCallback() {
            super.connectedCallback();
        }
        get label() {
            return this.item && this.item.label ? this.item.label : "";
        }
        get iconSize() {
            return this.item && this.item.iconSize ? this.item.iconSize : DEFAULT_ICON_SIZE;
        }
        get isMomentum() {
            return this.item && this.item.iconType === "momentum";
        }
        get isImg() {
            return this.item && this.item.iconType === "other" && !!isImageUrl(this.item.icon);
        }
        get btnCssClassInfo() {
            return {
                "nav-button__imaged": this.isImg,
                "nav-button__selected": this.selected
            };
        }
        static get styles() {
            return _NavigationItem_scss__WEBPACK_IMPORTED_MODULE_5__["default"];
        }
        onBtnClick() {
            this.dispatchEvent(new CustomEvent("selected", {
                detail: {
                    item: this.item
                }
            }));
        }
        render() {
            return (0,lit_html__WEBPACK_IMPORTED_MODULE_2__.html) `
        <md-button
          role="navigation"
          id="navigation-item-${this.uid}"
          ariaLabel=${this.label}
          @click=${() => this.onBtnClick()}
          class="nav-button ${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_3__.classMap)(this.btnCssClassInfo)}"
          expanded
          hasRemoveStyle
        >
          ${this.renderIcon()} ${this.renderBadge()}
        </md-button>
      `;
        }
        renderBadge() {
            if (this.item.notificationCount) {
                const count = this.item.notificationCount < 99 ? this.item.notificationCount : MAX_NOTIFICATION_COUNT;
                return (0,lit_html__WEBPACK_IMPORTED_MODULE_2__.html) `
          <md-badge class="wc-notification-count" color="unreadcount" id="wc-notification-count">
            <span>${count}</span>
          </md-badge>
        `;
            }
            return lit_html__WEBPACK_IMPORTED_MODULE_2__.nothing;
        }
        renderIcon() {
            if (this.isMomentum) {
                return (0,lit_html__WEBPACK_IMPORTED_MODULE_2__.html) `
          <md-icon
            ariaLabel=${this.item.icon}
            name=${`icon-${this.item.icon}_${this.iconSize}`}
            size=${this.iconSize}
            iconSet="preferMomentumDesign"
            class="nav-button-content"
          ></md-icon>
        `;
            }
            if (this.isImg) {
                return (0,lit_html__WEBPACK_IMPORTED_MODULE_2__.html) `
          <div
            class="nav-button-content ${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_3__.classMap)({
                    hidden: this.isImgError,
                    "img-loading": !this.isImgError && !this.isImgLoaded
                })}"
          >
            <img
              src="${this.item.icon}"
              alt="${this.label}"
              style="${(0,lit_html_directives_style_map__WEBPACK_IMPORTED_MODULE_4__.styleMap)({
                    "max-height": `${this.iconSize}px`,
                    "max-width": `${this.iconSize}px`
                })}"
              @load="${() => {
                    this.isImgError = false;
                    this.isImgLoaded = true;
                }}"
              @error="${() => (this.isImgError = true)}"
            />
          </div>
          <md-icon
            name="warning-regular"
            size="20"
            iconSet="momentumDesign"
            title=${this.label}
            class="nav-button-content ${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_3__.classMap)({ hidden: !this.isImgError })}"
          ></md-icon>
        `;
            }
            return (0,lit_html__WEBPACK_IMPORTED_MODULE_2__.html) ` <span>${this.label}</span> `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Object })
    ], Element.prototype, "item", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Boolean })
    ], Element.prototype, "selected", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Number })
    ], Element.prototype, "popoverCount", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "uid", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "isImgLoaded", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "isImgError", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.customElement)("uuip-wc-navigation-item")
    ], Element);
    NavigationItem.Element = Element;
})(NavigationItem || (NavigationItem = {}));


/***/ }),

/***/ "./src/components/Notifications/NotificationsHost.scss":
/*!*************************************************************!*\
  !*** ./src/components/Notifications/NotificationsHost.scss ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host md-button.ignore-all-toasts::part(button) {
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.16), 0 0 1px rgba(0, 0, 0, 0.14);
  color: var(--md-hyperlink-text-color);
  margin-top: 0.25rem;
  max-width: 21.25rem;
}
:host md-button.ignore-all-toasts::part(button)::after {
  border-radius: 0.5rem;
}
/*# sourceURL=/home/jenkins/agent/workspace/cicd-jobs/wxcc-common-CI-Builder/packages/@uuip/unified-ui-platform-common-components/src/components/Notifications/NotificationsHost.scss */
/*# sourceURL=NotificationsHost.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL2plbmtpbnMvYWdlbnQvd29ya3NwYWNlL2NpY2Qtam9icy93eGNjLWNvbW1vbi1DSS1CdWlsZGVyL3BhY2thZ2VzL0B1dWlwL3VuaWZpZWQtdWktcGxhdGZvcm0tY29tbW9uLWNvbXBvbmVudHMvc3JjL2NvbXBvbmVudHMvTm90aWZpY2F0aW9ucy9Ob3RpZmljYXRpb25zSG9zdC5zY3NzIiwiTm90aWZpY2F0aW9uc0hvc3Quc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFDRTtFQUNFLGtCQUFBO0VBQ0EsdUVBQUE7RUFDQSxxQ0FBQTtFQUNBLG1CQUFBO0VBQ0EsbUJBQUE7QUNBSjtBREVJO0VBQ0UscUJBQUE7QUNBTiIsImZpbGUiOiJOb3RpZmljYXRpb25zSG9zdC5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsiOmhvc3Qge1xyXG4gIG1kLWJ1dHRvbi5pZ25vcmUtYWxsLXRvYXN0czo6cGFydChidXR0b24pIHtcclxuICAgIGJvcmRlci1yYWRpdXM6IDhweDtcclxuICAgIGJveC1zaGFkb3c6IDAgNHB4IDE2cHggcmdiYSgwLCAwLCAwLCAwLjE2KSwgMCAwIDFweCByZ2JhKDAsIDAsIDAsIDAuMTQpO1xyXG4gICAgY29sb3I6IHZhcigtLW1kLWh5cGVybGluay10ZXh0LWNvbG9yKTtcclxuICAgIG1hcmdpbi10b3A6IDAuMjVyZW07XHJcbiAgICBtYXgtd2lkdGg6IDIxLjI1cmVtO1xyXG5cclxuICAgICY6OmFmdGVyIHtcclxuICAgICAgYm9yZGVyLXJhZGl1czogMC41cmVtO1xyXG4gICAgfVxyXG4gIH1cclxufSIsIjpob3N0IG1kLWJ1dHRvbi5pZ25vcmUtYWxsLXRvYXN0czo6cGFydChidXR0b24pIHtcbiAgYm9yZGVyLXJhZGl1czogOHB4O1xuICBib3gtc2hhZG93OiAwIDRweCAxNnB4IHJnYmEoMCwgMCwgMCwgMC4xNiksIDAgMCAxcHggcmdiYSgwLCAwLCAwLCAwLjE0KTtcbiAgY29sb3I6IHZhcigtLW1kLWh5cGVybGluay10ZXh0LWNvbG9yKTtcbiAgbWFyZ2luLXRvcDogMC4yNXJlbTtcbiAgbWF4LXdpZHRoOiAyMS4yNXJlbTtcbn1cbjpob3N0IG1kLWJ1dHRvbi5pZ25vcmUtYWxsLXRvYXN0czo6cGFydChidXR0b24pOjphZnRlciB7XG4gIGJvcmRlci1yYWRpdXM6IDAuNXJlbTtcbn0iXX0= */`);
    

/***/ }),

/***/ "./src/components/Notifications/NotificationsHost.ts":
/*!***********************************************************!*\
  !*** ./src/components/Notifications/NotificationsHost.ts ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   NotificationsHost: () => (/* binding */ NotificationsHost)
/* harmony export */ });
/* harmony import */ var _components_Notifications_components_ModalNotification_ModalNotificationsHost__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../components/Notifications/components/ModalNotification/ModalNotificationsHost */ "./src/components/Notifications/components/ModalNotification/ModalNotificationsHost.ts");
/* harmony import */ var _components_Notifications_components_ToasterNotification_ToasterNotificationsHost__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../components/Notifications/components/ToasterNotification/ToasterNotificationsHost */ "./src/components/Notifications/components/ToasterNotification/ToasterNotificationsHost.ts");
/* harmony import */ var _mixins_i18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @/mixins/i18n */ "./src/mixins/i18n.ts");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @uuip/unified-ui-platform-sdk */ "@uuip/unified-ui-platform-sdk");
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var lit_html_directives_style_map__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! lit-html/directives/style-map */ "lit-html/directives/style-map");
/* harmony import */ var lit_html_directives_style_map__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_style_map__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _NotificationsHost_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./NotificationsHost.scss */ "./src/components/Notifications/NotificationsHost.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};









var NotificationsHost;
(function (NotificationsHost) {
    /**
     * @element uuip-wc-notifications-host
     * @fires ignore-notifications
     */
    let Element = class Element extends (0,_mixins_i18n__WEBPACK_IMPORTED_MODULE_2__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_5__.LitElement) {
        constructor() {
            super(...arguments);
            this.toasterHostPosition = "top-right";
            this.toasterHostHeight = "height-auto";
            this.localization = {};
            this.t = {
                ignoreButtonText: "Ignore Notifications"
            };
            this.activatedAutodismiss = [];
            this.activatedAcknowledge = [];
            this.updateCollections = () => {
                this.activatedAutodismiss = [...this.notificationsService.activated.autodismiss];
                this.activatedAcknowledge = [...this.notificationsService.activated.acknowledge];
            };
        }
        static get styles() {
            return _NotificationsHost_scss__WEBPACK_IMPORTED_MODULE_8__["default"];
        }
        disconnectedCallback() {
            super.disconnectedCallback();
            this.unbindServiceEvents();
        }
        firstUpdated(changedProperties) {
            super.firstUpdated(changedProperties);
            this.updateCollections();
            this.bindServiceEvents();
        }
        bindServiceEvents() {
            // Listening for all service status events
            _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_4__.Notifications.ServiceMeta.STATUS_EVENTS.forEach(eventName => this.notificationsService.addEventListener(eventName, this.updateCollections));
        }
        unbindServiceEvents() {
            // Stop Listening for all service status events
            _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_4__.Notifications.ServiceMeta.STATUS_EVENTS.forEach(eventName => this.notificationsService.removeEventListener(eventName, this.updateCollections));
        }
        ignoreNotifications() {
            // Ignoring as pended-silent through service
            const pendingNotifications = this.notificationsService.pendingAll();
            // Emitting
            this.dispatchEvent(new CustomEvent("ignore-notifications", {
                detail: { notifications: pendingNotifications }
            }));
        }
        renderConditionalToasterIgnoreButton(slotName) {
            if (this.notificationsService &&
                this.activatedAutodismiss.length >= this.notificationsService.config.ACTIVATED_ITEM_MODE_LIMIT.autodismiss) {
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
          <md-button
            class="ignore-all-toasts"
            slot="${slotName}"
            ariaLabel="${this.t.ignoreButtonText}"
            variant="white"
            width="100%"
            size="40"
            @click="${() => this.ignoreNotifications()}"
          >
            <md-icon
              slot="icon"
              name="alert-muted-regular"
              size="16"
              iconSet="momentumDesign"
              style=${(0,lit_html_directives_style_map__WEBPACK_IMPORTED_MODULE_7__.styleMap)({ color: "var(--md-hyperlink-text-color)" })}
            ></md-icon>
            <span slot="text">${this.t.ignoreButtonText}</span>
          </md-button>
        `;
            }
            return lit_html__WEBPACK_IMPORTED_MODULE_6__.nothing;
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.html) `
        <uuip-wc-toaster-notifications-host
          .notifications="${this.activatedAutodismiss}"
          .position="${this.toasterHostPosition}"
          .height="${this.toasterHostHeight}"
        >
          ${this.renderConditionalToasterIgnoreButton("after-list")}
        </uuip-wc-toaster-notifications-host>
        <uuip-wc-modal-notifications-host
          .notifications="${this.activatedAcknowledge}"
        ></uuip-wc-modal-notifications-host>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Object })
    ], Element.prototype, "notificationsService", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: String })
    ], Element.prototype, "toasterHostPosition", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: String })
    ], Element.prototype, "toasterHostHeight", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.property)({ type: Object })
    ], Element.prototype, "localization", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "t", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "activatedAutodismiss", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.internalProperty)()
    ], Element.prototype, "activatedAcknowledge", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_5__.customElement)("uuip-wc-notifications-host")
    ], Element);
    NotificationsHost.Element = Element;
})(NotificationsHost || (NotificationsHost = {}));


/***/ }),

/***/ "./src/components/Notifications/components/ModalNotification/ModalNotification.scss":
/*!******************************************************************************************!*\
  !*** ./src/components/Notifications/components/ModalNotification/ModalNotification.scss ***!
  \******************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  bottom: 0;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
}
/*# sourceURL=/home/jenkins/agent/workspace/cicd-jobs/wxcc-common-CI-Builder/packages/@uuip/unified-ui-platform-common-components/src/components/Notifications/components/ModalNotification/ModalNotification.scss */
/*# sourceURL=ModalNotification.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL2plbmtpbnMvYWdlbnQvd29ya3NwYWNlL2NpY2Qtam9icy93eGNjLWNvbW1vbi1DSS1CdWlsZGVyL3BhY2thZ2VzL0B1dWlwL3VuaWZpZWQtdWktcGxhdGZvcm0tY29tbW9uLWNvbXBvbmVudHMvc3JjL2NvbXBvbmVudHMvTm90aWZpY2F0aW9ucy9jb21wb25lbnRzL01vZGFsTm90aWZpY2F0aW9uL01vZGFsTm90aWZpY2F0aW9uLnNjc3MiLCJNb2RhbE5vdGlmaWNhdGlvbi5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0UsU0FBQTtFQUNBLE9BQUE7RUFDQSxlQUFBO0VBQ0EsUUFBQTtFQUNBLE1BQUE7QUNDRiIsImZpbGUiOiJNb2RhbE5vdGlmaWNhdGlvbi5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsiOmhvc3Qge1xuICBib3R0b206IDA7XG4gIGxlZnQ6IDA7XG4gIHBvc2l0aW9uOiBmaXhlZDtcbiAgcmlnaHQ6IDA7XG4gIHRvcDogMDtcbn1cbiIsIjpob3N0IHtcbiAgYm90dG9tOiAwO1xuICBsZWZ0OiAwO1xuICBwb3NpdGlvbjogZml4ZWQ7XG4gIHJpZ2h0OiAwO1xuICB0b3A6IDA7XG59Il19 */`);
    

/***/ }),

/***/ "./src/components/Notifications/components/ModalNotification/ModalNotification.ts":
/*!****************************************************************************************!*\
  !*** ./src/components/Notifications/components/ModalNotification/ModalNotification.ts ***!
  \****************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ModalNotification: () => (/* binding */ ModalNotification)
/* harmony export */ });
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @uuip/unified-ui-platform-sdk */ "@uuip/unified-ui-platform-sdk");
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _ModalNotification_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./ModalNotification.scss */ "./src/components/Notifications/components/ModalNotification/ModalNotification.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





var ModalNotification;
(function (ModalNotification) {
    class DataController {
        constructor(p) {
            this.isPositiveChoiceAvailable = true;
            this.isNegativeChoiceAvailable = false;
            this.isNeutralChoiceAvailable = false;
            this.localization = {
                positiveButtonText: "OK",
                negativeButtonText: "CANCEL",
                neutralButtonText: "SNOOZE"
            };
            this.text = p.text;
            this.localization = p.localization || this.localization;
            this.isNegativeChoiceAvailable =
                p.isNegativeChoiceAvailable !== undefined ? p.isNegativeChoiceAvailable : this.isNegativeChoiceAvailable;
            this.isNeutralChoiceAvailable =
                p.isNeutralChoiceAvailable !== undefined ? p.isNeutralChoiceAvailable : this.isNeutralChoiceAvailable;
        }
    }
    ModalNotification.DataController = DataController;
    /**
     * @element uuip-wc-modal-notification
     */
    let Element = class Element extends lit_element__WEBPACK_IMPORTED_MODULE_2__.LitElement {
        constructor() {
            super(...arguments);
            this.isModalOpen = false;
        }
        static get styles() {
            return [_ModalNotification_scss__WEBPACK_IMPORTED_MODULE_4__["default"]];
        }
        connectedCallback() {
            super.connectedCallback();
            this.openModal();
        }
        get hasDataController() {
            return this.notification.data instanceof DataController;
        }
        get dataController() {
            return this.hasDataController ? this.notification.data : null;
        }
        get text() {
            if (this.dataController) {
                return this.dataController.text;
            }
            return this.notification.data;
        }
        get positiveButtonText() {
            return this.hasDataController ? this.dataController.localization.positiveButtonText : "OK";
        }
        get negativeButtonText() {
            return this.hasDataController ? this.dataController.localization.positiveButtonText : "CANCEL";
        }
        get neutralButtonText() {
            return this.hasDataController ? this.dataController.localization.positiveButtonText : "SNOOZE";
        }
        openModal() {
            this.isModalOpen = true;
        }
        closeModal(reason = _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_1__.Notifications.ItemMeta.DeactivateEventReason.UserNegative) {
            this.isModalOpen = false;
            this.notification.deactivate(reason);
        }
        handlePositiveAcknowledge() {
            this.closeModal(_uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_1__.Notifications.ItemMeta.DeactivateEventReason.UserPositive);
        }
        handleNegativeAcknowledge() {
            this.closeModal(_uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_1__.Notifications.ItemMeta.DeactivateEventReason.UserNegative);
        }
        handleNeutralAcknowledge() {
            this.closeModal(_uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_1__.Notifications.ItemMeta.DeactivateEventReason.UserNeutral);
        }
        renderPositiveButton() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
        <md-button
          variant="primary"
          ariaLabel="${this.positiveButtonText}"
          @click="${() => this.handlePositiveAcknowledge()}"
        >
          <span>${this.positiveButtonText}</span>
        </md-button>
      `;
        }
        renderNegativeButton() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
        <md-button
          variant="secondary"
          ariaLabel="${this.negativeButtonText}"
          @click="${() => this.handleNegativeAcknowledge()}"
        >
          <span>${this.negativeButtonText}</span>
        </md-button>
      `;
        }
        renderNeutralButton() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
        <md-button
          variant="secondary"
          ariaLabel="${this.neutralButtonText}"
          @click="${() => this.handleNegativeAcknowledge()}"
        >
          <span>${this.neutralButtonText}</span>
        </md-button>
      `;
        }
        renderAllButtons() {
            if (!this.dataController) {
                return this.renderPositiveButton();
            }
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
        ${this.dataController.isPositiveChoiceAvailable ? this.renderPositiveButton() : lit_html__WEBPACK_IMPORTED_MODULE_3__.nothing}
        ${this.dataController.isNegativeChoiceAvailable ? this.renderNegativeButton() : lit_html__WEBPACK_IMPORTED_MODULE_3__.nothing}
        ${this.dataController.isNeutralChoiceAvailable ? this.renderNeutralButton() : lit_html__WEBPACK_IMPORTED_MODULE_3__.nothing}
      `;
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
        <md-modal
          .htmlId="${`modal-${this.notification.timestamp}`}"
          .show=${this.isModalOpen}
          size="dialog"
          headerMessage="${this.notification.title}"
          hideFooter
          @close-modal="${() => {
                !this.dataController
                    ? this.handlePositiveAcknowledge()
                    : this.dataController.isNegativeChoiceAvailable
                        ? this.handleNegativeAcknowledge()
                        : this.dataController.isNeutralChoiceAvailable
                            ? this.handleNeutralAcknowledge()
                            : this.handlePositiveAcknowledge();
            }}"
        >
          <p>${this.text}</p>
          <div slot="footer">${this.renderAllButtons()}</div>
        </md-modal>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Object })
    ], Element.prototype, "notification", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.internalProperty)()
    ], Element.prototype, "isModalOpen", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.customElement)("uuip-wc-modal-notification")
    ], Element);
    ModalNotification.Element = Element;
})(ModalNotification || (ModalNotification = {}));


/***/ }),

/***/ "./src/components/Notifications/components/ModalNotification/ModalNotificationsHost.scss":
/*!***********************************************************************************************!*\
  !*** ./src/components/Notifications/components/ModalNotification/ModalNotificationsHost.scss ***!
  \***********************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  --z-index-negative: -1;
  --z-index-base: 0;
  --z-overflow-scroll-button: 1;
  --z-index-expand-collapse: 2;
  --z-index-maximize-block: 3;
  --z-navigation-bar: 5;
  --z-index-task-list: 6;
  --z-index-task-collapse-area: 7;
  --z-index-wrap-up: 7;
  --z-index-menu-overlay: 8;
  --z-index-dynamic-area-overflow: 9;
  --z-index-notification: 1041;
  --z-index-sticky-header: 11;
  --z-index-popover: 1030;
  --z-index-modal: 1040;
  --z-index-full-overlay: 1050;
  --z-index-app-full-overlay: 1060;
  --z-index-modal-error: 1100;
  --z-index-connection-lost: 1150;
}

:host .list {
  bottom: 0;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: var(--z-index-modal, 2);
}
:host .list.d-none {
  display: none !important;
}
/*# sourceURL=/home/jenkins/agent/workspace/cicd-jobs/wxcc-common-CI-Builder/packages/@uuip/unified-ui-platform-common-components/src/assets/styles/z-index.scss */
/*# sourceURL=ModalNotificationsHost.scss */
/*# sourceURL=/home/jenkins/agent/workspace/cicd-jobs/wxcc-common-CI-Builder/packages/@uuip/unified-ui-platform-common-components/src/components/Notifications/components/ModalNotification/ModalNotificationsHost.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/Notifications/components/ModalNotification/ModalNotificationsHost.ts":
/*!*********************************************************************************************!*\
  !*** ./src/components/Notifications/components/ModalNotification/ModalNotificationsHost.ts ***!
  \*********************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ModalNotificationsHost: () => (/* binding */ ModalNotificationsHost)
/* harmony export */ });
/* harmony import */ var _ModalNotification__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./ModalNotification */ "./src/components/Notifications/components/ModalNotification/ModalNotification.ts");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lit-html/directives/class-map */ "lit-html/directives/class-map");
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _ModalNotificationsHost_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./ModalNotificationsHost.scss */ "./src/components/Notifications/components/ModalNotification/ModalNotificationsHost.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};






var ModalNotificationsHost;
(function (ModalNotificationsHost) {
    /**
     * @element uuip-wc-modal-notifications-host
     */
    let Element = class Element extends lit_element__WEBPACK_IMPORTED_MODULE_2__.LitElement {
        constructor() {
            super(...arguments);
            this.notifications = [];
        }
        static get styles() {
            return [_ModalNotificationsHost_scss__WEBPACK_IMPORTED_MODULE_5__["default"]];
        }
        get notification() {
            return this.notifications.length ? this.notifications[0] : null;
        }
        render() {
            const listClassInfo = {
                ["d-none"]: !this.notification
            };
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
        <div class="list ${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_4__.classMap)(listClassInfo)}">
          ${this.notification
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
                <uuip-wc-modal-notification .notification="${this.notification}"></uuip-wc-modal-notification>
              `
                : lit_html__WEBPACK_IMPORTED_MODULE_3__.nothing}
        </div>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Array })
    ], Element.prototype, "notifications", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.customElement)("uuip-wc-modal-notifications-host")
    ], Element);
    ModalNotificationsHost.Element = Element;
})(ModalNotificationsHost || (ModalNotificationsHost = {}));


/***/ }),

/***/ "./src/components/Notifications/components/ToasterNotification/Content/ToasterNotificationItemContent.scss":
/*!*****************************************************************************************************************!*\
  !*** ./src/components/Notifications/components/ToasterNotification/Content/ToasterNotificationItemContent.scss ***!
  \*****************************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  /* Font family */
  --font-family: var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial, sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "CiscoSansTT Light", "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
}

:host(uuip-wc-toaster-notification-item-content) {
  display: flex;
  flex: 1 1 100%;
}

.wc-notification-menu-item md-badge {
  display: block;
}
.wc-notification-menu-item md-badge::part(badge) {
  overflow: hidden;
}
.wc-notification-menu-item .notification-slotted {
  display: inline-block;
  min-width: 25px;
  min-height: 25px;
}

.wc-notification-message {
  /* stylelint-disable */
  -webkit-box-orient: vertical;
  display: -webkit-box;
  -webkit-line-clamp: var(--lineClamp);
  line-clamp: var(--lineClamp);
  /* stylelint-enable */
  overflow: hidden;
  margin: 0;
  width: 100%;
}

.wc-notification-slotted-body {
  padding-bottom: 2px;
  width: 98%;
}

.wc-notification-button:not(:first-child) {
  margin-left: 6px;
}

.wc-notification-link {
  padding-left: 2px;
}
.wc-notification-link p {
  /* stylelint-disable */
  -webkit-box-orient: vertical;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  /* stylelint-enable */
  word-break: break-all;
  overflow: hidden;
  margin: 0;
  width: 100%;
}

md-alert::part(alert) {
  min-height: 4rem;
  place-content: normal;
  margin-bottom: 0;
}

:host([toast]) .wc-notification-menu-item md-badge::part(badge) {
  padding: 0.3rem;
  width: 1.8rem;
  height: 1.8rem;
}

.wc-notification-cursor-pointer {
  cursor: pointer;
}

.wc-notification-badge-image {
  width: 1.5rem;
}
/*# sourceURL=/home/jenkins/agent/workspace/cicd-jobs/wxcc-common-CI-Builder/packages/@uuip/unified-ui-platform-common-components/src/assets/styles/variables.scss */
/*# sourceURL=ToasterNotificationItemContent.scss */
/*# sourceURL=/home/jenkins/agent/workspace/cicd-jobs/wxcc-common-CI-Builder/packages/@uuip/unified-ui-platform-common-components/src/components/Notifications/components/ToasterNotification/Content/ToasterNotificationItemContent.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/Notifications/components/ToasterNotification/Content/ToasterNotificationItemContent.ts":
/*!***************************************************************************************************************!*\
  !*** ./src/components/Notifications/components/ToasterNotification/Content/ToasterNotificationItemContent.ts ***!
  \***************************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ToasterNotificationItemContent: () => (/* binding */ ToasterNotificationItemContent)
/* harmony export */ });
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-html/directives/if-defined */ "lit-html/directives/if-defined");
/* harmony import */ var lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _ToasterNotificationItemContent_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./ToasterNotificationItemContent.scss */ "./src/components/Notifications/components/ToasterNotification/Content/ToasterNotificationItemContent.scss");
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @uuip/unified-ui-platform-sdk */ "@uuip/unified-ui-platform-sdk");
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var lit_html_directives_unsafe_html__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! lit-html/directives/unsafe-html */ "lit-html/directives/unsafe-html");
/* harmony import */ var lit_html_directives_unsafe_html__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_unsafe_html__WEBPACK_IMPORTED_MODULE_6__);
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};







var ToasterNotificationItemContent;
(function (ToasterNotificationItemContent) {
    class DataController extends _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_5__.NotificationItemsContent.DataController {
    }
    ToasterNotificationItemContent.DataController = DataController;
    ToasterNotificationItemContent.FullTextTransientNotification = "full_text_transient_notification"; // Represents a notification with full text that doesn't persist/is marked as read
    let Element = class Element extends lit_element__WEBPACK_IMPORTED_MODULE_1__.LitElement {
        constructor() {
            super(...arguments);
            this.toast = false;
        }
        static get styles() {
            return [_ToasterNotificationItemContent_scss__WEBPACK_IMPORTED_MODULE_4__["default"]];
        }
        get hasDataController() {
            return (typeof this.notification.data === "object" &&
                this.notification.data !== null &&
                this.notification.data.type !== ToasterNotificationItemContent.FullTextTransientNotification);
        }
        get dataController() {
            return this.hasDataController ? this.notification.data : null;
        }
        get notificationData() {
            return this.notification.data;
        }
        get message() {
            if (typeof this.notification.data === "object" && this.notification.data.type === ToasterNotificationItemContent.FullTextTransientNotification) {
                return this.notification.data.text;
            }
            return this.notification.data;
        }
        get iconSize() {
            return this.toast ? undefined : "12";
        }
        get linkHref() {
            var _a;
            return ((_a = this.dataController) === null || _a === void 0 ? void 0 : _a.link) && !this.hasLinkHandler ? this.dataController.link : undefined;
        }
        get linkText() {
            var _a, _b;
            return ((_a = this.dataController) === null || _a === void 0 ? void 0 : _a.linkName) ? this.dataController.linkName : (_b = this.dataController) === null || _b === void 0 ? void 0 : _b.link;
        }
        get hasLinkHandler() {
            var _a;
            return typeof ((_a = this.dataController) === null || _a === void 0 ? void 0 : _a.linkHandler) === "function";
        }
        get hasClickHandler() {
            var _a;
            return typeof ((_a = this.dataController) === null || _a === void 0 ? void 0 : _a.clickHandler) === "function";
        }
        handleLinkClick(e) {
            var _a;
            if (this.hasLinkHandler) {
                e.preventDefault();
                (_a = this.dataController) === null || _a === void 0 ? void 0 : _a.linkHandler(this.notification);
            }
        }
        handleAlertClick() {
            var _a;
            if (this.hasClickHandler) {
                (_a = this.dataController) === null || _a === void 0 ? void 0 : _a.clickHandler(this.notification);
            }
        }
        get hasErrorDetail() {
            var _a;
            return !!((_a = this.dataController) === null || _a === void 0 ? void 0 : _a.errorDetail);
        }
        get errorDetailHeader() {
            var _a, _b, _c;
            return ((_b = (_a = this.dataController) === null || _a === void 0 ? void 0 : _a.errorDetail) === null || _b === void 0 ? void 0 : _b.header) ? (_c = this.dataController) === null || _c === void 0 ? void 0 : _c.errorDetail.header : undefined;
        }
        get errorDetailTrackingId() {
            var _a, _b, _c;
            return ((_b = (_a = this.dataController) === null || _a === void 0 ? void 0 : _a.errorDetail) === null || _b === void 0 ? void 0 : _b.trackingId) ? (_c = this.dataController) === null || _c === void 0 ? void 0 : _c.errorDetail.trackingId : undefined;
        }
        get errorDetailMessage() {
            var _a, _b;
            return (_b = (_a = this.dataController) === null || _a === void 0 ? void 0 : _a.errorDetail) === null || _b === void 0 ? void 0 : _b.message;
        }
        get errorDetailLocalization() {
            var _a, _b;
            return (_b = (_a = this.dataController) === null || _a === void 0 ? void 0 : _a.errorDetail) === null || _b === void 0 ? void 0 : _b.localization;
        }
        get iconDetail() {
            var _a, _b;
            return ((_a = this.dataController) === null || _a === void 0 ? void 0 : _a.iconDetail) ? (_b = this.dataController) === null || _b === void 0 ? void 0 : _b.iconDetail : undefined;
        }
        get hasIconName() {
            var _a, _b;
            return !!((_b = (_a = this.dataController) === null || _a === void 0 ? void 0 : _a.iconDetail) === null || _b === void 0 ? void 0 : _b.iconName);
        }
        get hasIconUrl() {
            var _a, _b;
            return !!((_b = (_a = this.dataController) === null || _a === void 0 ? void 0 : _a.iconDetail) === null || _b === void 0 ? void 0 : _b.iconUrl);
        }
        get closeButtonText() {
            var _a, _b, _c;
            return (_c = (_b = (_a = this.dataController) === null || _a === void 0 ? void 0 : _a.localization) === null || _b === void 0 ? void 0 : _b.closeButtonText) !== null && _c !== void 0 ? _c : "Close";
        }
        get hasActions() {
            var _a, _b, _c, _d;
            return Array.isArray((_a = this.dataController) === null || _a === void 0 ? void 0 : _a.actions) && ((_d = (_c = (_b = this.dataController) === null || _b === void 0 ? void 0 : _b.actions) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0) > 0;
        }
        renderActions() {
            var _a, _b;
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
        ${(_b = (_a = this.dataController) === null || _a === void 0 ? void 0 : _a.actions) === null || _b === void 0 ? void 0 : _b.map((action) => action ? this.renderButton(action.label, action.handler, action.variant) : "")}
      `;
        }
        renderButton(label, handler, variant) {
            if (label && handler) {
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
          <md-button class="wc-notification-button" variant="${variant}" @click="${() => handler(this.notification)}">
            ${label}
          </md-button>
        `;
            }
            return lit_html__WEBPACK_IMPORTED_MODULE_2__.nothing;
        }
        renderCustomIconTemplate() {
            var _a, _b, _c, _d, _e;
            const iconTemplate = (color, bgColor, iconName, iconColor, iconUrl, iconSize, iconSet = "preferMomentumDesign") => {
                const iconUrlContent = iconUrl ? (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) ` <img src=${iconUrl} class="wc-notification-badge-image" /> ` : lit_html__WEBPACK_IMPORTED_MODULE_2__.nothing;
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
          <md-badge
            slot="alert-icon"
            color=${(0,lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_3__.ifDefined)(color)}
            bgColor=${(0,lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_3__.ifDefined)(bgColor)}
            circle
            .small="${!this.toast}"
          >
            ${iconName
                    ? (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
                  <md-icon
                    .name=${iconName}
                    iconSet=${iconSet}
                    color=${(0,lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_3__.ifDefined)(iconColor)}
                    size=${(0,lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_3__.ifDefined)(iconSize)}
                  ></md-icon>
                `
                    : iconUrlContent}
          </md-badge>
        `;
            };
            if (this.iconDetail && (this.hasIconName || this.hasIconUrl)) {
                return iconTemplate((_a = this.iconDetail.color) !== null && _a !== void 0 ? _a : undefined, (_b = this.iconDetail.bgColor) !== null && _b !== void 0 ? _b : undefined, (_c = this.iconDetail.iconName) !== null && _c !== void 0 ? _c : undefined, (_d = this.iconDetail.iconColor) !== null && _d !== void 0 ? _d : undefined, (_e = this.iconDetail.iconUrl) !== null && _e !== void 0 ? _e : undefined, this.iconSize);
            }
            switch (this.notificationData.type) {
                case "sms":
                    return iconTemplate("darkmint", undefined, "sms_16", "white", undefined, this.iconSize);
                case "chat":
                    return iconTemplate("blue", undefined, "chat-active_16", undefined, undefined, this.iconSize);
                case "messenger":
                    return iconTemplate(undefined, "#0078FF", "messenger_16", "white", undefined, this.iconSize);
                case "twitter":
                    return iconTemplate(undefined, "#1DA1F2", "twitter_16", "white", undefined, this.iconSize);
                case "whatsapp":
                    return iconTemplate(undefined, "#25D366", "whatsApp_16", "white", undefined, this.iconSize);
                case "ai-assistant":
                    return iconTemplate(undefined, "transparent", "cisco-ai-assistant-color-gradient", undefined, undefined, "24", "momentumBrandVisuals");
                default:
                    return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
            <div slot="alert-icon" class="notification-slotted">
              <slot name="notif-icon"></slot>
            </div>
          `;
            }
        }
        renderNotificationLinkWithTooltip(tooltip) {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
        <md-tooltip placement="bottom">
          <div slot="tooltip-content">${this.getContent(tooltip)}</div>
          ${this.renderNotificationLink()}
        </md-tooltip>
      `;
        }
        renderNotificationLink() {
            if (this.linkText) {
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
          <md-link
            class="wc-notification-link"
            href=${(0,lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_3__.ifDefined)(this.linkHref)}
            target="${this.linkHref ? "_blank" : "_self"}"
            @click="${(e) => this.handleLinkClick(e)}"
          >
            <p>${this.linkText}</p>
          </md-link>
        `;
            }
            return lit_html__WEBPACK_IMPORTED_MODULE_2__.nothing;
        }
        /**
         * Using unsafeHTML for displaying the html markup when its passed as string
         */
        getContent(text) {
            if (typeof text === "string") {
                return (0,lit_html_directives_unsafe_html__WEBPACK_IMPORTED_MODULE_6__.unsafeHTML)(text);
            }
            return text;
        }
        getLineClamp() {
            var _a, _b;
            return ((_a = this.dataController) === null || _a === void 0 ? void 0 : _a.lineClamp) ? (_b = this.dataController) === null || _b === void 0 ? void 0 : _b.lineClamp : 3;
        }
        get renderContent() {
            var _a, _b, _c, _d;
            const clampStyle = `--lineClamp: ${this.getLineClamp()}`;
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
        ${((_a = this.dataController) === null || _a === void 0 ? void 0 : _a.type) || this.iconDetail ? (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) ` ${this.renderCustomIconTemplate()} ` : lit_html__WEBPACK_IMPORTED_MODULE_2__.nothing}
        <div
          slot="alert-body"
          class="${`wc-notification-slotted-body ${this.hasClickHandler && "wc-notification-cursor-pointer"}`}"
          @click="${this.handleAlertClick}"
        >
          <p class="wc-notification-message" style=${clampStyle}>${this.getContent((_c = (_b = this.dataController) === null || _b === void 0 ? void 0 : _b.text) !== null && _c !== void 0 ? _c : "")}</p>
          ${(this.linkHref || this.hasLinkHandler) && ((_d = this.dataController) === null || _d === void 0 ? void 0 : _d.linkTooltip)
                ? this.renderNotificationLinkWithTooltip(this.dataController.linkTooltip)
                : this.renderNotificationLink()}
          ${this.hasErrorDetail ? this.renderErrorDetail : lit_html__WEBPACK_IMPORTED_MODULE_2__.nothing}
        </div>
        ${this.hasActions ? this.renderFooter : lit_html__WEBPACK_IMPORTED_MODULE_2__.nothing}
      `;
        }
        get renderErrorDetail() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
        <uuip-wc-error-detail
          format="toaster"
          header=${(0,lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_3__.ifDefined)(this.errorDetailHeader)}
          trackingId=${(0,lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_3__.ifDefined)(this.errorDetailTrackingId)}
          .message=${this.errorDetailMessage ? this.errorDetailMessage : ""}
          .localization="${this.errorDetailLocalization ? this.errorDetailLocalization : {}}"
        ></uuip-wc-error-detail>
      `;
        }
        get renderFooter() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) ` <div slot="alert-footer">${this.renderActions()}</div> `;
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
        <md-alert
          title=${this.notification.title}
          type=${this.notification.type}
          message=${(0,lit_html_directives_if_defined__WEBPACK_IMPORTED_MODULE_3__.ifDefined)(!this.hasDataController ? this.message : undefined)}
          show
          newMomentum
          .internalClose="${false}"
          .closable="${this.toast}"
          .inline="${!this.toast}"
          btnlabel="${this.closeButtonText}"
          class="wc-notification-menu-item"
          @alert-close="${() => {
                var _a, _b;
                this.notification.pending();
                if ((_a = this.dataController) === null || _a === void 0 ? void 0 : _a.dismissHandler) {
                    (_b = this.dataController) === null || _b === void 0 ? void 0 : _b.dismissHandler(this.notification);
                }
            }}"
        >
          ${this.dataController ? this.renderContent : lit_html__WEBPACK_IMPORTED_MODULE_2__.nothing}
        </md-alert>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Object })
    ], Element.prototype, "notification", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Boolean })
    ], Element.prototype, "toast", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.customElement)("uuip-wc-toaster-notification-item-content")
    ], Element);
    ToasterNotificationItemContent.Element = Element;
})(ToasterNotificationItemContent || (ToasterNotificationItemContent = {}));


/***/ }),

/***/ "./src/components/Notifications/components/ToasterNotification/ToasterNotification.scss":
/*!**********************************************************************************************!*\
  !*** ./src/components/Notifications/components/ToasterNotification/ToasterNotification.scss ***!
  \**********************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  --animation-duration: 350ms;
  --animation-timing-function: ease-out;
  --default-transform: translate3d(0, 0, 0);
  --left-transform: translate3d(calc(-100% - 0.5rem), 0, 0);
  --right-transform: translate3d(calc(100% + 0.5rem), 0, 0);
  width: 100%;
  height: auto;
  will-change: transform;
}
:host .toaster {
  margin: 0.25rem 0;
  padding: 0;
  width: 23rem;
}

:host([position=top-left]),
:host([position=left]),
:host([position=bottom-left]) {
  transform: var(--left-transform);
}

:host([position=top-left][appear]),
:host([position=left][appear]),
:host([position=bottom-left][appear]) {
  transform: var(--default-transform);
  animation-name: appear-left;
  animation-timing-function: var(--animation-timing-function);
  animation-duration: var(--animation-duration);
}

:host([position=top-left][appear][wasAppeared]),
:host([position=left][appear][wasAppeared]),
:host([position=bottom-left][appear][wasAppeared]) {
  animation: none;
}

:host([position=top-left][appear][wasAppeared][disappear]),
:host([position=left][appear][wasAppeared][disappear]),
:host([position=bottom-left][appear][wasAppeared][disappear]) {
  transform: var(--left-transform);
  animation-name: disappear-left;
  animation-timing-function: var(--animation-timing-function);
  animation-duration: var(--animation-duration);
}

@keyframes appear-left {
  0% {
    transform: var(--left-transform);
  }
  100% {
    transform: var(--default-transform);
  }
}
@keyframes disappear-left {
  0% {
    transform: var(--default-transform);
  }
  100% {
    transform: var(--left-transform);
  }
}
:host([position=top-right]),
:host([position=right]),
:host([position=bottom-right]) {
  transform: var(--right-transform);
}

:host([position=top-right][appear]),
:host([position=right][appear]),
:host([position=bottom-right][appear]) {
  transform: var(--default-transform);
  animation-name: appear-right;
  animation-timing-function: var(--animation-timing-function);
  animation-duration: var(--animation-duration);
}

:host([position=top-right][appear][wasAppeared]),
:host([position=right][appear][wasAppeared]),
:host([position=bottom-right][appear][wasAppeared]) {
  animation: none;
}

:host([position=top-right][appear][wasAppeared][disappear]),
:host([position=right][appear][wasAppeared][disappear]),
:host([position=bottom-right][appear][wasAppeared][disappear]) {
  transform: var(--right-transform);
  animation-name: disappear-right;
  animation-timing-function: var(--animation-timing-function);
  animation-duration: var(--animation-duration);
}

@keyframes appear-right {
  0% {
    transform: var(--right-transform);
  }
  100% {
    transform: var(--default-transform);
  }
}
@keyframes disappear-right {
  0% {
    transform: var(--default-transform);
  }
  100% {
    transform: var(--right-transform);
  }
}
/*# sourceURL=/home/jenkins/agent/workspace/cicd-jobs/wxcc-common-CI-Builder/packages/@uuip/unified-ui-platform-common-components/src/components/Notifications/components/ToasterNotification/ToasterNotification.scss */
/*# sourceURL=ToasterNotification.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/Notifications/components/ToasterNotification/ToasterNotification.ts":
/*!********************************************************************************************!*\
  !*** ./src/components/Notifications/components/ToasterNotification/ToasterNotification.ts ***!
  \********************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ToasterNotification: () => (/* binding */ ToasterNotification)
/* harmony export */ });
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @uuip/unified-ui-platform-sdk */ "@uuip/unified-ui-platform-sdk");
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _ToasterNotification_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./ToasterNotification.scss */ "./src/components/Notifications/components/ToasterNotification/ToasterNotification.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var ToasterNotification;
(function (ToasterNotification) {
    const ANIMATION_DISABLED_CHECK_TIMEOUT = 2000; //ms - applying when "animationend" event was not fired after status change
    /**
     * @element uuip-wc-toaster-notification
     * @fires appeared
     * @fires disappeared
     */
    let Element = class Element extends lit_element__WEBPACK_IMPORTED_MODULE_2__.LitElement {
        constructor() {
            super(...arguments);
            this.position = "top-right";
            this.wasAppeared = false;
            this.appear = true;
            this.disappear = false;
            this.animationDisabledTimeoutRef = undefined;
            this.onAnimationEnd = () => {
                if (this.disappear) {
                    this.emit("disappeared", { notification: this.notification });
                }
                else {
                    if (!this.wasAppeared && this.appear) {
                        this.emit("appeared", { notification: this.notification });
                    }
                }
                this.removeAnimationDisabledCheck();
            };
            this.onStatusUpdate = (status, _reason) => {
                const wasDisappear = this.disappear;
                if (status !== _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_1__.Notifications.ItemMeta.Status.Activated) {
                    this.disappear = true;
                }
                if (!wasDisappear) {
                    this.setAnimationDisabledCheck();
                }
            };
        }
        static get styles() {
            return [_ToasterNotification_scss__WEBPACK_IMPORTED_MODULE_3__["default"]];
        }
        connectedCallback() {
            super.connectedCallback();
            this.addEventListener("animationend", this.onAnimationEnd);
            this.notification.addEventListener("statusUpdate", this.onStatusUpdate);
        }
        updated(changedProperties) {
            super.updated(changedProperties);
            changedProperties.forEach((oldValue, name) => {
                if (name === "appear") {
                    if (this.appear !== oldValue) {
                        if (this.appear) {
                            this.setAttribute("appear", "");
                        }
                        else {
                            this.removeAttribute("appear");
                        }
                    }
                }
                if (name === "disappear") {
                    if (this.disappear !== oldValue) {
                        if (this.disappear) {
                            this.setAttribute("disappear", "");
                        }
                        else {
                            this.removeAttribute("disappear");
                        }
                    }
                }
            });
        }
        disconnectedCallback() {
            super.disconnectedCallback();
            this.removeAnimationDisabledCheck();
            this.removeEventListener("animationend", this.onAnimationEnd);
            this.notification.removeEventListener("statusUpdate", this.onStatusUpdate);
        }
        setAnimationDisabledCheck() {
            this.removeAnimationDisabledCheck();
            this.animationDisabledTimeoutRef = window.setTimeout(() => this.onAnimationEnd(), ANIMATION_DISABLED_CHECK_TIMEOUT);
        }
        removeAnimationDisabledCheck() {
            window.clearTimeout(this.animationDisabledTimeoutRef);
            this.animationDisabledTimeoutRef = undefined;
        }
        emit(eventName, detail, bubbles = false, composed = false, cancelable = true) {
            this.dispatchEvent(new CustomEvent(eventName, {
                detail,
                bubbles,
                composed,
                cancelable
            }));
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.html) `
        <div class="toaster">
          <uuip-wc-toaster-notification-item-content
            toast
            .notification="${this.notification}"
          ></uuip-wc-toaster-notification-item-content>
        </div>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Object })
    ], Element.prototype, "notification", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: String, reflect: true })
    ], Element.prototype, "position", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.property)({ type: Boolean, reflect: true })
    ], Element.prototype, "wasAppeared", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.internalProperty)()
    ], Element.prototype, "appear", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.internalProperty)()
    ], Element.prototype, "disappear", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_2__.customElement)("uuip-wc-toaster-notification")
    ], Element);
    ToasterNotification.Element = Element;
})(ToasterNotification || (ToasterNotification = {}));


/***/ }),

/***/ "./src/components/Notifications/components/ToasterNotification/ToasterNotificationsHost.scss":
/*!***************************************************************************************************!*\
  !*** ./src/components/Notifications/components/ToasterNotification/ToasterNotificationsHost.scss ***!
  \***************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  --z-index-negative: -1;
  --z-index-base: 0;
  --z-overflow-scroll-button: 1;
  --z-index-expand-collapse: 2;
  --z-index-maximize-block: 3;
  --z-navigation-bar: 5;
  --z-index-task-list: 6;
  --z-index-task-collapse-area: 7;
  --z-index-wrap-up: 7;
  --z-index-menu-overlay: 8;
  --z-index-dynamic-area-overflow: 9;
  --z-index-notification: 1041;
  --z-index-sticky-header: 11;
  --z-index-popover: 1030;
  --z-index-modal: 1040;
  --z-index-full-overlay: 1050;
  --z-index-app-full-overlay: 1060;
  --z-index-modal-error: 1100;
  --z-index-connection-lost: 1150;
}

:host .list {
  display: flex;
  position: fixed;
  width: auto;
  z-index: var(--z-index-notification, 1041);
  overflow: visible;
  padding: 0.5rem;
}
:host .list.d-none {
  display: none !important;
}
:host .list.top-left {
  left: 0;
  top: 4rem;
  flex-direction: column;
}
:host .list.top {
  left: calc(50% - 12rem);
  top: 4rem;
  flex-direction: column;
}
:host .list.top-right {
  right: 1.5rem;
  top: 4rem;
  flex-direction: column;
}
:host .list.bottom-left {
  bottom: 0;
  left: 0;
  flex-direction: column-reverse;
}
:host .list.bottom {
  bottom: 0;
  left: calc(50% - 12rem);
  flex-direction: column-reverse;
}
:host .list.bottom-right {
  bottom: 0;
  right: 0;
  flex-direction: column-reverse;
}
:host .list.height-auto {
  height: auto;
}
:host .list.height-25 {
  height: 25vh;
}
:host .list.height-33 {
  height: 33.3334vh;
}
:host .list.height-50 {
  height: 50vh;
}
:host .list.height-66 {
  height: 66.6668vh;
}
:host .list.height-75 {
  height: 75vh;
}
:host .list.height-100 {
  height: 100vh;
}
/*# sourceURL=/home/jenkins/agent/workspace/cicd-jobs/wxcc-common-CI-Builder/packages/@uuip/unified-ui-platform-common-components/src/assets/styles/z-index.scss */
/*# sourceURL=ToasterNotificationsHost.scss */
/*# sourceURL=/home/jenkins/agent/workspace/cicd-jobs/wxcc-common-CI-Builder/packages/@uuip/unified-ui-platform-common-components/src/components/Notifications/components/ToasterNotification/ToasterNotificationsHost.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL2plbmtpbnMvYWdlbnQvd29ya3NwYWNlL2NpY2Qtam9icy93eGNjLWNvbW1vbi1DSS1CdWlsZGVyL3BhY2thZ2VzL0B1dWlwL3VuaWZpZWQtdWktcGxhdGZvcm0tY29tbW9uLWNvbXBvbmVudHMvc3JjL2Fzc2V0cy9zdHlsZXMvei1pbmRleC5zY3NzIiwiVG9hc3Rlck5vdGlmaWNhdGlvbnNIb3N0LnNjc3MiLCIvaG9tZS9qZW5raW5zL2FnZW50L3dvcmtzcGFjZS9jaWNkLWpvYnMvd3hjYy1jb21tb24tQ0ktQnVpbGRlci9wYWNrYWdlcy9AdXVpcC91bmlmaWVkLXVpLXBsYXRmb3JtLWNvbW1vbi1jb21wb25lbnRzL3NyYy9jb21wb25lbnRzL05vdGlmaWNhdGlvbnMvY29tcG9uZW50cy9Ub2FzdGVyTm90aWZpY2F0aW9uL1RvYXN0ZXJOb3RpZmljYXRpb25zSG9zdC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0Usc0JBQUE7RUFDQSxpQkFBQTtFQUNBLDZCQUFBO0VBRUEsNEJBQUE7RUFDQSwyQkFBQTtFQUVBLHFCQUFBO0VBQ0Esc0JBQUE7RUFFQSwrQkFBQTtFQUNBLG9CQUFBO0VBQ0EseUJBQUE7RUFDQSxrQ0FBQTtFQUNBLDRCQUFBO0VBQ0EsMkJBQUE7RUFFQSx1QkFBQTtFQUNBLHFCQUFBO0VBRUEsNEJBQUE7RUFDQSxnQ0FBQTtFQUVBLDJCQUFBO0VBQ0EsK0JBQUE7QUNMRjs7QUNkRTtFQUNFLGFBQUE7RUFDQSxlQUFBO0VBQ0EsV0FBQTtFQUNBLDBDQUFBO0VBRUEsaUJBQUE7RUFDQSxlQUFBO0FEZ0JKO0FDZEk7RUFDRSx3QkFBQTtBRGdCTjtBQ2JJO0VBQ0UsT0FBQTtFQUNBLFNBakJXO0VBa0JYLHNCQUFBO0FEZU47QUNaSTtFQUNFLHVCQUFBO0VBQ0EsU0F2Qlc7RUF3Qlgsc0JBQUE7QURjTjtBQ1hJO0VBQ0UsYUFBQTtFQUNBLFNBN0JXO0VBOEJYLHNCQUFBO0FEYU47QUNWSTtFQUNFLFNBQUE7RUFDQSxPQUFBO0VBQ0EsOEJBQUE7QURZTjtBQ1RJO0VBQ0UsU0FBQTtFQUNBLHVCQUFBO0VBQ0EsOEJBQUE7QURXTjtBQ1JJO0VBQ0UsU0FBQTtFQUNBLFFBQUE7RUFDQSw4QkFBQTtBRFVOO0FDUEk7RUFDRSxZQUFBO0FEU047QUNOSTtFQUNFLFlBQUE7QURRTjtBQ0xJO0VBQ0UsaUJBQUE7QURPTjtBQ0pJO0VBQ0UsWUFBQTtBRE1OO0FDSEk7RUFDRSxpQkFBQTtBREtOO0FDRkk7RUFDRSxZQUFBO0FESU47QUNESTtFQUNFLGFBQUE7QURHTiIsImZpbGUiOiJUb2FzdGVyTm90aWZpY2F0aW9uc0hvc3Quc2NzcyIsInNvdXJjZXNDb250ZW50IjpbIjpob3N0IHtcclxuICAtLXotaW5kZXgtbmVnYXRpdmU6IC0xO1xyXG4gIC0tei1pbmRleC1iYXNlOiAwO1xyXG4gIC0tei1vdmVyZmxvdy1zY3JvbGwtYnV0dG9uOiAxO1xyXG5cclxuICAtLXotaW5kZXgtZXhwYW5kLWNvbGxhcHNlOiAyO1xyXG4gIC0tei1pbmRleC1tYXhpbWl6ZS1ibG9jazogMztcclxuXHJcbiAgLS16LW5hdmlnYXRpb24tYmFyOiA1O1xyXG4gIC0tei1pbmRleC10YXNrLWxpc3Q6IDY7XHJcblxyXG4gIC0tei1pbmRleC10YXNrLWNvbGxhcHNlLWFyZWE6IDc7XHJcbiAgLS16LWluZGV4LXdyYXAtdXA6IDc7XHJcbiAgLS16LWluZGV4LW1lbnUtb3ZlcmxheTogODtcclxuICAtLXotaW5kZXgtZHluYW1pYy1hcmVhLW92ZXJmbG93OiA5O1xyXG4gIC0tei1pbmRleC1ub3RpZmljYXRpb246IDEwNDE7XHJcbiAgLS16LWluZGV4LXN0aWNreS1oZWFkZXI6IDExO1xyXG5cclxuICAtLXotaW5kZXgtcG9wb3ZlcjogMTAzMDtcclxuICAtLXotaW5kZXgtbW9kYWw6IDEwNDA7XHJcblxyXG4gIC0tei1pbmRleC1mdWxsLW92ZXJsYXk6IDEwNTA7XHJcbiAgLS16LWluZGV4LWFwcC1mdWxsLW92ZXJsYXk6IDEwNjA7XHJcblxyXG4gIC0tei1pbmRleC1tb2RhbC1lcnJvcjogMTEwMDtcclxuICAtLXotaW5kZXgtY29ubmVjdGlvbi1sb3N0OiAxMTUwO1xyXG59IiwiOmhvc3Qge1xuICAtLXotaW5kZXgtbmVnYXRpdmU6IC0xO1xuICAtLXotaW5kZXgtYmFzZTogMDtcbiAgLS16LW92ZXJmbG93LXNjcm9sbC1idXR0b246IDE7XG4gIC0tei1pbmRleC1leHBhbmQtY29sbGFwc2U6IDI7XG4gIC0tei1pbmRleC1tYXhpbWl6ZS1ibG9jazogMztcbiAgLS16LW5hdmlnYXRpb24tYmFyOiA1O1xuICAtLXotaW5kZXgtdGFzay1saXN0OiA2O1xuICAtLXotaW5kZXgtdGFzay1jb2xsYXBzZS1hcmVhOiA3O1xuICAtLXotaW5kZXgtd3JhcC11cDogNztcbiAgLS16LWluZGV4LW1lbnUtb3ZlcmxheTogODtcbiAgLS16LWluZGV4LWR5bmFtaWMtYXJlYS1vdmVyZmxvdzogOTtcbiAgLS16LWluZGV4LW5vdGlmaWNhdGlvbjogMTA0MTtcbiAgLS16LWluZGV4LXN0aWNreS1oZWFkZXI6IDExO1xuICAtLXotaW5kZXgtcG9wb3ZlcjogMTAzMDtcbiAgLS16LWluZGV4LW1vZGFsOiAxMDQwO1xuICAtLXotaW5kZXgtZnVsbC1vdmVybGF5OiAxMDUwO1xuICAtLXotaW5kZXgtYXBwLWZ1bGwtb3ZlcmxheTogMTA2MDtcbiAgLS16LWluZGV4LW1vZGFsLWVycm9yOiAxMTAwO1xuICAtLXotaW5kZXgtY29ubmVjdGlvbi1sb3N0OiAxMTUwO1xufVxuXG46aG9zdCAubGlzdCB7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIHBvc2l0aW9uOiBmaXhlZDtcbiAgd2lkdGg6IGF1dG87XG4gIHotaW5kZXg6IHZhcigtLXotaW5kZXgtbm90aWZpY2F0aW9uLCAxMDQxKTtcbiAgb3ZlcmZsb3c6IHZpc2libGU7XG4gIHBhZGRpbmc6IDAuNXJlbTtcbn1cbjpob3N0IC5saXN0LmQtbm9uZSB7XG4gIGRpc3BsYXk6IG5vbmUgIWltcG9ydGFudDtcbn1cbjpob3N0IC5saXN0LnRvcC1sZWZ0IHtcbiAgbGVmdDogMDtcbiAgdG9wOiA0cmVtO1xuICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xufVxuOmhvc3QgLmxpc3QudG9wIHtcbiAgbGVmdDogY2FsYyg1MCUgLSAxMnJlbSk7XG4gIHRvcDogNHJlbTtcbiAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcbn1cbjpob3N0IC5saXN0LnRvcC1yaWdodCB7XG4gIHJpZ2h0OiAxLjVyZW07XG4gIHRvcDogNHJlbTtcbiAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcbn1cbjpob3N0IC5saXN0LmJvdHRvbS1sZWZ0IHtcbiAgYm90dG9tOiAwO1xuICBsZWZ0OiAwO1xuICBmbGV4LWRpcmVjdGlvbjogY29sdW1uLXJldmVyc2U7XG59XG46aG9zdCAubGlzdC5ib3R0b20ge1xuICBib3R0b206IDA7XG4gIGxlZnQ6IGNhbGMoNTAlIC0gMTJyZW0pO1xuICBmbGV4LWRpcmVjdGlvbjogY29sdW1uLXJldmVyc2U7XG59XG46aG9zdCAubGlzdC5ib3R0b20tcmlnaHQge1xuICBib3R0b206IDA7XG4gIHJpZ2h0OiAwO1xuICBmbGV4LWRpcmVjdGlvbjogY29sdW1uLXJldmVyc2U7XG59XG46aG9zdCAubGlzdC5oZWlnaHQtYXV0byB7XG4gIGhlaWdodDogYXV0bztcbn1cbjpob3N0IC5saXN0LmhlaWdodC0yNSB7XG4gIGhlaWdodDogMjV2aDtcbn1cbjpob3N0IC5saXN0LmhlaWdodC0zMyB7XG4gIGhlaWdodDogMzMuMzMzNHZoO1xufVxuOmhvc3QgLmxpc3QuaGVpZ2h0LTUwIHtcbiAgaGVpZ2h0OiA1MHZoO1xufVxuOmhvc3QgLmxpc3QuaGVpZ2h0LTY2IHtcbiAgaGVpZ2h0OiA2Ni42NjY4dmg7XG59XG46aG9zdCAubGlzdC5oZWlnaHQtNzUge1xuICBoZWlnaHQ6IDc1dmg7XG59XG46aG9zdCAubGlzdC5oZWlnaHQtMTAwIHtcbiAgaGVpZ2h0OiAxMDB2aDtcbn0iLCJAdXNlIFwiQGNzcy96LWluZGV4XCIgYXMgKjtcblxuOmhvc3Qge1xuICAkd2lkdGg6IDI0cmVtO1xuICAkdG9wLXBvc2l0aW9uOiA0cmVtO1xuXG4gIC5saXN0IHtcbiAgICBkaXNwbGF5OiBmbGV4O1xuICAgIHBvc2l0aW9uOiBmaXhlZDtcbiAgICB3aWR0aDogYXV0bztcbiAgICB6LWluZGV4OiB2YXIoLS16LWluZGV4LW5vdGlmaWNhdGlvbiwgMTA0MSk7XG4gICAgLy9vdmVyZmxvdyB2aXNpYmxlIGlzIG5lY2Vzc2FyeSBvciB0aGUgbm90aWZpY2F0aW9uIHNoYWRvdyB3aWxsIGJlIGN1dCBvZmZcbiAgICBvdmVyZmxvdzogdmlzaWJsZTtcbiAgICBwYWRkaW5nOiAwLjVyZW07XG5cbiAgICAmLmQtbm9uZSB7XG4gICAgICBkaXNwbGF5OiBub25lICFpbXBvcnRhbnQ7XG4gICAgfVxuXG4gICAgJi50b3AtbGVmdCB7XG4gICAgICBsZWZ0OiAwO1xuICAgICAgdG9wOiAkdG9wLXBvc2l0aW9uO1xuICAgICAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcbiAgICB9XG5cbiAgICAmLnRvcCB7XG4gICAgICBsZWZ0OiBjYWxjKDUwJSAtICN7JHdpZHRoICogMC41fSk7XG4gICAgICB0b3A6ICR0b3AtcG9zaXRpb247XG4gICAgICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICAgIH1cblxuICAgICYudG9wLXJpZ2h0IHtcbiAgICAgIHJpZ2h0OiAxLjVyZW07XG4gICAgICB0b3A6ICR0b3AtcG9zaXRpb247XG4gICAgICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICAgIH1cblxuICAgICYuYm90dG9tLWxlZnQge1xuICAgICAgYm90dG9tOiAwO1xuICAgICAgbGVmdDogMDtcbiAgICAgIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW4tcmV2ZXJzZTtcbiAgICB9XG5cbiAgICAmLmJvdHRvbSB7XG4gICAgICBib3R0b206IDA7XG4gICAgICBsZWZ0OiBjYWxjKDUwJSAtICN7JHdpZHRoICogMC41fSk7XG4gICAgICBmbGV4LWRpcmVjdGlvbjogY29sdW1uLXJldmVyc2U7XG4gICAgfVxuXG4gICAgJi5ib3R0b20tcmlnaHQge1xuICAgICAgYm90dG9tOiAwO1xuICAgICAgcmlnaHQ6IDA7XG4gICAgICBmbGV4LWRpcmVjdGlvbjogY29sdW1uLXJldmVyc2U7XG4gICAgfVxuXG4gICAgJi5oZWlnaHQtYXV0byB7XG4gICAgICBoZWlnaHQ6IGF1dG87XG4gICAgfVxuXG4gICAgJi5oZWlnaHQtMjUge1xuICAgICAgaGVpZ2h0OiAyNXZoO1xuICAgIH1cblxuICAgICYuaGVpZ2h0LTMzIHtcbiAgICAgIGhlaWdodDogMzMuMzMzNHZoO1xuICAgIH1cblxuICAgICYuaGVpZ2h0LTUwIHtcbiAgICAgIGhlaWdodDogNTB2aDtcbiAgICB9XG5cbiAgICAmLmhlaWdodC02NiB7XG4gICAgICBoZWlnaHQ6IDY2LjY2Njh2aDtcbiAgICB9XG5cbiAgICAmLmhlaWdodC03NSB7XG4gICAgICBoZWlnaHQ6IDc1dmg7XG4gICAgfVxuXG4gICAgJi5oZWlnaHQtMTAwIHtcbiAgICAgIGhlaWdodDogMTAwdmg7XG4gICAgfVxuICB9XG59XG4iXX0= */`);
    

/***/ }),

/***/ "./src/components/Notifications/components/ToasterNotification/ToasterNotificationsHost.ts":
/*!*************************************************************************************************!*\
  !*** ./src/components/Notifications/components/ToasterNotification/ToasterNotificationsHost.ts ***!
  \*************************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ToasterNotificationsHost: () => (/* binding */ ToasterNotificationsHost)
/* harmony export */ });
/* harmony import */ var _components_Notifications_components_ToasterNotification_Content_ToasterNotificationItemContent__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../components/Notifications/components/ToasterNotification/Content/ToasterNotificationItemContent */ "./src/components/Notifications/components/ToasterNotification/Content/ToasterNotificationItemContent.ts");
/* harmony import */ var _components_Notifications_components_ToasterNotification_ToasterNotification__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../components/Notifications/components/ToasterNotification/ToasterNotification */ "./src/components/Notifications/components/ToasterNotification/ToasterNotification.ts");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @momentum-ui/web-components */ "@momentum-ui/web-components");
/* harmony import */ var _momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_momentum_ui_web_components__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @uuip/unified-ui-platform-sdk */ "@uuip/unified-ui-platform-sdk");
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! lit-html/directives/class-map */ "lit-html/directives/class-map");
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! lit-html/directives/repeat */ "lit-html/directives/repeat");
/* harmony import */ var lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _ToasterNotificationsHost_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./ToasterNotificationsHost.scss */ "./src/components/Notifications/components/ToasterNotification/ToasterNotificationsHost.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};








var ToasterNotificationsHost;
(function (ToasterNotificationsHost) {
    /**
     * @element uuip-wc-toaster-notifications-host
     */
    let Element = class Element extends lit_element__WEBPACK_IMPORTED_MODULE_4__.LitElement {
        constructor() {
            super(...arguments);
            this.notifications = [];
            this.position = "top-right";
            this.height = "height-auto";
            this.renderNotifications = [];
            // Appear map need to prevent re-animatoin on repeat re-concilation
            this.appearedMap = {};
        }
        static get styles() {
            return _ToasterNotificationsHost_scss__WEBPACK_IMPORTED_MODULE_7__["default"];
        }
        updated(changedProperties) {
            super.updated(changedProperties);
            changedProperties.forEach((oldValue, name) => {
                if (name === "notifications") {
                    this.addToRenderNotifications();
                    // To be animated - removing from notifications handling in ToasterNotification onStatusUpdate
                }
            });
        }
        addToRenderNotifications() {
            const old_notifications = [...this.renderNotifications];
            let new_notifications = [];
            this.notifications.forEach(n => {
                const idx = old_notifications.findIndex(_n => _n.timestamp === n.timestamp);
                if (idx === -1) {
                    // Add New
                    new_notifications = [...old_notifications, n];
                }
                else {
                    // Update Existing
                    new_notifications = [
                        ...old_notifications.slice(0, idx),
                        n,
                        ...old_notifications.slice(idx + 1, old_notifications.length)
                    ];
                }
            });
            new_notifications.sort(_uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_3__.Notifications.Service.sortByTimestampsFn);
            if (new_notifications.length) {
                this.renderNotifications = [...new_notifications];
            }
        }
        removeFromRenderNotifications(n) {
            const idx = this.renderNotifications.findIndex(_n => _n.timestamp === n.timestamp);
            if (idx !== -1) {
                this.renderNotifications = [
                    ...this.renderNotifications.slice(0, idx),
                    ...this.renderNotifications.slice(idx + 1)
                ];
            }
        }
        render() {
            const listClassInfo = {
                [this.position]: this.position,
                [this.height]: this.height,
                ["d-none"]: !this.renderNotifications.length
            };
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
        <div part="host" class="list ${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_5__.classMap)(listClassInfo)}">
          <slot name="before-list"></slot>
          ${(0,lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_6__.repeat)(this.renderNotifications, n => n.timestamp, n => (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.html) `
                <uuip-wc-toaster-notification
                  .notification="${n}"
                  .wasAppeared="${this.appearedMap[n.timestamp]}"
                  @appeared="${(e) => {
                this.appearedMap[e.detail.notification.timestamp] = true;
            }}"
                  @disappeared="${(e) => {
                this.removeFromRenderNotifications(e.detail.notification);
            }}"
                ></uuip-wc-toaster-notification>
              `)}
          <slot name="after-list"></slot>
        </div>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: Array })
    ], Element.prototype, "notifications", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: String })
    ], Element.prototype, "position", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.property)({ type: String })
    ], Element.prototype, "height", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.internalProperty)()
    ], Element.prototype, "renderNotifications", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_4__.customElement)("uuip-wc-toaster-notifications-host")
    ], Element);
    ToasterNotificationsHost.Element = Element;
})(ToasterNotificationsHost || (ToasterNotificationsHost = {}));


/***/ }),

/***/ "./src/components/Notifications/index.ts":
/*!***********************************************!*\
  !*** ./src/components/Notifications/index.ts ***!
  \***********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ModalNotification: () => (/* reexport safe */ _components_ModalNotification_ModalNotification__WEBPACK_IMPORTED_MODULE_0__.ModalNotification),
/* harmony export */   ModalNotificationsHost: () => (/* reexport safe */ _components_ModalNotification_ModalNotificationsHost__WEBPACK_IMPORTED_MODULE_1__.ModalNotificationsHost),
/* harmony export */   NotificationsHost: () => (/* reexport safe */ _NotificationsHost__WEBPACK_IMPORTED_MODULE_5__.NotificationsHost),
/* harmony export */   ToasterNotification: () => (/* reexport safe */ _components_ToasterNotification_ToasterNotification__WEBPACK_IMPORTED_MODULE_3__.ToasterNotification),
/* harmony export */   ToasterNotificationItemContent: () => (/* reexport safe */ _components_ToasterNotification_Content_ToasterNotificationItemContent__WEBPACK_IMPORTED_MODULE_2__.ToasterNotificationItemContent),
/* harmony export */   ToasterNotificationsHost: () => (/* reexport safe */ _components_ToasterNotification_ToasterNotificationsHost__WEBPACK_IMPORTED_MODULE_4__.ToasterNotificationsHost)
/* harmony export */ });
/* harmony import */ var _components_ModalNotification_ModalNotification__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./components/ModalNotification/ModalNotification */ "./src/components/Notifications/components/ModalNotification/ModalNotification.ts");
/* harmony import */ var _components_ModalNotification_ModalNotificationsHost__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./components/ModalNotification/ModalNotificationsHost */ "./src/components/Notifications/components/ModalNotification/ModalNotificationsHost.ts");
/* harmony import */ var _components_ToasterNotification_Content_ToasterNotificationItemContent__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./components/ToasterNotification/Content/ToasterNotificationItemContent */ "./src/components/Notifications/components/ToasterNotification/Content/ToasterNotificationItemContent.ts");
/* harmony import */ var _components_ToasterNotification_ToasterNotification__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./components/ToasterNotification/ToasterNotification */ "./src/components/Notifications/components/ToasterNotification/ToasterNotification.ts");
/* harmony import */ var _components_ToasterNotification_ToasterNotificationsHost__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./components/ToasterNotification/ToasterNotificationsHost */ "./src/components/Notifications/components/ToasterNotification/ToasterNotificationsHost.ts");
/* harmony import */ var _NotificationsHost__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./NotificationsHost */ "./src/components/Notifications/NotificationsHost.ts");









/***/ }),

/***/ "./src/components/PersonalGreeting/PersonalGreeting.scss":
/*!***************************************************************!*\
  !*** ./src/components/PersonalGreeting/PersonalGreeting.scss ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  /* Font family */
  --font-family: var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial, sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "CiscoSansTT Light", "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
}

:host {
  flex: 1;
}

.greeting-title {
  color: var(--input-default-new-color);
  font-family: var(--font-family);
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
}
.greeting-title.disabled {
  color: var(--input-default-new-disabled-color);
}

.greeting-sub-title {
  color: var(--md-secondary-text-color);
  font-family: var(--font-family);
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
}
.greeting-sub-title.disabled {
  color: var(--input-default-new-disabled-color);
}

.greeting-list-title {
  color: var(--input-default-new-color);
  font-family: var(--font-family);
  font-size: 16px;
  font-weight: 400;
  line-height: 21px;
}

.greeting-parent-container {
  display: flex;
  justify-content: left;
  height: 100%;
  padding: 8px 0px;
  align-items: center;
}

.greeting-title-and-length-container {
  display: flex;
  flex-direction: column;
  margin: 0 12px;
}

.greeting-title-container {
  display: flex;
  justify-content: flex-start;
  flex: 1;
  align-items: center;
  margin: 0 12px;
}

.greeting-delete-and-record-container {
  margin-left: auto;
  display: flex;
  gap: 8px;
}

.greeting-list {
  width: 100%;
}

.greeting-list-item {
  width: 100%;
  padding: 10px;
}
/*# sourceURL=/home/jenkins/agent/workspace/cicd-jobs/wxcc-common-CI-Builder/packages/@uuip/unified-ui-platform-common-components/src/assets/styles/variables.scss */
/*# sourceURL=PersonalGreeting.scss */
/*# sourceURL=/home/jenkins/agent/workspace/cicd-jobs/wxcc-common-CI-Builder/packages/@uuip/unified-ui-platform-common-components/src/components/PersonalGreeting/PersonalGreeting.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/PersonalGreeting/PersonalGreeting.ts":
/*!*************************************************************!*\
  !*** ./src/components/PersonalGreeting/PersonalGreeting.ts ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   PersonalGreeting: () => (/* binding */ PersonalGreeting)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-html/directives/class-map */ "lit-html/directives/class-map");
/* harmony import */ var lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _PersonalGreeting_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./PersonalGreeting.scss */ "./src/components/PersonalGreeting/PersonalGreeting.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};



var PersonalGreeting;
(function (PersonalGreeting) {
    /**
     * @element uuip-wc-personal-greeting
     * @fires greeting-failed-to-play
     * @fires greeting-record-clicked
     * @fires greeting-delete-clicked
     */
    let Element = class Element extends lit_element__WEBPACK_IMPORTED_MODULE_0__.LitElement {
        constructor() {
            super(...arguments);
            this.greeting = {
                greetingId: "",
                greetingName: "",
                greetingUrl: "",
                isActive: false
            };
            this.t = {
                record: "Record",
                recordTooltip: "Record a greeting",
                rerecordTooltip: "Re-record this greeting",
                playGreetingTooltip: "Play greeting",
                pauseGreetingTooltip: "Pause greeting",
                deleteGreetingTooltip: "Delete greeting"
            };
            this.audio = null;
            this.audioDuration = null;
            this.isPlaying = false;
        }
        static get styles() {
            return _PersonalGreeting_scss__WEBPACK_IMPORTED_MODULE_2__["default"];
        }
        stopPlayback() {
            if (this.audio && !this.audio.paused) {
                this.audio.pause();
            }
        }
        getAudio() {
            return this.audio;
        }
        disconnectedCallback() {
            this.stopPlayback();
            this.audio = null;
            super.disconnectedCallback();
        }
        connectedCallback() {
            super.connectedCallback();
            this.initializeAudio();
        }
        initializeAudio() {
            if (this.greeting.isActive && (!this.audio || this.audio.src !== this.greeting.greetingUrl)) {
                this.audio = new Audio(this.greeting.greetingUrl);
                this.audio.addEventListener("loadedmetadata", () => {
                    var _a, _b;
                    this.audioDuration = (_b = (_a = this.audio) === null || _a === void 0 ? void 0 : _a.duration) !== null && _b !== void 0 ? _b : 0;
                });
                this.audio.addEventListener("play", () => {
                    this.isPlaying = true;
                });
                this.audio.addEventListener("pause", () => {
                    this.isPlaying = false;
                });
            }
        }
        addPlaybackErrorListener() {
            if (this.audio) {
                this.audio.addEventListener("error", () => {
                    this.onPlaybackFailed();
                });
            }
        }
        onPlaybackFailed() {
            this.isPlaying = false;
            this.dispatchEvent(new CustomEvent("greeting-failed-to-play", {
                bubbles: true,
                composed: true,
                detail: {
                    greetingId: this.greeting.greetingId
                }
            }));
        }
        onRecordButtonClicked() {
            this.dispatchEvent(new CustomEvent("greeting-record-clicked", {
                bubbles: true,
                composed: true,
                detail: {
                    greetingId: this.greeting.greetingId
                }
            }));
        }
        onDeleteButtonClicked() {
            this.dispatchEvent(new CustomEvent("greeting-delete-clicked", {
                bubbles: true,
                composed: true,
                detail: {
                    greetingId: this.greeting.greetingId
                }
            }));
        }
        onPlayPauseClicked() {
            return __awaiter(this, void 0, void 0, function* () {
                this.initializeAudio();
                if (this.audio === null) {
                    return;
                }
                this.addPlaybackErrorListener();
                if (this.audio.paused) {
                    try {
                        yield this.audio.play();
                    }
                    catch (_a) {
                        this.onPlaybackFailed();
                    }
                }
                else {
                    this.audio.pause();
                }
            });
        }
        formatDuration(duration) {
            const minutes = Math.floor(duration / 60);
            const seconds = Math.floor(duration % 60);
            return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.html) `
        <div class="greeting-parent-container">
          <md-tooltip
            message=${this.isPlaying ? this.t.pauseGreetingTooltip : this.t.playGreetingTooltip}
            placement="top"
            ?disabled="${!this.greeting.isActive}"
          >
            <md-button
              variant="primary"
              size="32"
              circle
              ?disabled="${!this.greeting.isActive}"
              @button-click=${this.onPlayPauseClicked}
              ><md-icon
                slot="icon"
                iconSet="momentumDesign"
                name="${this.isPlaying ? "pause-bold" : "play-bold"}"
              ></md-icon
            ></md-button>
          </md-tooltip>

          ${this.audioDuration !== null
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.html) ` <div class="greeting-title-and-length-container">
                <label class="greeting-title ${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_1__.classMap)({ disabled: !this.greeting.isActive })}"
                  >${this.greeting.greetingName}</label
                >
                <label class="greeting-sub-title ${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_1__.classMap)({ disabled: !this.greeting.isActive })}"
                  >${this.formatDuration(this.audioDuration)}</label
                >
              </div>`
                : (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.html) `<div class="greeting-title-container">
                <label class="greeting-title ${(0,lit_html_directives_class_map__WEBPACK_IMPORTED_MODULE_1__.classMap)({ disabled: !this.greeting.isActive })}"
                  >${this.greeting.greetingName}</label
                >
              </div>`}

          <div class="greeting-delete-and-record-container">
            <md-tooltip message=${this.t.deleteGreetingTooltip} placement="top" ?disabled="${!this.greeting.isActive}">
              <md-button
                variant="secondary-negative"
                circle
                ?disabled="${!this.greeting.isActive}"
                @button-click=${this.onDeleteButtonClicked}
                ><md-icon slot="icon" iconSet="momentumDesign" name="delete-bold"></md-icon
              ></md-button>
            </md-tooltip>
            <md-tooltip
              message=${this.greeting.isActive ? this.t.rerecordTooltip : this.t.recordTooltip}
              placement="top"
            >
              <md-button size="32" variant="secondary" @button-click=${this.onRecordButtonClicked}
                >${this.t.record}</md-button
              >
            </md-tooltip>
          </div>
        </div>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.property)({ type: Object })
    ], Element.prototype, "greeting", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.internalProperty)()
    ], Element.prototype, "t", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.internalProperty)()
    ], Element.prototype, "audio", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.internalProperty)()
    ], Element.prototype, "audioDuration", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.internalProperty)()
    ], Element.prototype, "isPlaying", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.customElement)("uuip-wc-personal-greeting")
    ], Element);
    PersonalGreeting.Element = Element;
})(PersonalGreeting || (PersonalGreeting = {}));


/***/ }),

/***/ "./src/components/PersonalGreeting/PersonalGreetingList.ts":
/*!*****************************************************************!*\
  !*** ./src/components/PersonalGreeting/PersonalGreetingList.ts ***!
  \*****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   PersonalGreetingList: () => (/* binding */ PersonalGreetingList)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _PersonalGreeting_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./PersonalGreeting.scss */ "./src/components/PersonalGreeting/PersonalGreeting.scss");
/* harmony import */ var lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-html/directives/repeat */ "lit-html/directives/repeat");
/* harmony import */ var lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_2__);
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var PersonalGreetingList;
(function (PersonalGreetingList) {
    /**
     * @element uuip-wc-personal-greeting-list
     */
    let Element = class Element extends lit_element__WEBPACK_IMPORTED_MODULE_0__.LitElement {
        constructor() {
            super(...arguments);
            this.greetings = [];
        }
        static get styles() {
            return _PersonalGreeting_scss__WEBPACK_IMPORTED_MODULE_1__["default"];
        }
        // Public API to stop all playback
        stopAllPlayback() {
            var _a;
            const greetingList = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelectorAll("uuip-wc-personal-greeting");
            greetingList.forEach((greeting) => greeting.stopPlayback());
        }
        render() {
            // Sort greetings with active ones at the top
            const sortedGreetings = [...this.greetings].sort((a, b) => Number(b.isActive) - Number(a.isActive));
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.html) `
        <md-list alignment="vertical" class="greeting-list" role="list">
          ${(0,lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_2__.repeat)(sortedGreetings, (n) => (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.html) ` <md-list-item slot="list-item" role="listitem" class="greeting-list-item">
                <uuip-wc-personal-greeting .greeting=${n}></uuip-wc-personal-greeting>
              </md-list-item>
              </div>`)}
        </md-list>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.property)({ type: Array })
    ], Element.prototype, "greetings", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.customElement)("uuip-wc-personal-greeting-list")
    ], Element);
    PersonalGreetingList.Element = Element;
})(PersonalGreetingList || (PersonalGreetingList = {}));


/***/ }),

/***/ "./src/components/UserProfile/UserProfile.scss":
/*!*****************************************************!*\
  !*** ./src/components/UserProfile/UserProfile.scss ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  /* Font Size */
  --font-size-small: 12px;
  --font-size-medium: 14px;
  --font-size-large: 16px;
  /* Spacing tokens */
  --space-token-cardinal: 5px;
  --space-token-even: 2px;
  --space-error-input: 4px 8px;
  /* Heights */
  --error-input-height: 32px;
  /* Font Weight */
  --font-weight-lite: 300;
  /* Font family */
  --font-family: var(--brand-font-regular, "CiscoSansTT Regular"), "CiscoSansTT Regular", "Helvetica Neue", Helvetica, Arial, sans-serif;
  --font-family-light: var(--brand-font-light, "CiscoSansTT Light"), "CiscoSansTT Light", "Helvetica Neue", Helvetica, Arial, sans-serif;
  /* Colors */
  --light-green-color: #44cf50;
  --color-gray-10: #ededed;
  --color-gray-70: #545454;
  --color-gray-100: #121212;
  --color-blue-70: #005e7d;
  --color-link: #00a0d1;
  --color-error-detail: #535759;
  --color-gray-border: #ccc;
  --color-error-text: #a12512;
  --color-count-notifications: #fff;
  /* Border radius */
  --border-radius-small: 4px;
  --border-radius-medium: 8px;
  --border-radius-large: 12px;
  --border-radius-circle: 100%;
  /* Animation */
  --ease-in-out-quint: cubic-bezier(0.83, 0, 0.17, 1);
  --default-animation-duration: 300ms;
  --quick-animation-duration: 150ms;
  /* Box shadow */
  --box-shadow: 0 0 4px 2px rgba(0, 160, 209, 0.75);
  --box-shadow-gray: 0 4px 8px rgba(0, 0, 0, 0.08);
}

.selection-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.selection-title-container {
  display: flex;
  flex-direction: row;
  gap: 8px;
  height: 20px;
}

.selection-title {
  color: var(--md-primary-text-color);
  font-family: var(--font-family);
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  margin: 0px;
}

.user-profile-wrapper {
  display: flex;
  flex-direction: column;
}

.section-container {
  margin-bottom: 20px;
}

.voice-config-container {
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.browser-label-container-emergency md-tooltip::part(tooltip_reference), .browser-label-container-emergency-helpText md-tooltip::part(tooltip_reference) {
  display: flex;
}

.browser-label-container-emergency-helpText {
  color: var(--md-secondary-text-color);
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  margin-top: 0px;
  align-items: flex-start;
}
.browser-label-container-emergency-helpText md-link::part(link) {
  color: var(--md-hyperlink-text-color);
}

.browser-label-container-emergency-helpText md-icon {
  margin-top: 10px;
}

.emergency-help-tooltip md-button::part(button) {
  width: 0;
  height: 0;
  margin: 5px 14px 0 5px;
}

.info-icon {
  margin-left: 2px;
}

.international-format-container {
  width: 100%;
  container-type: inline-size;
  display: flex;
  flex-direction: row;
  gap: 8px;
}
.international-format-container md-country-code-picker::part(combobox) {
  width: 100px;
}
.international-format-container md-country-code-picker::part(options-container) {
  width: 100cqw;
}
.international-format-container md-country-code-picker::part(option) {
  justify-content: space-between;
}
.international-format-container md-combobox::part(message) {
  margin-left: -108px;
  width: 100cqw;
}

.phone-number-combobox {
  flex: 1;
}
.phone-number-combobox::part(multiwrap) {
  overflow-x: hidden;
}
.phone-number-combobox::part(multiwrap-input) {
  padding-left: 0;
  padding-right: 0;
  width: 100%;
}
.phone-number-combobox::part(label) {
  width: 100%;
}

.extension-info-container {
  display: flex;
}
.extension-info-container span {
  margin-left: 8px;
}

.extension-info {
  color: var(--md-alert-info-text-color);
}

.no-devices-available {
  color: var(--md-alert-error-text-color);
}

.signed-out {
  color: var(--md-alert-warning-text-color);
}

.extension-device, .unavailable-device, .available-device {
  display: flex;
  gap: 8px;
  text-align: start;
  align-items: center;
  color: var(--md-primary-text-color);
  background-color: var(--md-tertiary-bg-color);
  border-radius: 8px;
  border: 1px solid;
  padding: 11px;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
}
.extension-device strong, .unavailable-device strong, .available-device strong {
  font-weight: 700;
}

.available-device {
  background: var(--md-alert-success-bg-color);
  border-color: var(--md-button-join-outline-color);
}

.unavailable-device {
  background: var(--md-alert-error-bg-color);
  border-color: var(--md-button-cancel-outline-color);
}

.extension-device-list-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.error-message {
  margin-top: 8px;
}

.remember-me-wrapper {
  margin-top: 20px;
}

.checkbox-info {
  display: inline-flex;
  vertical-align: sub;
}
/*# sourceURL=/home/jenkins/agent/workspace/cicd-jobs/wxcc-common-CI-Builder/packages/@uuip/unified-ui-platform-common-components/src/assets/styles/variables.scss */
/*# sourceURL=UserProfile.scss */
/*# sourceURL=/home/jenkins/agent/workspace/cicd-jobs/wxcc-common-CI-Builder/packages/@uuip/unified-ui-platform-common-components/src/components/UserProfile/UserProfile.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/UserProfile/UserProfile.ts":
/*!***************************************************!*\
  !*** ./src/components/UserProfile/UserProfile.ts ***!
  \***************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   UserProfile: () => (/* binding */ UserProfile)
/* harmony export */ });
/* harmony import */ var _mixins_i18n__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18n */ "./src/mixins/i18n.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_DeviceList__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./components/DeviceList */ "./src/components/UserProfile/components/DeviceList.ts");
/* harmony import */ var _components_DialNumberSelection__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./components/DialNumberSelection */ "./src/components/UserProfile/components/DialNumberSelection.ts");
/* harmony import */ var _components_ExtensionSelection__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./components/ExtensionSelection */ "./src/components/UserProfile/components/ExtensionSelection.ts");
/* harmony import */ var _components_RoleSelection__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./components/RoleSelection */ "./src/components/UserProfile/components/RoleSelection.ts");
/* harmony import */ var _components_TeamSelection__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./components/TeamSelection */ "./src/components/UserProfile/components/TeamSelection.ts");
/* harmony import */ var _components_VoiceOptionSelection__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./components/VoiceOptionSelection */ "./src/components/UserProfile/components/VoiceOptionSelection.ts");
/* harmony import */ var _UserProfile_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./UserProfile.scss */ "./src/components/UserProfile/UserProfile.scss");
/* harmony import */ var _UserProfileTypes__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./UserProfileTypes */ "./src/components/UserProfile/UserProfileTypes.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};











var UserProfile;
(function (UserProfile) {
    /**
     * @element uuip-wc-user-profile
     * @fires data-available
     * @fires component-updated
     * @fires emergency-notification-read
     */
    let Element = class Element extends (0,_mixins_i18n__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_1__.LitElement) {
        constructor() {
            super(...arguments);
            this.defaultDialNumber = "";
            this.dialPlanRegexStrings = [];
            this.dialNumbers = [];
            this.defaultExtension = "";
            this.errorMessage = "";
            this.errorType = "none";
            this.extensions = [];
            this.getProfileDataTriggered = false;
            this.isCallMonitoringEnabled = false;
            this.isExternalTeamSelection = false;
            this.isRememberMeChecked = false;
            this.isReadonlyNumber = false;
            this.loginVoiceOptions = [];
            this.defaultVoiceOption = null;
            this.preferenceRoleName = "";
            this.defaultTeam = { teamId: "", teamName: "" };
            this.teams = [];
            this.warningLinkUrl = "";
            this.emergencyNotificationDisplayMode = _UserProfileTypes__WEBPACK_IMPORTED_MODULE_10__.UserProfileTypes.EmergencyNotificationDisplayMode.NONE;
            this.devices = {};
            this.shouldRenderDevices = false;
            this.userRole = "";
            this.dialNumber = "";
            this.internationalDialNumber = "";
            this.isInternational = false;
            this.countryCodeValue = "+1"; // initial country code of US.
            this.countryCallingCode = "+1, United States of America, US";
            this.localization = {};
            this.t = {
                dialNumberSelectionTitle: "Dial number",
                dialNumberPlaceholder: "Enter your Dial number",
                dialNumberInvalid: "Dial number is invalid. Please contact your administrator.",
                extensionInfo: "Enter your calling extension number provided by the administrator.",
                extensionPlaceHolder: "Enter the Webex Calling Extension",
                extensionSelectionTitle: "Extension",
                extensionInvalid: "Extension number is invalid. Please contact your administrator.",
                extensionDevicesInfo: "Make sure you're using an available device",
                extensionDeviceUnavailable: "Select another extension that has devices available",
                extensionDeviceSignedOut: "Sign in to this device or select another extension",
                deviceIsAvailable: "is available",
                deviceIsNotAvailable: "isn't available",
                teamSelectionTitle: "Your team",
                selectTeam: "Select the Team",
                rememberMe: "Don't show this again",
                rememberMeInfo: "If unchecked, your details will still be saved. You can change these details in your profile settings.",
                rememberMeInfoButtonLabel: "Remember me info",
                roleSelectionTitle: "Your role",
                selectRole: "Select the Role",
                supervisorRole: "Supervisor",
                supervisorAndAgentRole: "Supervisor and Agent",
                loginVoiceInfoButtonLabel: "Voice option info",
                loginVoiceInfo: "Enter the Dial Number / Select Extension if you are provided with a calling extension number by the administrator / Select Desktop for calls through the internet.",
                voiceSelectionTitle: "Handle calls using",
                voiceOptionDialNumber: "Dial Number",
                voiceOptionExtension: "Extension",
                voiceOptionDesktop: "Desktop",
                emergencyNotificationSubTitle: "Dialing Emergency Services:",
                emergencyNotificationContent: 
                // eslint-disable-next-line max-len
                "Use the Desktop outdial dial pad, when using the Desktop Telephony option for dialling emergency services (e.g. 999). Emergency services may not be accessible outside of your home country.",
                emergencyNotificationWarningMessage: 
                // eslint-disable-next-line max-len
                "When working outside the corporate location, make sure to update your current address in the Emergency service section. Not adding your current address may delay emergency services in locating you.",
                emergencyNotificationWarningLinkText: "See help section",
                emergencyNotificationAcknowledgement: "I have read the notification.",
                emergencyInfoContent: "When working outside the corporate location, make sure to update your current address in the Emergency service.",
                internationalFormatButtonLabel: "International dialling format",
                internationalFormatTooltip: "Choose the country code and enter the dial number. To use another dial number format, untick this tickbox.",
                countryCodeAriaLabel: "Country code",
                clearAriaLabel: "Clear"
            };
            this.dnConfig = {
                number: "",
                isInternational: false,
                isPrevalidatedOption: false,
                countryCodeValue: "",
                countryCallingCode: "",
                internationalNumber: "",
                nonInternationalNumber: ""
            };
            this.selectedExtension = "";
            this.selectedRoleName = "";
            this.selectedTeam = { teamName: "", teamId: "" };
            this.selectedVoiceOption = null;
            this.rememberMeUserCheckChange = null;
            this.dialPlanRegexArray = [];
            this.voiceOptions = [];
        }
        static get styles() {
            return _UserProfile_scss__WEBPACK_IMPORTED_MODULE_9__["default"];
        }
        connectedCallback() {
            super.connectedCallback();
            this.dnConfig.isInternational = this.isInternational;
            this.dnConfig.countryCodeValue = this.countryCodeValue;
            this.dnConfig.countryCallingCode = this.countryCallingCode;
            this.dnConfig.internationalNumber = this.internationalDialNumber;
            this.dnConfig.nonInternationalNumber = this.dialNumber;
            this.selectedExtension = this.defaultExtension;
        }
        get deduceRoleName() {
            return this.selectedRoleName
                ? this.selectedRoleName
                : this.shouldShowRoleSelection
                    ? this.preferenceRoleName
                    : "";
        }
        get deduceVoiceOption() {
            var _a;
            if (this.selectedVoiceOption) {
                return this.selectedVoiceOption;
            }
            return this.defaultVoiceOption ? this.defaultVoiceOption : ((_a = this.voiceOptions[0]) === null || _a === void 0 ? void 0 : _a.name) || "NONE";
        }
        get deduceDefaultTeam() {
            if (this.teams.length === 0) {
                return { teamName: "", teamId: "" };
            }
            const defaultTeam = this.teams.find((team) => team.teamName === this.defaultTeam.teamName);
            return defaultTeam !== null && defaultTeam !== void 0 ? defaultTeam : this.teams[0];
        }
        get availableVoiceOptions() {
            const voiceOptionsMapping = {
                AGENT_DN: this.t.voiceOptionDialNumber,
                EXTENSION: this.t.voiceOptionExtension,
                BROWSER: this.t.voiceOptionDesktop,
                NONE: ""
            };
            if (this.loginVoiceOptions.length === 0) {
                this.loginVoiceOptions = _UserProfileTypes__WEBPACK_IMPORTED_MODULE_10__.UserProfileTypes.DEFAULT_DEVICE_TYPE;
            }
            const options = this.loginVoiceOptions
                .filter((option) => option !== "NONE")
                .map((option) => ({
                name: option,
                displayName: voiceOptionsMapping[option]
            }));
            return options;
        }
        get isDNVoiceOption() {
            return this.deduceVoiceOption === "AGENT_DN";
        }
        get isExtensionVoiceOption() {
            return this.deduceVoiceOption === "EXTENSION";
        }
        get shouldShowRoleSelection() {
            return this.userRole === _UserProfileTypes__WEBPACK_IMPORTED_MODULE_10__.UserProfileTypes.AGENT_AND_SUPERVISOR;
        }
        get shouldShowVoiceConfiguration() {
            if (this.loginVoiceOptions.length === 1 && this.loginVoiceOptions[0] === "NONE") {
                return false;
            }
            if (this.userRole === _UserProfileTypes__WEBPACK_IMPORTED_MODULE_10__.UserProfileTypes.AGENT) {
                return true;
            }
            if ((this.userRole === _UserProfileTypes__WEBPACK_IMPORTED_MODULE_10__.UserProfileTypes.SUPERVISOR ||
                (this.userRole === _UserProfileTypes__WEBPACK_IMPORTED_MODULE_10__.UserProfileTypes.AGENT_AND_SUPERVISOR &&
                    this.deduceRoleName === _UserProfileTypes__WEBPACK_IMPORTED_MODULE_10__.UserProfileTypes.SUPERVISOR)) &&
                this.isCallMonitoringEnabled) {
                return true;
            }
            return (this.userRole === _UserProfileTypes__WEBPACK_IMPORTED_MODULE_10__.UserProfileTypes.AGENT_AND_SUPERVISOR &&
                this.deduceRoleName === _UserProfileTypes__WEBPACK_IMPORTED_MODULE_10__.UserProfileTypes.AGENT_AND_SUPERVISOR);
        }
        get shouldShowTeamSelection() {
            return (this.userRole === _UserProfileTypes__WEBPACK_IMPORTED_MODULE_10__.UserProfileTypes.AGENT ||
                (this.userRole === _UserProfileTypes__WEBPACK_IMPORTED_MODULE_10__.UserProfileTypes.AGENT_AND_SUPERVISOR &&
                    this.deduceRoleName === _UserProfileTypes__WEBPACK_IMPORTED_MODULE_10__.UserProfileTypes.AGENT_AND_SUPERVISOR));
        }
        firstUpdated(changedProperties) {
            super.firstUpdated(changedProperties);
            this.handleSelectionChange();
        }
        updated(changedProperties) {
            super.updated(changedProperties);
            if (changedProperties.has("getProfileDataTriggered") && this.getProfileDataTriggered) {
                this.handleGetProfileData();
            }
            if (changedProperties.has("dialPlanRegexStrings") && this.dialPlanRegexStrings.length > 0) {
                this.updateDialPlanRegexArray();
            }
            if (changedProperties.has("loginVoiceOptions")) {
                const oldVoiceOptions = changedProperties.get("loginVoiceOptions");
                if (JSON.stringify(oldVoiceOptions) !== JSON.stringify(this.loginVoiceOptions)) {
                    this.voiceOptions = this.availableVoiceOptions;
                }
            }
            if (this.isExternalTeamSelection && changedProperties.has("defaultTeam")) {
                this.handleSelectionChange();
            }
        }
        evt(name, detail) {
            this.dispatchEvent(new CustomEvent(name, { bubbles: true, composed: true, detail }));
        }
        handleSelectionChange() {
            var _a;
            const roleSelected = this.shouldShowRoleSelection ? this.deduceRoleName.length > 0 : true;
            const validTeamSelected = this.isExternalTeamSelection
                ? this.defaultTeam.teamName.length > 0
                : ((_a = this.teamSelectionOrDefault) === null || _a === void 0 ? void 0 : _a.teamName.length) > 0;
            const teamSelected = this.shouldShowTeamSelection ? validTeamSelected : true;
            const showVoiceConfiguration = this.shouldShowVoiceConfiguration;
            const dialNumberSelected = showVoiceConfiguration && this.isDNVoiceOption ? this.dnConfig.number.length > 0 : true;
            const isExtensionConfig = showVoiceConfiguration && this.isExtensionVoiceOption;
            const isExtensionSelected = this.selectedExtension.length > 0;
            let hasAvailableDevices = true;
            if (isExtensionConfig && isExtensionSelected && Object.keys(this.devices).includes(this.selectedExtension)) {
                const devices = this.devices[this.selectedExtension];
                hasAvailableDevices =
                    devices.length > 0 && devices.some((device) => !!device.available || device.available === undefined);
            }
            const isExtensionConfigComplete = isExtensionConfig ? isExtensionSelected && hasAvailableDevices : true;
            this.evt("component-updated", {
                isComplete: roleSelected && teamSelected && dialNumberSelected && isExtensionConfigComplete,
                data: this.profileData
            });
        }
        handleGetProfileData() {
            this.evt("data-available", {
                data: this.profileData
            });
        }
        get profileData() {
            return {
                role: this.deduceRoleName,
                team: this.shouldShowTeamSelection && !this.isExternalTeamSelection
                    ? this.selectedTeam.teamName
                        ? this.selectedTeam
                        : this.deduceDefaultTeam
                    : { teamId: "", teamName: "" },
                dialNumber: this.dnConfig.number,
                dnConfig: this.dnConfig,
                extensionNumber: this.selectedExtension,
                loginOption: this.deduceVoiceOption,
                isRememberMeChecked: this.rememberMeUserCheckChange !== null ? this.rememberMeUserCheckChange : this.isRememberMeChecked
            };
        }
        onRememberMeCheckboxChanged() {
            this.rememberMeUserCheckChange =
                this.rememberMeUserCheckChange !== null ? !this.rememberMeUserCheckChange : !this.isRememberMeChecked;
            this.handleSelectionChange();
        }
        handleDialNumberSelection(e) {
            this.dnConfig = e.detail;
            this.handleSelectionChange();
        }
        handleExtensionSelection(e) {
            this.selectedExtension = e.detail.extension;
            this.handleSelectionChange();
        }
        handleRoleSelection(e) {
            this.selectedRoleName = e.detail.role.roleName;
            this.handleSelectionChange();
        }
        handleTeamSelection(e) {
            this.selectedTeam = e.detail.team;
            this.handleSelectionChange();
        }
        handleVoiceOptionSelection(e) {
            this.selectedVoiceOption = e.detail.voice.name;
            this.handleSelectionChange();
        }
        handleEmergencyNotificationReadChange(e) {
            const notificationRead = e.detail.isRead;
            this.evt("emergency-notification-read", {
                isRead: notificationRead
            });
        }
        get teamSelectionOrDefault() {
            return this.selectedTeam.teamName.length > 0 ? this.selectedTeam : this.deduceDefaultTeam;
        }
        updateDialPlanRegexArray() {
            this.dialPlanRegexArray = this.dialPlanRegexStrings.map((plan) => {
                return new RegExp(plan);
            });
        }
        renderRoleSelection() {
            return this.shouldShowRoleSelection
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
            <div class="section-container">
              <uuip-wc-user-profile-role
                .selectedRoleName=${this.deduceRoleName}
                .localization=${{
                    roleSelectionTitle: this.t.roleSelectionTitle,
                    selectRole: this.t.selectRole,
                    supervisorRole: this.t.supervisorRole,
                    supervisorAndAgentRole: this.t.supervisorAndAgentRole
                }}
                @role-selected=${this.handleRoleSelection}
              ></uuip-wc-user-profile-role>
            </div>
          `
                : lit_html__WEBPACK_IMPORTED_MODULE_2__.nothing;
        }
        renderDevicesList() {
            if (this.shouldRenderDevices &&
                this.selectedExtension &&
                Object.keys(this.devices).includes(this.selectedExtension)) {
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
          <uuip-wc-device-list
            .devicesList=${this.devices[this.selectedExtension].slice(0, 5)}
            .localization=${{
                    extensionDevicesInfo: this.t.extensionDevicesInfo,
                    extensionDeviceUnavailable: this.t.extensionDeviceUnavailable,
                    extensionDeviceSignedOut: this.t.extensionDeviceSignedOut,
                    isAvailable: this.t.deviceIsAvailable,
                    isNotAvailable: this.t.deviceIsNotAvailable
                }}
          ></uuip-wc-device-list>
        `;
            }
            return lit_html__WEBPACK_IMPORTED_MODULE_2__.nothing;
        }
        renderVoiceOptionConfiguration() {
            if (this.isDNVoiceOption) {
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
          <uuip-wc-user-profile-dial-number
            .dialNumbers=${this.dialNumbers}
            .validationRegexes=${this.dialPlanRegexArray}
            .errorMessage=${this.errorType === "dialNumberError" ? this.errorMessage : ""}
            ?readonly=${this.isReadonlyNumber}
            .dialNumber=${this.dnConfig.isPrevalidatedOption
                    ? this.dnConfig.number
                    : this.dnConfig.nonInternationalNumber}
            .internationalDialNumber=${this.dnConfig.isPrevalidatedOption
                    ? this.dnConfig.number
                    : this.dnConfig.internationalNumber}
            ?isInternational=${this.dnConfig.isInternational}
            .countryCodeValue=${this.dnConfig.countryCodeValue}
            .countryCallingCode=${this.dnConfig.countryCallingCode}
            .localization=${{
                    dialNumberSelectionTitle: this.t.dialNumberSelectionTitle,
                    dialNumberPlaceholder: this.t.dialNumberPlaceholder,
                    dialNumberInvalid: this.t.dialNumberInvalid,
                    internationalFormatButtonLabel: this.t.internationalFormatButtonLabel,
                    internationalFormatTooltip: this.t.internationalFormatTooltip,
                    countryCodeAriaLabel: this.t.countryCodeAriaLabel,
                    clearAriaLabel: this.t.clearAriaLabel
                }}
            @dn-selected=${this.handleDialNumberSelection}
          ></uuip-wc-user-profile-dial-number>
        `;
            }
            else if (this.isExtensionVoiceOption) {
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
          <uuip-wc-user-profile-extension
            .extensions=${this.extensions}
            .defaultExtension=${this.selectedExtension}
            ?readonly=${this.isReadonlyNumber}
            .errorMessage=${this.errorType === "extensionError" ? this.errorMessage : ""}
            .localization=${{
                    extensionInfo: this.t.extensionInfo,
                    extensionPlaceHolder: this.t.extensionPlaceHolder,
                    extensionSelectionTitle: this.t.extensionSelectionTitle,
                    extensionInvalid: this.t.extensionInvalid
                }}
            @extension-selected=${this.handleExtensionSelection}
          ></uuip-wc-user-profile-extension>

          ${this.renderDevicesList()}
        `;
            }
            return lit_html__WEBPACK_IMPORTED_MODULE_2__.nothing;
        }
        renderVoiceOptionSelection() {
            if (!this.shouldShowVoiceConfiguration) {
                return lit_html__WEBPACK_IMPORTED_MODULE_2__.nothing;
            }
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
        <div class="voice-config-container">
          <uuip-wc-user-profile-voice-option
            .voiceOptions=${this.voiceOptions}
            .defaultVoiceOption=${this.deduceVoiceOption}
            .warningLinkUrl=${this.warningLinkUrl}
            .localization=${{
                loginVoiceInfoButtonLabel: this.t.loginVoiceInfoButtonLabel,
                loginVoiceInfo: this.t.loginVoiceInfo,
                voiceSelectionTitle: this.t.voiceSelectionTitle
            }}
            @voice-selected=${this.handleVoiceOptionSelection}
          ></uuip-wc-user-profile-voice-option>
          ${this.emergencyNotificationDisplayMode === _UserProfileTypes__WEBPACK_IMPORTED_MODULE_10__.UserProfileTypes.EmergencyNotificationDisplayMode.BANNER
                ? this.renderEmergencyInfo()
                : lit_html__WEBPACK_IMPORTED_MODULE_2__.nothing}
          ${this.renderVoiceOptionConfiguration()}
        </div>
      `;
        }
        renderEmergencyInfo() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
        <div class="browser-label-container-emergency-helpText">
          <md-tooltip class="emergency-help-tooltip" placement="top" message=${this.t.emergencyInfoContent}>
            <md-button
              aria-label=${this.warningLinkUrl}
              circle
              variant="ghost"
              class="info-icon"
              role="tooltip"
              size="16"
            >
              <md-icon name="info-circle-regular" size="16" iconSet="momentumDesign"></md-icon>
            </md-button>
            <label
              >${this.t.emergencyInfoContent}
              <md-link
                inline
                class="help-section-link"
                aria-label=${this.t.emergencyNotificationWarningLinkText}
                tag="a"
                href=${this.warningLinkUrl}
                target="_blank"
                >${this.t.emergencyNotificationWarningLinkText}</md-link
              >
            </label>
          </md-tooltip>
        </div>
      `;
        }
        renderTeamSelection() {
            return this.shouldShowTeamSelection
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
            <div class="section-container selection-container">
              <p class="selection-title">${this.t.teamSelectionTitle}</p>
              ${this.isExternalTeamSelection
                    ? (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `<slot name="external-team-selection-slot" />`
                    : (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
                    <uuip-wc-user-profile-team
                      .teams=${this.teams}
                      .defaultTeam=${this.teamSelectionOrDefault.teamName}
                      .localization=${{
                        selectTeam: this.t.selectTeam
                    }}
                      @team-selected=${this.handleTeamSelection}
                    ></uuip-wc-user-profile-team>
                  `}
            </div>
          `
                : lit_html__WEBPACK_IMPORTED_MODULE_2__.nothing;
        }
        renderEmergencyNotificationBody() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
        <div class="emergency-notification-body">
          <uuip-wc-emergency-notification-content
            .warningLinkUrl=${this.warningLinkUrl}
            .localization=${{
                notificationTitle: this.t.emergencyNotificationSubTitle,
                notificationContent: this.t.emergencyNotificationContent,
                warningMessage: this.t.emergencyNotificationWarningMessage,
                warningLinkText: this.t.emergencyNotificationWarningLinkText,
                readNotification: this.t.emergencyNotificationAcknowledgement
            }}
            @read-notification-change=${this.handleEmergencyNotificationReadChange}
          ></uuip-wc-emergency-notification-content>
        </div>
      `;
        }
        renderRememberMeCheckbox() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
        <div>
          <md-checkbox
            id="rememberMeCheckbox"
            slot="checkbox"
            ?checked=${this.isRememberMeChecked}
            label=${this.t.rememberMe}
            @checkbox-change=${this.onRememberMeCheckboxChanged}
          >
            ${this.t.rememberMe}
            <md-tooltip message=${this.t.rememberMeInfo} placement="bottom">
              <md-button
                class="checkbox-info"
                ariaLabel=${this.t.rememberMeInfoButtonLabel}
                circle
                variant="ghost"
                size="20"
              >
                <md-icon name="info-badge-filled" size="16" iconSet="momentumDesign"></md-icon>
              </md-button>
            </md-tooltip>
          </md-checkbox>
        </div>
      `;
        }
        renderUnknownError() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
        <div class="error-message">
          <md-help-text .messageType=${"error"}> ${this.errorMessage} </md-help-text>
        </div>
      `;
        }
        renderUserProfile() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
        <div class="user-profile-wrapper">
          ${this.renderRoleSelection()} ${this.renderVoiceOptionSelection()} ${this.renderTeamSelection()}
          ${this.errorType === "unknown" && this.errorMessage.length > 0 ? this.renderUnknownError() : lit_html__WEBPACK_IMPORTED_MODULE_2__.nothing}
          ${this.renderRememberMeCheckbox()}
        </div>
      `;
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) ` ${this.emergencyNotificationDisplayMode === _UserProfileTypes__WEBPACK_IMPORTED_MODULE_10__.UserProfileTypes.EmergencyNotificationDisplayMode.MODAL
                ? this.renderEmergencyNotificationBody()
                : this.renderUserProfile()}`;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: String })
    ], Element.prototype, "defaultDialNumber", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Array })
    ], Element.prototype, "dialPlanRegexStrings", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Array })
    ], Element.prototype, "dialNumbers", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: String })
    ], Element.prototype, "defaultExtension", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: String })
    ], Element.prototype, "errorMessage", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: String })
    ], Element.prototype, "errorType", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Array })
    ], Element.prototype, "extensions", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Boolean })
    ], Element.prototype, "getProfileDataTriggered", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Boolean })
    ], Element.prototype, "isCallMonitoringEnabled", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Boolean })
    ], Element.prototype, "isExternalTeamSelection", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Boolean })
    ], Element.prototype, "isRememberMeChecked", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Boolean })
    ], Element.prototype, "isReadonlyNumber", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Array })
    ], Element.prototype, "loginVoiceOptions", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: String })
    ], Element.prototype, "defaultVoiceOption", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: String })
    ], Element.prototype, "preferenceRoleName", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Object })
    ], Element.prototype, "defaultTeam", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Array })
    ], Element.prototype, "teams", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: String })
    ], Element.prototype, "warningLinkUrl", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: _UserProfileTypes__WEBPACK_IMPORTED_MODULE_10__.UserProfileTypes.EmergencyNotificationDisplayMode })
    ], Element.prototype, "emergencyNotificationDisplayMode", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Object })
    ], Element.prototype, "devices", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Boolean })
    ], Element.prototype, "shouldRenderDevices", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: String })
    ], Element.prototype, "userRole", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: String })
    ], Element.prototype, "dialNumber", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: String })
    ], Element.prototype, "internationalDialNumber", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Boolean })
    ], Element.prototype, "isInternational", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: String })
    ], Element.prototype, "countryCodeValue", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: String })
    ], Element.prototype, "countryCallingCode", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Object })
    ], Element.prototype, "localization", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "t", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "dnConfig", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "selectedExtension", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "selectedRoleName", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "selectedTeam", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "selectedVoiceOption", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "rememberMeUserCheckChange", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "dialPlanRegexArray", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "voiceOptions", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.customElement)("uuip-wc-user-profile")
    ], Element);
    UserProfile.Element = Element;
})(UserProfile || (UserProfile = {}));


/***/ }),

/***/ "./src/components/UserProfile/UserProfileTypes.ts":
/*!********************************************************!*\
  !*** ./src/components/UserProfile/UserProfileTypes.ts ***!
  \********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   UserProfileTypes: () => (/* binding */ UserProfileTypes)
/* harmony export */ });
var UserProfileTypes;
(function (UserProfileTypes) {
    UserProfileTypes.AGENT = "agent";
    UserProfileTypes.AGENT_AND_SUPERVISOR = "agent_supervisor";
    UserProfileTypes.SUPERVISOR = "supervisor";
    UserProfileTypes.DEFAULT_DEVICE_TYPE = ["AGENT_DN", "EXTENSION"];
    let EmergencyNotificationDisplayMode;
    (function (EmergencyNotificationDisplayMode) {
        EmergencyNotificationDisplayMode["NONE"] = "none";
        EmergencyNotificationDisplayMode["MODAL"] = "modal";
        EmergencyNotificationDisplayMode["BANNER"] = "banner";
    })(EmergencyNotificationDisplayMode = UserProfileTypes.EmergencyNotificationDisplayMode || (UserProfileTypes.EmergencyNotificationDisplayMode = {}));
})(UserProfileTypes || (UserProfileTypes = {}));


/***/ }),

/***/ "./src/components/UserProfile/components/DeviceList.ts":
/*!*************************************************************!*\
  !*** ./src/components/UserProfile/components/DeviceList.ts ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   DeviceList: () => (/* binding */ DeviceList)
/* harmony export */ });
/* harmony import */ var _mixins_i18n__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18n */ "./src/mixins/i18n.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lit-html */ "lit-html");
/* harmony import */ var lit_html__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lit_html__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-html/directives/repeat */ "lit-html/directives/repeat");
/* harmony import */ var lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _UserProfile_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../UserProfile.scss */ "./src/components/UserProfile/UserProfile.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





var DeviceList;
(function (DeviceList) {
    /**
     * @element uuip-wc-device-list
     */
    let Element = class Element extends (0,_mixins_i18n__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_1__.LitElement) {
        constructor() {
            super(...arguments);
            this.devicesList = [];
            this.localization = {};
            this.t = {
                extensionDevicesInfo: "Make sure you're using an available device",
                extensionDeviceUnavailable: "Select another extension that has devices available",
                extensionDeviceSignedOut: "Sign in to this device or select another extension",
                isAvailable: "is available",
                isNotAvailable: "isn't available"
            };
        }
        static get styles() {
            return _UserProfile_scss__WEBPACK_IMPORTED_MODULE_4__["default"];
        }
        renderDeviceInfo() {
            if (!this.devicesList.length) {
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `<div class="extension-info-container no-devices-available">
          <md-icon name="error-legacy-badge-filled" iconSet="momentumDesign" size="16"></md-icon>
          <span>${this.t.extensionDeviceUnavailable}</span>
        </div>`;
            }
            if (this.devicesList.some((device) => !!device.available || device.available === undefined)) {
                return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `<div class="extension-info-container extension-info">
          <md-icon name="priority-badge-filled" iconSet="momentumDesign" size="16"></md-icon>
          <span>${this.t.extensionDevicesInfo}</span>
        </div>`;
            }
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `<div class="extension-info-container signed-out">
        <md-icon name="warning-badge-filled" iconSet="momentumDesign" size="16"></md-icon>
        <span>${this.t.extensionDeviceSignedOut}</span>
      </div>`;
        }
        renderDevice(device) {
            if (device.available === undefined) {
                return lit_html__WEBPACK_IMPORTED_MODULE_2__.nothing;
            }
            const className = device.available ? "available-device" : "unavailable-device";
            const icon = device.available ? "check-circle-bold" : "error-legacy-bold";
            const iconColor = device.available ? "--md-alert-success-text-color" : "--md-alert-error-text-color";
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
        <div class="${className}">
          <md-icon name=${icon} size="20" iconSet="momentumDesign" color="var(${iconColor})"></md-icon>
          <span>
            <strong>${device.name}</strong> ${device.available ? this.t.isAvailable : this.t.isNotAvailable}
          </span>
        </div>
      `;
        }
        renderDeviceList() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
        <div class="extension-device-list-container">
          ${(0,lit_html_directives_repeat__WEBPACK_IMPORTED_MODULE_3__.repeat)(this.devicesList, (device) => this.renderDevice(device))}
        </div>
      `;
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `${this.renderDeviceInfo()} ${this.renderDeviceList()}`;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Array })
    ], Element.prototype, "devicesList", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Object })
    ], Element.prototype, "localization", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "t", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.customElement)("uuip-wc-device-list")
    ], Element);
    DeviceList.Element = Element;
})(DeviceList || (DeviceList = {}));


/***/ }),

/***/ "./src/components/UserProfile/components/DialNumberSelection.ts":
/*!**********************************************************************!*\
  !*** ./src/components/UserProfile/components/DialNumberSelection.ts ***!
  \**********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   UserProfileDialNumber: () => (/* binding */ UserProfileDialNumber)
/* harmony export */ });
/* harmony import */ var _mixins_i18n__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18n */ "./src/mixins/i18n.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _UserProfile_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../UserProfile.scss */ "./src/components/UserProfile/UserProfile.scss");
/* harmony import */ var libphonenumber_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! libphonenumber-js */ "libphonenumber-js");
/* harmony import */ var libphonenumber_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(libphonenumber_js__WEBPACK_IMPORTED_MODULE_3__);
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var UserProfileDialNumber;
(function (UserProfileDialNumber) {
    /**
     * @element uuip-wc-user-profile-dial-number
     * @fires dn-selected
     */
    let Element = class Element extends (0,_mixins_i18n__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_1__.LitElement) {
        constructor() {
            super(...arguments);
            this.dialNumbers = [];
            this.errorMessage = "";
            this.validationRegexes = [];
            this.readonly = false;
            this.localization = {};
            this.dialNumber = "";
            this.internationalDialNumber = "";
            this.isInternational = false;
            this.DEFAULT_COUNTRY_CODE_VALUE = "+1";
            this.DEFAULT_COUNTRY_CALLING_CODE = "+1, United States of America, US";
            this.countryCodeValue = this.DEFAULT_COUNTRY_CODE_VALUE;
            this.countryCallingCode = this.DEFAULT_COUNTRY_CALLING_CODE;
            this.countryCode = "US";
            this.formattedNumber = "";
            this.selectedDialNumber = null;
            this.isErrDNInvalid = false;
            this.t = {
                dialNumberSelectionTitle: "Dial number",
                dialNumberPlaceholder: "Enter your Dial number",
                dialNumberInvalid: "Dial number is invalid. Please contact your administrator.",
                internationalFormatButtonLabel: "International dialling format",
                internationalFormatTooltip: "Choose the country code and enter the dial number. To use another dial number format, untick this tickbox.",
                countryCodeAriaLabel: "Country code",
                clearAriaLabel: "Clear"
            };
        }
        connectedCallback() {
            super.connectedCallback();
            this.revalidate();
            this.formatInternationalNumber();
        }
        dispatchDnSelectedEvent() {
            const isInternational = this.isInternational && !this.isSelectedNumber;
            const detail = {
                number: "",
                isInternational,
                isPrevalidatedOption: this.isSelectedNumber,
                countryCodeValue: this.countryCodeValue || this.DEFAULT_COUNTRY_CODE_VALUE,
                countryCallingCode: this.countryCallingCode || this.DEFAULT_COUNTRY_CALLING_CODE,
                internationalNumber: this.internationalDialNumber,
                nonInternationalNumber: this.dialNumber
            };
            if (!this.isErrDNInvalid) {
                detail.number = this.isSelectedNumber ? this.selectedDialNumber || "" : this.manualInputDialNumber;
            }
            this.dispatchEvent(new CustomEvent("dn-selected", {
                bubbles: true,
                composed: true,
                detail
            }));
        }
        get errorMessageArr() {
            if (this.errorMessage.length === 0 && !this.isErrDNInvalid) {
                return [];
            }
            let messageLabel = "";
            if (this.isErrDNInvalid) {
                messageLabel = `${this.t.dialNumberInvalid}`;
            }
            else {
                messageLabel = this.errorMessage;
            }
            if (messageLabel) {
                return [
                    {
                        message: messageLabel,
                        type: "error"
                    }
                ];
            }
            else {
                return [];
            }
        }
        get manualInputDialNumber() {
            let prefix = "";
            if (this.isInternational && this.internationalDialNumber !== "") {
                prefix = this.countryCodeValue || "+1";
            }
            return `${prefix}${this.isInternational ? this.internationalDialNumber : this.dialNumber}`;
        }
        get inputNumber() {
            return this.isSelectedNumber
                ? this.selectedDialNumber || ""
                : this.isInternational
                    ? this.formattedNumber || this.internationalDialNumber
                    : this.dialNumber;
        }
        get isSelectedNumber() {
            return this.selectedDialNumber !== null && this.selectedDialNumber.length > 0;
        }
        resetErrors() {
            this.errorMessage = "";
            this.isErrDNInvalid = false;
        }
        validateNumber() {
            this.resetErrors();
            if ((this.isInternational && this.internationalDialNumber.length === 0) ||
                (!this.isInternational && this.dialNumber.length === 0)) {
                return;
            }
            if (this.isInternational) {
                this.isErrDNInvalid = !(0,libphonenumber_js__WEBPACK_IMPORTED_MODULE_3__.isValidNumberForRegion)(this.internationalDialNumber, this.countryCode);
            }
            else {
                const regexOtherFormat = new RegExp("^([\\d\\-_]+)$");
                this.isErrDNInvalid = !regexOtherFormat.test(this.dialNumber);
            }
        }
        formatNumber(value) {
            this.formattedNumber = new libphonenumber_js__WEBPACK_IMPORTED_MODULE_3__.AsYouType(this.countryCode).input(value);
        }
        removeCountryCode() {
            var _a;
            const countryCodeValue = (_a = this.countryCallingCode.split(",")[0]) === null || _a === void 0 ? void 0 : _a.trim();
            if (this.internationalDialNumber.startsWith(countryCodeValue)) {
                const validPhoneNumber = this.internationalDialNumber.slice(countryCodeValue.length).replace(/^-/, "");
                this.internationalDialNumber = validPhoneNumber;
            }
        }
        stripSpecialChar(str) {
            /*eslint no-useless-escape: "off"*/
            return str.replace(/[^\+?\d]/gi, "");
        }
        revalidate() {
            const number = this.isInternational ? this.internationalDialNumber : this.dialNumber;
            if (number.length > 0 && this.dialNumbers.includes(number)) {
                this.selectedDialNumber = number;
                this.dialNumber = "";
                this.internationalDialNumber = "";
                this.formattedNumber = "";
            }
            this.validateNumber();
            this.dispatchDnSelectedEvent();
        }
        handleSelectedDialNumber(e) {
            var _a;
            this.selectedDialNumber = (_a = e.detail.value) !== null && _a !== void 0 ? _a : "";
            if (!this.isSelectedNumber) {
                this.internationalDialNumber = "";
                this.formattedNumber = "";
                this.dialNumber = "";
            }
            this.revalidate();
        }
        handleTypedInDialNumber(e) {
            var _a;
            this.resetErrors();
            this.selectedDialNumber = null;
            const value = (_a = e.detail.value) !== null && _a !== void 0 ? _a : "";
            if (this.isInternational) {
                this.internationalDialNumber = this.stripSpecialChar(value);
                this.formattedNumber = value;
            }
            else {
                this.dialNumber = value;
            }
            if (value.length === 0) {
                this.dispatchDnSelectedEvent();
                return;
            }
            this.revalidate();
        }
        formatInternationalNumber() {
            if (this.isInternational) {
                this.removeCountryCode();
                this.formatNumber(this.internationalDialNumber);
            }
        }
        handleInternationalFormatCheckboxChanged() {
            this.isInternational = !this.isInternational;
            this.revalidate();
        }
        handleCountryCodeChanged(e) {
            var _a, _b;
            const event = e.detail.srcEvent;
            if (event && event.detail) {
                if (!event.detail.value || !event.detail.value.id) {
                    this.countryCodeValue = "+1";
                    this.countryCallingCode = "";
                    this.countryCode = "US";
                }
                else {
                    this.countryCodeValue = (_a = event.detail.selected[0]) === null || _a === void 0 ? void 0 : _a.value;
                    this.countryCallingCode = event.detail.value.id;
                    this.countryCode = (_b = event.detail.value.id.split(",")[2]) === null || _b === void 0 ? void 0 : _b.trim();
                }
                this.revalidate();
            }
        }
        static get styles() {
            return _UserProfile_scss__WEBPACK_IMPORTED_MODULE_2__["default"];
        }
        renderCountryCode() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
        <md-country-code-picker
          ?disabled=${this.readonly}
          ?pill=${false}
          ?show-flags=${false}
          ariaLabel=${this.t.countryCodeAriaLabel}
          codePlaceholder=${this.countryCodeValue}
          .countryCallingCode=${this.countryCallingCode}
          @country-code-changed=${this.handleCountryCodeChanged}
          .clearIconHeight=${"auto"}
          ?newMomentum=${true}
          ?isDropdownArrow=${true}
          .clearAriaLabel="${this.t.clearAriaLabel} ${this.t.countryCodeAriaLabel}"
        ></md-country-code-picker>
      `;
        }
        renderInternationalPhoneNumber() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
        <div class="international-format-container">${this.renderCountryCode()} ${this.renderPhoneNumber()}</div>
      `;
        }
        renderPhoneNumber() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
        <md-combobox
          class="phone-number-combobox"
          .title=${this.t.dialNumberPlaceholder}
          ariaLabel=${this.t.dialNumberPlaceholder}
          .inputValue=${this.inputNumber}
          .placeholder=${this.t.dialNumberPlaceholder}
          .options=${this.dialNumbers}
          .visibleOptions=${3}
          ?readonly=${this.readonly}
          .messageArr=${this.errorMessageArr}
          newMomentum
          @change-selected=${this.handleSelectedDialNumber}
          @combobox-input=${this.handleTypedInDialNumber}
          @combobox-focus-out=${this.formatInternationalNumber}
        ></md-combobox>
      `;
        }
        renderInternationalFormatCheckbox() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
        <div class="international-format-checkbox">
          <md-checkbox
            id="internationalCheckbox"
            slot="checkbox"
            ?disabled=${this.isSelectedNumber}
            ?checked=${this.isInternational}
            label=${this.t.internationalFormatButtonLabel}
            @checkbox-change=${this.handleInternationalFormatCheckboxChanged}
          >
            ${this.t.internationalFormatButtonLabel}
            <md-tooltip message=${this.t.internationalFormatTooltip} placement="bottom">
              <md-button
                class="checkbox-info"
                ariaLabel=${this.t.internationalFormatButtonLabel}
                circle
                variant="ghost"
                size="20"
              >
                <md-icon name="info-badge-filled" size="16" iconSet="momentumDesign"></md-icon>
              </md-button>
            </md-tooltip>
          </md-checkbox>
        </div>
      `;
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
        <div class="selection-container">
          <p class="selection-title">${this.t.dialNumberSelectionTitle}</p>
          ${this.isInternational && !this.isSelectedNumber
                ? this.renderInternationalPhoneNumber()
                : this.renderPhoneNumber()}
          ${this.renderInternationalFormatCheckbox()}
        </div>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Array })
    ], Element.prototype, "dialNumbers", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: String })
    ], Element.prototype, "errorMessage", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Array })
    ], Element.prototype, "validationRegexes", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Boolean })
    ], Element.prototype, "readonly", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Object })
    ], Element.prototype, "localization", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: String })
    ], Element.prototype, "dialNumber", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: String })
    ], Element.prototype, "internationalDialNumber", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Boolean })
    ], Element.prototype, "isInternational", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: String })
    ], Element.prototype, "countryCodeValue", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: String })
    ], Element.prototype, "countryCallingCode", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "countryCode", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "formattedNumber", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "selectedDialNumber", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "isErrDNInvalid", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "t", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.customElement)("uuip-wc-user-profile-dial-number")
    ], Element);
    UserProfileDialNumber.Element = Element;
})(UserProfileDialNumber || (UserProfileDialNumber = {}));


/***/ }),

/***/ "./src/components/UserProfile/components/ExtensionSelection.ts":
/*!*********************************************************************!*\
  !*** ./src/components/UserProfile/components/ExtensionSelection.ts ***!
  \*********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   UserProfileExtension: () => (/* binding */ UserProfileExtension)
/* harmony export */ });
/* harmony import */ var _mixins_i18n__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18n */ "./src/mixins/i18n.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _UserProfile_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../UserProfile.scss */ "./src/components/UserProfile/UserProfile.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var UserProfileExtension;
(function (UserProfileExtension) {
    /**
     * @element uuip-wc-user-profile-extension
     * @fires extension-selected
     */
    let Element = class Element extends (0,_mixins_i18n__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_1__.LitElement) {
        constructor() {
            super(...arguments);
            this.defaultExtension = "";
            this.errorMessage = "";
            this.extensions = [];
            this.readonly = false;
            this.localization = {};
            this.t = {
                extensionInfo: "Enter your calling extension number provided by the administrator.",
                extensionPlaceHolder: "Enter the Webex Calling Extension",
                extensionSelectionTitle: "Extension",
                extensionInvalid: "Extension number is invalid. Please contact your administrator."
            };
            this.isValid = true;
            this.selectedExtension = null;
            this.regexExtension = new RegExp("^\\d{2,18}$");
        }
        get availableExtensions() {
            if (this.defaultExtension) {
                return [this.defaultExtension];
            }
            return this.extensions;
        }
        get defaultValue() {
            if (this.selectedExtension || this.selectedExtension === "") {
                return this.selectedExtension;
            }
            return this.defaultExtension;
        }
        get errorMessageArr() {
            if (this.errorMessage.length === 0 && this.isValid) {
                return [];
            }
            let messageLabel = "";
            if (!this.isValid) {
                messageLabel = `${this.t.extensionInvalid}`;
            }
            else {
                messageLabel = this.errorMessage;
            }
            return [
                {
                    message: messageLabel,
                    type: "error"
                }
            ];
        }
        dispatchExtensionSelectedEvent(ext) {
            this.dispatchEvent(new CustomEvent("extension-selected", {
                bubbles: true,
                composed: true,
                detail: {
                    extension: ext
                }
            }));
        }
        updated(changedProperties) {
            super.updated(changedProperties);
            if (changedProperties.has("defaultExtension")) {
                if (this.defaultExtension !== changedProperties.get("defaultExtension") && !this.selectedExtension) {
                    this.dispatchExtensionSelectedEvent(this.defaultExtension);
                }
            }
        }
        handleSelectedExtension(e) {
            var _a;
            this.errorMessage = "";
            this.isValid = true;
            this.selectedExtension = (_a = e.detail.value) !== null && _a !== void 0 ? _a : "";
            if (!this.selectedExtension || this.selectedExtension.length === 0) {
                this.dispatchExtensionSelectedEvent("");
                return;
            }
            if (!this.availableExtensions.includes(e.detail.value)) {
                this.isValid = this.regexExtension.test(e.detail.value);
            }
            this.dispatchExtensionSelectedEvent(this.isValid ? e.detail.value : "");
        }
        static get styles() {
            return _UserProfile_scss__WEBPACK_IMPORTED_MODULE_2__["default"];
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
        <div class="selection-container">
          <p class="selection-title">${this.t.extensionSelectionTitle}</p>
          <md-combobox
            .title="${this.t.extensionSelectionTitle}"
            ariaLabel="${this.t.extensionInfo}"
            .placeholder=${this.t.extensionPlaceHolder}
            .options=${this.extensions}
            .visibleOptions=${3}
            .inputValue=${this.defaultValue}
            .messageArr=${this.errorMessageArr}
            ?readonly=${this.readonly}
            newMomentum
            htmlId="extensionCombobox"
            @change-selected=${this.handleSelectedExtension}
            @combobox-input=${this.handleSelectedExtension}
          ></md-combobox>
        </div>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: String })
    ], Element.prototype, "defaultExtension", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: String })
    ], Element.prototype, "errorMessage", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Array })
    ], Element.prototype, "extensions", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Boolean })
    ], Element.prototype, "readonly", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Object })
    ], Element.prototype, "localization", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "t", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "isValid", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "selectedExtension", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.customElement)("uuip-wc-user-profile-extension")
    ], Element);
    UserProfileExtension.Element = Element;
})(UserProfileExtension || (UserProfileExtension = {}));


/***/ }),

/***/ "./src/components/UserProfile/components/RoleSelection.ts":
/*!****************************************************************!*\
  !*** ./src/components/UserProfile/components/RoleSelection.ts ***!
  \****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   UserProfileRole: () => (/* binding */ UserProfileRole)
/* harmony export */ });
/* harmony import */ var _mixins_i18n__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18n */ "./src/mixins/i18n.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _UserProfile_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../UserProfile.scss */ "./src/components/UserProfile/UserProfile.scss");
/* harmony import */ var _UserProfileTypes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../UserProfileTypes */ "./src/components/UserProfile/UserProfileTypes.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var UserProfileRole;
(function (UserProfileRole) {
    /**
     * @element uuip-wc-user-profile-role
     * @fires role-selected
     */
    let Element = class Element extends (0,_mixins_i18n__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_1__.LitElement) {
        constructor() {
            super(...arguments);
            this.selectedRoleName = "";
            this.localization = {};
            this.t = {
                roleSelectionTitle: "Your role",
                selectRole: "Select the Role",
                supervisorRole: "Supervisor",
                supervisorAndAgentRole: "Supervisor and Agent"
            };
            this.roles = [
                { roleId: "1", roleName: _UserProfileTypes__WEBPACK_IMPORTED_MODULE_3__.UserProfileTypes.SUPERVISOR, roleDisplay: this.t.supervisorRole },
                {
                    roleId: "2",
                    roleName: _UserProfileTypes__WEBPACK_IMPORTED_MODULE_3__.UserProfileTypes.AGENT_AND_SUPERVISOR,
                    roleDisplay: this.t.supervisorAndAgentRole
                }
            ];
        }
        handleSelectedRole(e) {
            var _a;
            this.dispatchEvent(new CustomEvent("role-selected", {
                bubbles: true,
                composed: true,
                detail: {
                    role: (_a = e.detail.option) !== null && _a !== void 0 ? _a : { roleId: "", roleName: "", roleDisplay: "" }
                }
            }));
        }
        static get styles() {
            return _UserProfile_scss__WEBPACK_IMPORTED_MODULE_2__["default"];
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
        <div class="selection-container">
          <p class="selection-title">${this.t.roleSelectionTitle}</p>
          <md-dropdown
            .title=${this.t.selectRole}
            ariaLabel=${this.t.selectRole}
            .options=${this.roles}
            .defaultOption=${this.roles.find((role) => role.roleName === this.selectedRoleName) || {}}
            option-id="roleId"
            option-value="roleDisplay"
            .visibleOptions=${2}
            newMomentum
            @dropdown-selected=${this.handleSelectedRole}
          ></md-dropdown>
        </div>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: String })
    ], Element.prototype, "selectedRoleName", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Object })
    ], Element.prototype, "localization", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "t", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.customElement)("uuip-wc-user-profile-role")
    ], Element);
    UserProfileRole.Element = Element;
})(UserProfileRole || (UserProfileRole = {}));


/***/ }),

/***/ "./src/components/UserProfile/components/TeamSelection.ts":
/*!****************************************************************!*\
  !*** ./src/components/UserProfile/components/TeamSelection.ts ***!
  \****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   UserProfileTeam: () => (/* binding */ UserProfileTeam)
/* harmony export */ });
/* harmony import */ var _mixins_i18n__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18n */ "./src/mixins/i18n.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _UserProfile_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../UserProfile.scss */ "./src/components/UserProfile/UserProfile.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var UserProfileTeam;
(function (UserProfileTeam) {
    /**
     * @element uuip-wc-user-profile-team
     * @fires team-selected
     */
    let Element = class Element extends (0,_mixins_i18n__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_1__.LitElement) {
        constructor() {
            super(...arguments);
            this.teams = [];
            this.defaultTeam = "";
            this.localization = {};
            this.t = {
                selectTeam: "Select the Team"
            };
        }
        handleSelectedTeam(e) {
            var _a;
            this.dispatchEvent(new CustomEvent("team-selected", {
                bubbles: true,
                composed: true,
                detail: {
                    team: (_a = e.detail.option) !== null && _a !== void 0 ? _a : { teamId: "", teamName: "" }
                }
            }));
        }
        static get styles() {
            return _UserProfile_scss__WEBPACK_IMPORTED_MODULE_2__["default"];
        }
        updated(changedProperties) {
            super.updated(changedProperties);
            // If new teams don't contain the selected/default team, reset the selection
            if (changedProperties.has("teams") && this.teams) {
                if (!this.teams.find((team) => team.teamName === this.defaultTeam)) {
                    this.handleSelectedTeam(new CustomEvent("team-selected", { detail: { option: null } }));
                }
            }
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
        <md-dropdown
          .title=${this.t.selectTeam}
          ariaLabel=${this.t.selectTeam}
          .options=${this.teams}
          .defaultOption=${this.teams.find((team) => team.teamName === this.defaultTeam) || {}}
          .visibleOptions=${3}
          option-id="teamId"
          option-value="teamName"
          newMomentum
          @dropdown-selected=${this.handleSelectedTeam}
        ></md-dropdown>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Array })
    ], Element.prototype, "teams", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: String })
    ], Element.prototype, "defaultTeam", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Object })
    ], Element.prototype, "localization", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "t", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.customElement)("uuip-wc-user-profile-team")
    ], Element);
    UserProfileTeam.Element = Element;
})(UserProfileTeam || (UserProfileTeam = {}));


/***/ }),

/***/ "./src/components/UserProfile/components/VoiceOptionSelection.ts":
/*!***********************************************************************!*\
  !*** ./src/components/UserProfile/components/VoiceOptionSelection.ts ***!
  \***********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   UserProfileVoiceOption: () => (/* binding */ UserProfileVoiceOption)
/* harmony export */ });
/* harmony import */ var _mixins_i18n__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18n */ "./src/mixins/i18n.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _UserProfile_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../UserProfile.scss */ "./src/components/UserProfile/UserProfile.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var UserProfileVoiceOption;
(function (UserProfileVoiceOption) {
    /**
     * @element uuip-wc-user-profile-voice-option
     * @fires voice-selected
     */
    let Element = class Element extends (0,_mixins_i18n__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_1__.LitElement) {
        constructor() {
            super(...arguments);
            this.voiceOptions = [];
            this.defaultVoiceOption = null;
            this.localization = {};
            this.t = {
                loginVoiceInfoButtonLabel: "Voice option info",
                loginVoiceInfo: "Enter the Dial Number / Select Extension if you are provided with a calling extension number by the administrator / Select Desktop for calls through the internet.",
                voiceSelectionTitle: "Handle calls using"
            };
        }
        handleSelectedVoiceOption(e) {
            this.dispatchEvent(new CustomEvent("voice-selected", {
                bubbles: true,
                composed: true,
                detail: {
                    voice: e.detail.option
                }
            }));
        }
        static get styles() {
            return _UserProfile_scss__WEBPACK_IMPORTED_MODULE_2__["default"];
        }
        renderInfoTooltip() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
        <md-tooltip ?opened=${false} message=${this.t.loginVoiceInfo} placement="bottom">
          <md-button ariaLabel=${this.t.loginVoiceInfoButtonLabel} circle variant="ghost" size="20">
            <md-icon name="info-badge-filled" size="16" iconSet="momentumDesign"></md-icon>
          </md-button>
        </md-tooltip>
      `;
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.html) `
        <div class="selection-container">
          <div class="selection-title-container">
            <p class="selection-title">${this.t.voiceSelectionTitle}</p>
            ${this.renderInfoTooltip()}
          </div>
          <md-dropdown
            .title=${this.t.voiceSelectionTitle}
            ariaLabel=${this.t.voiceSelectionTitle}
            .options=${this.voiceOptions}
            .defaultOption=${this.voiceOptions.find((voiceOption) => voiceOption.name === this.defaultVoiceOption) ||
                {}}
            option-id="name"
            option-value="displayName"
            .visibleOptions=${3}
            newMomentum
            @dropdown-selected=${this.handleSelectedVoiceOption}
          ></md-dropdown>
        </div>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Array })
    ], Element.prototype, "voiceOptions", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: String })
    ], Element.prototype, "defaultVoiceOption", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.property)({ type: Object })
    ], Element.prototype, "localization", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.internalProperty)()
    ], Element.prototype, "t", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_1__.customElement)("uuip-wc-user-profile-voice-option")
    ], Element);
    UserProfileVoiceOption.Element = Element;
})(UserProfileVoiceOption || (UserProfileVoiceOption = {}));


/***/ }),

/***/ "./src/components/UserStationLogin/UserStationLogin.scss":
/*!***************************************************************!*\
  !*** ./src/components/UserStationLogin/UserStationLogin.scss ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`@media screen and (max-height: 540px) {
  md-modal::part(modal-container) {
    max-height: calc(100vh - 2%);
  }
  md-modal::part(modal-content) {
    min-height: 100%;
    max-height: 100vh;
    overflow-y: auto;
  }
}
md-modal::part(modal-content) {
  min-height: 226px;
}

md-modal::part(modal-flex-container) {
  padding: 16px;
  gap: 16px;
}

md-modal::part(modal-header) {
  align-items: baseline;
  padding: 0px;
}

md-modal::part(modal-body) {
  overflow: visible;
  padding: 0px;
}

md-modal::part(modal-footer) {
  padding: 0px;
}

.sl-form-label {
  color: var(--md-primary-text-color);
  display: block;
  font-family: var(--font-family);
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  text-align: left;
  margin: 0px;
}

.sl-footer {
  margin-top: 4px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
}

.footer-buttons {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}

.station-body-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
/*# sourceURL=/home/jenkins/agent/workspace/cicd-jobs/wxcc-common-CI-Builder/packages/@uuip/unified-ui-platform-common-components/src/components/UserStationLogin/UserStationLogin.scss */
/*# sourceURL=UserStationLogin.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`);
    

/***/ }),

/***/ "./src/components/UserStationLogin/UserStationLogin.ts":
/*!*************************************************************!*\
  !*** ./src/components/UserStationLogin/UserStationLogin.ts ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   UserStationLogin: () => (/* binding */ UserStationLogin)
/* harmony export */ });
/* harmony import */ var _mixins_i18n__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/mixins/i18n */ "./src/mixins/i18n.ts");
/* harmony import */ var _UserStationLogin_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./UserStationLogin.scss */ "./src/components/UserStationLogin/UserStationLogin.scss");
/* harmony import */ var _UserProfile_UserProfileTypes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../UserProfile/UserProfileTypes */ "./src/components/UserProfile/UserProfileTypes.ts");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_3__);
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var UserStationLogin;
(function (UserStationLogin) {
    /**
     * @element uuip-wc-user-station-login
     * @fires signout-clicked
     * @fires confirm-clicked
     * @fires component-updated
     */
    let Element = class Element extends (0,_mixins_i18n__WEBPACK_IMPORTED_MODULE_0__.i18nMixin)(lit_element__WEBPACK_IMPORTED_MODULE_3__.LitElement) {
        constructor() {
            super(...arguments);
            this.isModalOpen = false;
            this.isRememberMeChecked = false;
            this.isSubmitBusy = false;
            this.isDesktopEmergencyNotificationEnabled = false;
            this.isEmergencyNotificationAlreadyDisplayed = false;
            this.defaultDialNumber = "";
            this.defaultTeam = { teamId: "", teamName: "" };
            this.dialPlanRegexStrings = [];
            this.dialNumbers = [];
            this.defaultExtension = "";
            this.errorMessage = "";
            this.errorType = "none";
            this.extensions = [];
            this.isCallMonitoringEnabled = false;
            this.isExternalTeamSelection = false;
            this.isReadonlyNumber = false;
            this.loginVoiceOptions = [];
            this.defaultVoiceOption = null;
            this.preferenceRoleName = "";
            this.teams = [];
            this.userRoles = [];
            this.devices = {};
            this.shouldRenderDevices = false;
            this.dialNumber = "";
            this.internationalDialNumber = "";
            this.isInternational = false;
            this.countryCodeValue = "+1"; // initial country code of US.
            this.countryCallingCode = "+1, United States of America, US";
            this.localization = {};
            this.t = {
                // UserStationLogin related
                stationCredentials: "Station Credentials",
                confirmInteractionProperties: "Confirm your interaction preferences",
                rememberMe: "Don't show this again",
                rememberMeInfo: "If unchecked, your details will still be saved. You can change these details in your profile settings.",
                rememberMeInfoButtonLabel: "Remember me info",
                signOutButton: "Sign Out",
                confirmButton: "Confirm",
                cancelButton: "Cancel",
                continueButton: "Continue",
                // UserProfile related
                dialNumberSelectionTitle: "Dial number",
                dialNumberPlaceholder: "Enter your Dial number",
                dialNumberInvalid: "Dial number is invalid. Please contact your administrator.",
                extensionInfo: "Enter your calling extension number provided by the administrator.",
                extensionPlaceHolder: "Enter the Webex Calling Extension",
                extensionSelectionTitle: "Extension",
                extensionInvalid: "Extension number is invalid. Please contact your administrator.",
                extensionDevicesInfo: "Make sure you're using an available device",
                extensionDeviceUnavailable: "Select another extension that has devices available",
                extensionDeviceSignedOut: "Sign in to this device or select another extension",
                deviceIsAvailable: "is available",
                deviceIsNotAvailable: "isn't available",
                teamSelectionTitle: "Your team",
                selectTeam: "Select the Team",
                roleSelectionTitle: "Your role",
                selectRole: "Select the Role",
                supervisorRole: "Supervisor",
                supervisorAndAgentRole: "Supervisor and Agent",
                loginVoiceInfoButtonLabel: "Voice option info",
                loginVoiceInfo: "Enter the Dial Number / Select Extension if you are provided with a calling extension number by the administrator / Select Desktop for calls through the internet.",
                voiceSelectionTitle: "Handle calls using",
                voiceOptionDialNumber: "Dial Number",
                voiceOptionExtension: "Extension",
                voiceOptionDesktop: "Desktop",
                emergencyNotificationTitle: "Emergency Service Notification",
                emergencyNotificationSubTitle: "Dialing Emergency Services:",
                emergencyNotificationContent: 
                // eslint-disable-next-line max-len
                "Use the Desktop outdial dial pad, when using the Desktop Telephony option for dialling emergency services (e.g. 999). Emergency services may not be accessible outside of your home country.",
                emergencyNotificationWarningMessage: 
                // eslint-disable-next-line max-len
                "When working outside the corporate location, make sure to update your current address in the Emergency service section. Not adding your current address may delay emergency services in locating you.",
                emergencyNotificationWarningLinkText: "See help section",
                emergencyNotificationAcknowledgement: "I have read the notification.",
                internationalFormatButtonLabel: "International dialling format",
                internationalFormatTooltip: "Choose the country code and enter the dial number. To use another dial number format, untick this tickbox.",
                countryCodeAriaLabel: "Country code",
                clearAriaLabel: "Clear"
            };
            this.isConfirmButtonDisabled = true;
            this.showEmergencyNotificationModal = false;
            this.isEmergencyNotificationAccepted = false;
            this.selectedVoiceOption = "";
            this.isSubmitRequested = false;
        }
        get emergencyNotificationDisplayMode() {
            if (!this.isDesktopEmergencyNotificationEnabled || this.selectedVoiceOption !== "BROWSER") {
                return _UserProfile_UserProfileTypes__WEBPACK_IMPORTED_MODULE_2__.UserProfileTypes.EmergencyNotificationDisplayMode.NONE;
            }
            if (this.isEmergencyNotificationAlreadyDisplayed) {
                return _UserProfile_UserProfileTypes__WEBPACK_IMPORTED_MODULE_2__.UserProfileTypes.EmergencyNotificationDisplayMode.BANNER;
            }
            return this.showEmergencyNotificationModal
                ? _UserProfile_UserProfileTypes__WEBPACK_IMPORTED_MODULE_2__.UserProfileTypes.EmergencyNotificationDisplayMode.MODAL
                : _UserProfile_UserProfileTypes__WEBPACK_IMPORTED_MODULE_2__.UserProfileTypes.EmergencyNotificationDisplayMode.NONE;
        }
        get isEmergencyDisplayAsModal() {
            return this.emergencyNotificationDisplayMode === _UserProfile_UserProfileTypes__WEBPACK_IMPORTED_MODULE_2__.UserProfileTypes.EmergencyNotificationDisplayMode.MODAL;
        }
        static get styles() {
            return _UserStationLogin_scss__WEBPACK_IMPORTED_MODULE_1__["default"];
        }
        onSubmit() {
            this.isSubmitRequested = !this.isSubmitRequested;
        }
        evt(name, detail) {
            this.dispatchEvent(new CustomEvent(name, { bubbles: true, composed: true, detail }));
        }
        onSignoutButtonClicked() {
            this.isModalOpen = false;
            this.dispatchEvent(new CustomEvent("signout-clicked", { bubbles: true, composed: true }));
        }
        onConfirmButtonClicked() {
            if (this.isDesktopEmergencyNotificationEnabled &&
                this.selectedVoiceOption === "BROWSER" &&
                !this.isEmergencyNotificationAlreadyDisplayed) {
                this.showEmergencyNotificationModal = true;
                return;
            }
            this.onSubmit();
        }
        renderHeader() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
        <div slot="header">
          ${this.isEmergencyDisplayAsModal ? this.renderEmergencyNotificationHeader() : this.renderStationHeader()}
        </div>
      `;
        }
        renderStationHeader() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) ` <h2 class="sl-form-label">${this.t.confirmInteractionProperties}</h2> `;
        }
        renderEmergencyNotificationHeader() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) ` <h2 class="sl-form-label">${this.t.emergencyNotificationTitle}</h2> `;
        }
        renderStationBody() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
        <div class="station-body-container">
          <uuip-wc-user-profile
            .userRole=${this.userRoles.join("_")}
            .teams=${this.teams}
            .defaultTeam=${this.defaultTeam}
            .extensions=${this.extensions}
            .getProfileDataTriggered=${this.isSubmitRequested}
            ?isCallMonitoringEnabled=${this.isCallMonitoringEnabled}
            ?isExternalTeamSelection=${this.isExternalTeamSelection}
            ?isRememberMeChecked=${this.isRememberMeChecked}
            .dialNumbers=${this.dialNumbers}
            .defaultExtension=${this.defaultExtension}
            .errorMessage=${this.errorMessage}
            .errorType=${this.errorType}
            .devices=${this.devices}
            ?isReadonlyNumber=${this.isReadonlyNumber}
            .dialNumber=${this.dialNumber}
            .internationalDialNumber=${this.internationalDialNumber}
            ?isInternational=${this.isInternational}
            .countryCodeValue=${this.countryCodeValue}
            .countryCallingCode=${this.countryCallingCode}
            .dialPlanRegexStrings=${this.dialPlanRegexStrings}
            .loginVoiceOptions=${this.loginVoiceOptions}
            .defaultVoiceOption=${this.defaultVoiceOption}
            .preferenceRoleName=${this.preferenceRoleName}
            .shouldRenderDevices=${this.shouldRenderDevices}
            .emergencyNotificationDisplayMode=${this.emergencyNotificationDisplayMode}
            .localization=${{
                dialNumberSelectionTitle: this.t.dialNumberSelectionTitle,
                dialNumberPlaceholder: this.t.dialNumberPlaceholder,
                dialNumberInvalid: this.t.dialNumberInvalid,
                extensionInfo: this.t.extensionInfo,
                extensionPlaceHolder: this.t.extensionPlaceHolder,
                extensionSelectionTitle: this.t.extensionSelectionTitle,
                extensionInvalid: this.t.extensionInvalid,
                extensionDevicesInfo: this.t.extensionDevicesInfo,
                extensionDeviceUnavailable: this.t.extensionDeviceUnavailable,
                extensionDeviceSignedOut: this.t.extensionDeviceSignedOut,
                deviceIsAvailable: this.t.deviceIsAvailable,
                deviceIsNotAvailable: this.t.deviceIsNotAvailable,
                teamSelectionTitle: this.t.teamSelectionTitle,
                selectTeam: this.t.selectTeam,
                rememberMe: this.t.rememberMe,
                rememberMeInfo: this.t.rememberMeInfo,
                rememberMeInfoButtonLabel: this.t.rememberMeInfoButtonLabel,
                roleSelectionTitle: this.t.roleSelectionTitle,
                selectRole: this.t.selectRole,
                supervisorRole: this.t.supervisorRole,
                supervisorAndAgentRole: this.t.supervisorAndAgentRole,
                loginVoiceInfoButtonLabel: this.t.loginVoiceInfoButtonLabel,
                loginVoiceInfo: this.t.loginVoiceInfo,
                voiceSelectionTitle: this.t.voiceSelectionTitle,
                voiceOptionDialNumber: this.t.voiceOptionDialNumber,
                voiceOptionExtension: this.t.voiceOptionExtension,
                voiceOptionDesktop: this.t.voiceOptionDesktop,
                emergencyNotificationTitle: this.t.emergencyNotificationTitle,
                emergencyNotificationSubTitle: this.t.emergencyNotificationSubTitle,
                emergencyNotificationContent: this.t.emergencyNotificationContent,
                emergencyNotificationWarningMessage: this.t.emergencyNotificationWarningMessage,
                emergencyNotificationWarningLinkText: this.t.emergencyNotificationWarningLinkText,
                emergencyNotificationAcknowledgement: this.t.emergencyNotificationAcknowledgement,
                internationalFormatButtonLabel: this.t.internationalFormatButtonLabel,
                internationalFormatTooltip: this.t.internationalFormatTooltip,
                countryCodeAriaLabel: this.t.countryCodeAriaLabel,
                clearAriaLabel: this.t.clearAriaLabel
            }}
            @data-available=${(e) => {
                this.isSubmitRequested = false;
                this.evt("confirm-clicked", {
                    data: e.detail.data
                });
            }}
            @component-updated=${(e) => {
                this.isConfirmButtonDisabled = !e.detail.isComplete;
                this.selectedVoiceOption = e.detail.data.loginOption;
                this.evt("component-updated", {
                    data: e.detail.data
                });
            }}
            @emergency-notification-read=${(e) => {
                this.isEmergencyNotificationAccepted = e.detail.isRead;
            }}
          >
            <slot name="external-team-selection" slot="external-team-selection-slot" />
          </uuip-wc-user-profile>
        </div>
      `;
        }
        renderFooter() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
        <div class="sl-footer" slot="footer">
          ${this.isEmergencyDisplayAsModal ? this.renderEmergencyNotificationFooter() : this.renderStationFooter()}
        </div>
      `;
        }
        renderStationFooter() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
        <div class="footer-buttons">
          <md-button variant="secondary" @button-click=${this.onSignoutButtonClicked} ariaLabel=${this.t.signOutButton}>
            ${this.t.signOutButton}
          </md-button>

          <md-button
            variant="primary"
            .disabled=${this.isConfirmButtonDisabled || this.isSubmitBusy}
            @button-click=${this.onConfirmButtonClicked}
            ariaLabel=${this.t.confirmButton}
          >
            ${this.isSubmitBusy ? (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) ` <md-loading></md-loading> ` : this.t.confirmButton}
          </md-button>
        </div>
      `;
        }
        renderEmergencyNotificationFooter() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
        <div class="footer-buttons">
          <md-button
            variant="secondary"
            @button-click=${() => {
                this.showEmergencyNotificationModal = false;
            }}
          >
            ${this.t.cancelButton}
          </md-button>
          <md-button
            variant="primary"
            @button-click=${this.onSubmit}
            .disabled=${!this.isEmergencyNotificationAccepted ||
                (this.isEmergencyNotificationAccepted && this.isSubmitBusy)}
          >
            ${this.isSubmitBusy ? (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) ` <md-loading></md-loading> ` : this.t.continueButton}
          </md-button>
        </div>
      `;
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.html) `
        <md-modal
          lang=${this.lang}
          .show=${this.isModalOpen}
          size="small"
          .hideFooter=${true}
          .hideHeader=${true}
          noExitOnEsc
          disableInitialFocus
          aria-label=${this.t.stationCredentials}
        >
          ${this.renderHeader()} ${this.renderStationBody()} ${this.renderFooter()}
        </md-modal>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Boolean })
    ], Element.prototype, "isModalOpen", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Boolean })
    ], Element.prototype, "isRememberMeChecked", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Boolean })
    ], Element.prototype, "isSubmitBusy", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Boolean })
    ], Element.prototype, "isDesktopEmergencyNotificationEnabled", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Boolean })
    ], Element.prototype, "isEmergencyNotificationAlreadyDisplayed", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: String })
    ], Element.prototype, "defaultDialNumber", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Object })
    ], Element.prototype, "defaultTeam", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Array })
    ], Element.prototype, "dialPlanRegexStrings", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Array })
    ], Element.prototype, "dialNumbers", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: String })
    ], Element.prototype, "defaultExtension", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: String })
    ], Element.prototype, "errorMessage", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: String })
    ], Element.prototype, "errorType", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Array })
    ], Element.prototype, "extensions", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Boolean })
    ], Element.prototype, "isCallMonitoringEnabled", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Boolean })
    ], Element.prototype, "isExternalTeamSelection", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Boolean })
    ], Element.prototype, "isReadonlyNumber", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Array })
    ], Element.prototype, "loginVoiceOptions", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: String })
    ], Element.prototype, "defaultVoiceOption", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: String })
    ], Element.prototype, "preferenceRoleName", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Array })
    ], Element.prototype, "teams", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Array })
    ], Element.prototype, "userRoles", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Object })
    ], Element.prototype, "devices", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Boolean })
    ], Element.prototype, "shouldRenderDevices", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: String })
    ], Element.prototype, "dialNumber", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: String })
    ], Element.prototype, "internationalDialNumber", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Boolean })
    ], Element.prototype, "isInternational", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: String })
    ], Element.prototype, "countryCodeValue", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: String })
    ], Element.prototype, "countryCallingCode", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.property)({ type: Object })
    ], Element.prototype, "localization", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "t", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "isConfirmButtonDisabled", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "showEmergencyNotificationModal", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "isEmergencyNotificationAccepted", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "selectedVoiceOption", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.internalProperty)()
    ], Element.prototype, "isSubmitRequested", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_3__.customElement)("uuip-wc-user-station-login")
    ], Element);
    UserStationLogin.Element = Element;
})(UserStationLogin || (UserStationLogin = {}));


/***/ }),

/***/ "./src/components/WidgetWrapper/WidgetWrapper.scss":
/*!*********************************************************!*\
  !*** ./src/components/WidgetWrapper/WidgetWrapper.scss ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);

        
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,lit_element__WEBPACK_IMPORTED_MODULE_0__.css)`:host {
  --header-height: 48px;
  --font-size: 16px;
  --border-width: 1px;
  --border: var(--border-width) solid var(--md-primary-separator-color);
  height: 100%;
  width: 100%;
  box-sizing: border-box;
}

.ax-widget--slotted {
  overflow: hidden;
  height: 100%;
  width: 100%;
}

.ax-widget--section {
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  border: var(--border);
  margin: calc(var(--border-width) * -1) 0 0 calc(var(--border-width) * -1);
}

.ax-widget--header {
  height: var(--header-height);
  color: var(--md-primary-text-color);
  display: flex;
  align-items: center;
  background-color: var(--md-primary-bg-color);
}
.ax-widget--header__bordered {
  border-bottom: var(--border);
}
.ax-widget--header h3 {
  margin: 0;
  font-size: var(--font-size);
  font-weight: 300;
  font-family: inherit;
  padding: 0 1em;
}
/*# sourceURL=/home/jenkins/agent/workspace/cicd-jobs/wxcc-common-CI-Builder/packages/@uuip/unified-ui-platform-common-components/src/components/WidgetWrapper/WidgetWrapper.scss */
/*# sourceURL=WidgetWrapper.scss */
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL2plbmtpbnMvYWdlbnQvd29ya3NwYWNlL2NpY2Qtam9icy93eGNjLWNvbW1vbi1DSS1CdWlsZGVyL3BhY2thZ2VzL0B1dWlwL3VuaWZpZWQtdWktcGxhdGZvcm0tY29tbW9uLWNvbXBvbmVudHMvc3JjL2NvbXBvbmVudHMvV2lkZ2V0V3JhcHBlci9XaWRnZXRXcmFwcGVyLnNjc3MiLCJXaWRnZXRXcmFwcGVyLnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRSxxQkFBQTtFQUNBLGlCQUFBO0VBQ0EsbUJBQUE7RUFDQSxxRUFBQTtFQUNBLFlBQUE7RUFDQSxXQUFBO0VBQ0Esc0JBQUE7QUNDRjs7QURFQTtFQUNFLGdCQUFBO0VBQ0EsWUFBQTtFQUNBLFdBQUE7QUNDRjs7QURFQTtFQUNFLFlBQUE7RUFDQSxXQUFBO0VBQ0Esc0JBQUE7RUFDQSxxQkFBQTtFQUNBLHlFQUFBO0FDQ0Y7O0FERUE7RUFDRSw0QkFBQTtFQUNBLG1DQUFBO0VBQ0EsYUFBQTtFQUNBLG1CQUFBO0VBQ0EsNENBQUE7QUNDRjtBRENFO0VBQ0UsNEJBQUE7QUNDSjtBREVFO0VBQ0UsU0FBQTtFQUNBLDJCQUFBO0VBQ0EsZ0JBQUE7RUFDQSxvQkFBQTtFQUNBLGNBQUE7QUNBSiIsImZpbGUiOiJXaWRnZXRXcmFwcGVyLnNjc3MiLCJzb3VyY2VzQ29udGVudCI6WyI6aG9zdCB7XG4gIC0taGVhZGVyLWhlaWdodDogNDhweDtcbiAgLS1mb250LXNpemU6IDE2cHg7XG4gIC0tYm9yZGVyLXdpZHRoOiAxcHg7XG4gIC0tYm9yZGVyOiB2YXIoLS1ib3JkZXItd2lkdGgpIHNvbGlkIHZhcigtLW1kLXByaW1hcnktc2VwYXJhdG9yLWNvbG9yKTtcbiAgaGVpZ2h0OiAxMDAlO1xuICB3aWR0aDogMTAwJTtcbiAgYm94LXNpemluZzogYm9yZGVyLWJveDtcbn1cblxuLmF4LXdpZGdldC0tc2xvdHRlZCB7XG4gIG92ZXJmbG93OiBoaWRkZW47XG4gIGhlaWdodDogMTAwJTtcbiAgd2lkdGg6IDEwMCU7XG59XG5cbi5heC13aWRnZXQtLXNlY3Rpb24ge1xuICBoZWlnaHQ6IDEwMCU7XG4gIHdpZHRoOiAxMDAlO1xuICBib3gtc2l6aW5nOiBib3JkZXItYm94O1xuICBib3JkZXI6IHZhcigtLWJvcmRlcik7XG4gIG1hcmdpbjogY2FsYyh2YXIoLS1ib3JkZXItd2lkdGgpICogLTEpIDAgMCBjYWxjKHZhcigtLWJvcmRlci13aWR0aCkgKiAtMSk7IC8vIEhhY2sgdG8gZGlzcGxheSBzaW5nbGUgYm9yZGVyIGluIGEgZ3JpZFxufVxuXG4uYXgtd2lkZ2V0LS1oZWFkZXIge1xuICBoZWlnaHQ6IHZhcigtLWhlYWRlci1oZWlnaHQpO1xuICBjb2xvcjogdmFyKC0tbWQtcHJpbWFyeS10ZXh0LWNvbG9yKTtcbiAgZGlzcGxheTogZmxleDtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgYmFja2dyb3VuZC1jb2xvcjogdmFyKC0tbWQtcHJpbWFyeS1iZy1jb2xvcik7XG5cbiAgJl9fYm9yZGVyZWQge1xuICAgIGJvcmRlci1ib3R0b206IHZhcigtLWJvcmRlcik7XG4gIH1cblxuICBoMyB7XG4gICAgbWFyZ2luOiAwO1xuICAgIGZvbnQtc2l6ZTogdmFyKC0tZm9udC1zaXplKTtcbiAgICBmb250LXdlaWdodDogMzAwO1xuICAgIGZvbnQtZmFtaWx5OiBpbmhlcml0O1xuICAgIHBhZGRpbmc6IDAgMWVtO1xuICB9XG59XG4iLCI6aG9zdCB7XG4gIC0taGVhZGVyLWhlaWdodDogNDhweDtcbiAgLS1mb250LXNpemU6IDE2cHg7XG4gIC0tYm9yZGVyLXdpZHRoOiAxcHg7XG4gIC0tYm9yZGVyOiB2YXIoLS1ib3JkZXItd2lkdGgpIHNvbGlkIHZhcigtLW1kLXByaW1hcnktc2VwYXJhdG9yLWNvbG9yKTtcbiAgaGVpZ2h0OiAxMDAlO1xuICB3aWR0aDogMTAwJTtcbiAgYm94LXNpemluZzogYm9yZGVyLWJveDtcbn1cblxuLmF4LXdpZGdldC0tc2xvdHRlZCB7XG4gIG92ZXJmbG93OiBoaWRkZW47XG4gIGhlaWdodDogMTAwJTtcbiAgd2lkdGg6IDEwMCU7XG59XG5cbi5heC13aWRnZXQtLXNlY3Rpb24ge1xuICBoZWlnaHQ6IDEwMCU7XG4gIHdpZHRoOiAxMDAlO1xuICBib3gtc2l6aW5nOiBib3JkZXItYm94O1xuICBib3JkZXI6IHZhcigtLWJvcmRlcik7XG4gIG1hcmdpbjogY2FsYyh2YXIoLS1ib3JkZXItd2lkdGgpICogLTEpIDAgMCBjYWxjKHZhcigtLWJvcmRlci13aWR0aCkgKiAtMSk7XG59XG5cbi5heC13aWRnZXQtLWhlYWRlciB7XG4gIGhlaWdodDogdmFyKC0taGVhZGVyLWhlaWdodCk7XG4gIGNvbG9yOiB2YXIoLS1tZC1wcmltYXJ5LXRleHQtY29sb3IpO1xuICBkaXNwbGF5OiBmbGV4O1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuICBiYWNrZ3JvdW5kLWNvbG9yOiB2YXIoLS1tZC1wcmltYXJ5LWJnLWNvbG9yKTtcbn1cbi5heC13aWRnZXQtLWhlYWRlcl9fYm9yZGVyZWQge1xuICBib3JkZXItYm90dG9tOiB2YXIoLS1ib3JkZXIpO1xufVxuLmF4LXdpZGdldC0taGVhZGVyIGgzIHtcbiAgbWFyZ2luOiAwO1xuICBmb250LXNpemU6IHZhcigtLWZvbnQtc2l6ZSk7XG4gIGZvbnQtd2VpZ2h0OiAzMDA7XG4gIGZvbnQtZmFtaWx5OiBpbmhlcml0O1xuICBwYWRkaW5nOiAwIDFlbTtcbn0iXX0= */`);
    

/***/ }),

/***/ "./src/components/WidgetWrapper/WidgetWrapper.ts":
/*!*******************************************************!*\
  !*** ./src/components/WidgetWrapper/WidgetWrapper.ts ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   WidgetWrapper: () => (/* binding */ WidgetWrapper)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _components_MaximizeArea_MaximizeAreaBlock__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../components/MaximizeArea/MaximizeAreaBlock */ "./src/components/MaximizeArea/MaximizeAreaBlock.ts");
/* harmony import */ var _WidgetWrapper_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./WidgetWrapper.scss */ "./src/components/WidgetWrapper/WidgetWrapper.scss");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var WidgetWrapper;
(function (WidgetWrapper) {
    /**
     * @element uuip-wc-widget-wrapper
     */
    let Element = class Element extends lit_element__WEBPACK_IMPORTED_MODULE_0__.LitElement {
        constructor() {
            super(...arguments);
            this.title = "";
            this.id = "";
            this.maximizeBlockLocalization = {};
            this.setTitleHandler = (e) => {
                this.title = e.detail.title;
            };
        }
        static get styles() {
            return [_WidgetWrapper_scss__WEBPACK_IMPORTED_MODULE_2__["default"]];
        }
        connectedCallback() {
            super.connectedCallback();
            if (this.id) {
                window.addEventListener(this.id, this.setTitleHandler);
            }
        }
        disconnectedCallback() {
            if (this.id) {
                window.removeEventListener(this.id, this.setTitleHandler);
            }
        }
        render() {
            return (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.html) `
        <section class="ax-widget--section" part="widget-section">
          ${!this.maximizeToAreaName
                ? (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.html) `
                <div class="ax-widget--header ax-widget--header__bordered">
                  <h3>${this.title}</h3>
                </div>
                <div class="ax-widget--slotted">
                  <slot></slot>
                </div>
              `
                : (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.html) `
                <uuip-wc-maximize-area-block
                  .maximizeToAreaName="${this.maximizeToAreaName}"
                  .localization="${this.maximizeBlockLocalization}"
                >
                  <div class="ax-widget--header" slot="title">
                    <h3>${this.title}</h3>
                  </div>
                  <div class="ax-widget--slotted">
                    <slot></slot>
                  </div>
                </uuip-wc-maximize-area-block>
              `}
        </section>
      `;
        }
    };
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.property)({ type: String })
    ], Element.prototype, "title", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.property)({ type: String })
    ], Element.prototype, "maximizeToAreaName", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.property)({ type: String })
    ], Element.prototype, "id", void 0);
    __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.property)({ type: Object })
    ], Element.prototype, "maximizeBlockLocalization", void 0);
    Element = __decorate([
        (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.customElement)("uuip-wc-widget-wrapper")
    ], Element);
    WidgetWrapper.Element = Element;
})(WidgetWrapper || (WidgetWrapper = {}));


/***/ }),

/***/ "./src/mixins/i18n.ts":
/*!****************************!*\
  !*** ./src/mixins/i18n.ts ***!
  \****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   i18nMixin: () => (/* binding */ i18nMixin)
/* harmony export */ });
//////////
// MIXIN
const i18nMixin = (baseElement) => {
    return class extends baseElement {
        firstUpdated(changedProperties) {
            super.firstUpdated(changedProperties);
            const thisI18n = this;
            if (!thisI18n.t) {
                throw new Error('Localization component MUST have @internalProperty "t"');
            }
            if (!thisI18n.localization) {
                throw new Error('Localization component MUST have @property "localization"');
            }
        }
        updated(changedProperties) {
            super.updated(changedProperties);
            changedProperties.forEach((oldValue, name) => {
                if (name === "localization") {
                    const thisI18n = this;
                    thisI18n.t = Object.keys(thisI18n.t).reduce((_t, k) => {
                        if (thisI18n.localization[k] !== undefined) {
                            _t[k] = thisI18n.localization[k];
                        }
                        else {
                            _t[k] = thisI18n.t[k];
                        }
                        return _t;
                    }, {});
                }
            });
        }
    };
};


/***/ }),

/***/ "./src/sdk.ts":
/*!********************!*\
  !*** ./src/sdk.ts ***!
  \********************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   logger: () => (/* binding */ logger)
/* harmony export */ });
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @uuip/unified-ui-platform-sdk */ "@uuip/unified-ui-platform-sdk");
/* harmony import */ var _uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__);

const logger = (0,_uuip_unified_ui_platform_sdk__WEBPACK_IMPORTED_MODULE_0__.createLogger)("uuip-mfe-wc-based");


/***/ }),

/***/ "./src/utils/WindowListenersHub.ts":
/*!*****************************************!*\
  !*** ./src/utils/WindowListenersHub.ts ***!
  \*****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   WINDOW_LISTENERS_HUB: () => (/* binding */ WINDOW_LISTENERS_HUB)
/* harmony export */ });
class WindowListenersHub {
    constructor() {
        this.listeners = {};
        this.listenersWrappers = {};
    }
    on(eventName, listener) {
        // One window listener per eventName
        if (!this.listeners[eventName]) {
            this.listeners[eventName] = [];
            this.listenersWrappers[eventName] = (e) => this.listeners[eventName].forEach((eventListener) => eventListener.call(eventListener, e));
            window.addEventListener(eventName, this.listenersWrappers[eventName]);
        }
        this.listeners[eventName].push(listener);
        return () => this.off(eventName, listener);
    }
    off(eventName, listener) {
        if (this.listeners[eventName]) {
            const idx = this.listeners[eventName].findIndex((l) => l === listener);
            if (idx !== -1) {
                this.listeners[eventName].splice(idx, 1);
                if (this.listeners[eventName].length < 1) {
                    window.removeEventListener(eventName, this.listenersWrappers[eventName]);
                    delete this.listeners[eventName];
                    delete this.listenersWrappers[eventName];
                }
            }
        }
    }
    once(eventName, listener, onceConditionChecker) {
        const _listener = (...args) => {
            let res = true;
            if (typeof onceConditionChecker === "function") {
                res = onceConditionChecker(...args);
            }
            if (res) {
                listener(...args);
                this.off(eventName, _listener);
            }
        };
        this.on(eventName, _listener);
        return () => this.off(eventName, _listener);
    }
    dispatch(e) {
        window.dispatchEvent(e);
    }
    allOff(eventName) {
        const offEventName = (_eventName) => {
            if (_eventName in this.listeners) {
                let i = this.listeners[_eventName].length;
                while (i) {
                    const listener = this.listeners[_eventName][i - 1];
                    this.off(_eventName, listener);
                    i--;
                }
            }
        };
        if (eventName) {
            offEventName(eventName);
        }
        else {
            Object.keys(this.listeners).forEach((eventListenerName) => offEventName(eventListenerName));
        }
    }
}
const WINDOW_LISTENERS_HUB = new WindowListenersHub();


/***/ }),

/***/ "./src/utils/helpers.ts":
/*!******************************!*\
  !*** ./src/utils/helpers.ts ***!
  \******************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   createElementTransitionEndPromise: () => (/* binding */ createElementTransitionEndPromise),
/* harmony export */   createTimeoutPromise: () => (/* binding */ createTimeoutPromise),
/* harmony export */   isCoordCloseToRect: () => (/* binding */ isCoordCloseToRect),
/* harmony export */   relativeTimeFormatter: () => (/* binding */ relativeTimeFormatter),
/* harmony export */   renderListError: () => (/* binding */ renderListError),
/* harmony export */   renderLoadingSpinner: () => (/* binding */ renderLoadingSpinner),
/* harmony export */   renderPlaceholder: () => (/* binding */ renderPlaceholder),
/* harmony export */   renderSearchErrorMessage: () => (/* binding */ renderSearchErrorMessage),
/* harmony export */   throttle: () => (/* binding */ throttle)
/* harmony export */ });
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lit-element */ "lit-element");
/* harmony import */ var lit_element__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lit_element__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! luxon */ "luxon");
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(luxon__WEBPACK_IMPORTED_MODULE_1__);


const relativeTimeFormatter = (timeInMilliseconds, totalTimeInMilliSeconds = 0) => {
    if (totalTimeInMilliSeconds <= timeInMilliseconds) {
        totalTimeInMilliSeconds = timeInMilliseconds;
    }
    let format = "mm:ss";
    if (luxon__WEBPACK_IMPORTED_MODULE_1__.Duration.fromMillis(totalTimeInMilliSeconds).as("hours") >= 1) {
        format = "hh:mm:ss";
    }
    return luxon__WEBPACK_IMPORTED_MODULE_1__.Duration.fromMillis(timeInMilliseconds).shiftTo("hours", "minutes", "seconds").toFormat(format);
};
const throttle = (fn, delay = 1000 / 60) => {
    let lastTimeoutRef = undefined;
    let last = Date.now();
    // Throttling
    const next = (...args) => {
        const now = Date.now();
        window.clearTimeout(lastTimeoutRef);
        if (!last || now - last >= delay) {
            last = now;
            fn.call(fn, ...args);
        }
        else {
            lastTimeoutRef = window.setTimeout(() => next(...args), delay - (now - last));
        }
    };
    return (...args) => next(...args);
};
const createTimeoutPromise = (timeout = 0) => new Promise((resolve) => window.setTimeout(resolve, timeout));
const createElementTransitionEndPromise = (element, transitionPropertyName, transitionEndFailMsTimeout = 2000) => new Promise((resolve) => {
    // Awaiting transform end or timeout
    const onTransitionEnd = (e) => {
        if (e.propertyName === transitionPropertyName) {
            onTransitionEnd.clear();
            resolve();
        }
    };
    element.addEventListener("transitionend", onTransitionEnd);
    // Setup clear
    onTransitionEnd.clear = () => {
        // Remove timeout "clear"
        window.clearTimeout(onTransitionEnd.timeoutRef);
        // Remove Listener
        element.removeEventListener("transitionend", onTransitionEnd);
    };
    // Start timeout
    onTransitionEnd.timeoutRef = window.setTimeout(() => onTransitionEnd.clear(), transitionEndFailMsTimeout);
});
const isCoordCloseToRect = (coord, rect, distance) => {
    return (rect.left - distance <= coord.x &&
        rect.right + distance >= coord.x &&
        rect.top - distance <= coord.y &&
        rect.bottom + distance >= coord.y);
};
const renderLoadingSpinner = (spinnerSize = "18") => {
    return (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.html) `
    <div class="loading-spinner" part="spinner">
      <md-spinner size=${spinnerSize}></md-spinner>
    </div>
  `;
};
const renderSearchErrorMessage = (searchErrorMsg, errorIconSize = "16") => {
    return (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.html) `
    <div class="search-error">
      <div class="search-error-msg">
        <md-icon
          name="info-badge-filled"
          iconSet="momentumDesign"
          size=${errorIconSize}
          class="search-error-icon"
        ></md-icon>
        ${searchErrorMsg}
      </div>
    </div>
  `;
};
const renderPlaceholder = (placeholderIllustration, placeholderText) => {
    if (!placeholderIllustration) {
        return (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.html) `
      <div class="empty-state-placeholder">
        <span class="empty-title">${placeholderText}</span>
      </div>
    `;
    }
    return (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.html) `
    <div class="empty-state-placeholder">
      <uuip-wc-empty-state
        illustration-name=${placeholderIllustration}
        illustration-alt=${placeholderIllustration}
        class="empty-state-wrapper"
      >
        <span class="empty-title">${placeholderText}</span>
      </uuip-wc-empty-state>
    </div>
  `;
};
const renderListError = (listErrorMsg, retryButtonText, retryFunc, retryButtonSize = "32", retryButtonVariant = "secondary") => {
    return (0,lit_element__WEBPACK_IMPORTED_MODULE_0__.html) `
  <div class="load-error">
            <uuip-wc-empty-state
      illustration-name="cloud_failure_red"
      illustration-alt="cloud_failure_red"
      class="load-error-wrapper"
    >
      <div class="load-error-container">
        <p class="load-error-title">${listErrorMsg}</p>
        <md-button @click=${() => retryFunc()} id="reload-btn" size=${retryButtonSize} variant=${retryButtonVariant}>
        <span slot="text">${retryButtonText}</span>
        </div>
       </md-button>
        </uuip-wc-empty-state>
        </div>
        `;
};


/***/ }),

/***/ "@momentum-ui/web-components":
/*!**********************************************!*\
  !*** external "@momentum-ui/web-components" ***!
  \**********************************************/
/***/ ((module) => {

"use strict";
module.exports = require("@momentum-ui/web-components");

/***/ }),

/***/ "@uuip/unified-ui-platform-sdk":
/*!************************************************!*\
  !*** external "@uuip/unified-ui-platform-sdk" ***!
  \************************************************/
/***/ ((module) => {

"use strict";
module.exports = require("@uuip/unified-ui-platform-sdk");

/***/ }),

/***/ "libphonenumber-js":
/*!************************************!*\
  !*** external "libphonenumber-js" ***!
  \************************************/
/***/ ((module) => {

"use strict";
module.exports = require("libphonenumber-js");

/***/ }),

/***/ "lit-element":
/*!******************************!*\
  !*** external "lit-element" ***!
  \******************************/
/***/ ((module) => {

"use strict";
module.exports = require("lit-element");

/***/ }),

/***/ "lit-html":
/*!***************************!*\
  !*** external "lit-html" ***!
  \***************************/
/***/ ((module) => {

"use strict";
module.exports = require("lit-html");

/***/ }),

/***/ "lit-html/directives/class-map":
/*!************************************************!*\
  !*** external "lit-html/directives/class-map" ***!
  \************************************************/
/***/ ((module) => {

"use strict";
module.exports = require("lit-html/directives/class-map");

/***/ }),

/***/ "lit-html/directives/if-defined":
/*!*************************************************!*\
  !*** external "lit-html/directives/if-defined" ***!
  \*************************************************/
/***/ ((module) => {

"use strict";
module.exports = require("lit-html/directives/if-defined");

/***/ }),

/***/ "lit-html/directives/repeat":
/*!*********************************************!*\
  !*** external "lit-html/directives/repeat" ***!
  \*********************************************/
/***/ ((module) => {

"use strict";
module.exports = require("lit-html/directives/repeat");

/***/ }),

/***/ "lit-html/directives/style-map":
/*!************************************************!*\
  !*** external "lit-html/directives/style-map" ***!
  \************************************************/
/***/ ((module) => {

"use strict";
module.exports = require("lit-html/directives/style-map");

/***/ }),

/***/ "lit-html/directives/unsafe-html":
/*!**************************************************!*\
  !*** external "lit-html/directives/unsafe-html" ***!
  \**************************************************/
/***/ ((module) => {

"use strict";
module.exports = require("lit-html/directives/unsafe-html");

/***/ }),

/***/ "lit-html/lit-html":
/*!************************************!*\
  !*** external "lit-html/lit-html" ***!
  \************************************/
/***/ ((module) => {

"use strict";
module.exports = require("lit-html/lit-html");

/***/ }),

/***/ "lit-virtualizer":
/*!**********************************!*\
  !*** external "lit-virtualizer" ***!
  \**********************************/
/***/ ((module) => {

"use strict";
module.exports = require("lit-virtualizer");

/***/ }),

/***/ "luxon":
/*!************************!*\
  !*** external "luxon" ***!
  \************************/
/***/ ((module) => {

"use strict";
module.exports = require("luxon");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	(() => {
/******/ 		__webpack_require__.p = "/";
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
(() => {
"use strict";
/*!**********************!*\
  !*** ./src/index.ts ***!
  \**********************/
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   AdvancedSearch: () => (/* reexport safe */ _components_AdvancedSearch_components_AdvancedSearch__WEBPACK_IMPORTED_MODULE_0__.AdvancedSearch),
/* harmony export */   AgentList: () => (/* reexport safe */ _components_AgentList_AgentList__WEBPACK_IMPORTED_MODULE_1__.AgentList),
/* harmony export */   AgentListItem: () => (/* reexport safe */ _components_AgentList_components_AgentListItem__WEBPACK_IMPORTED_MODULE_2__.AgentListItem),
/* harmony export */   AgentPopoverAvatar: () => (/* reexport safe */ _components_AgentList_components_AgentPopoverAvatar__WEBPACK_IMPORTED_MODULE_3__.AgentPopoverAvatar),
/* harmony export */   ChatMessage: () => (/* reexport safe */ _components_ChatMessageList_components_ChatMessage__WEBPACK_IMPORTED_MODULE_6__.ChatMessage),
/* harmony export */   ChatMessageList: () => (/* reexport safe */ _components_ChatMessageList_ChatMessageList__WEBPACK_IMPORTED_MODULE_5__.ChatMessageList),
/* harmony export */   CollapseArea: () => (/* reexport safe */ _components_CollapseArea_CollapseArea__WEBPACK_IMPORTED_MODULE_7__.CollapseArea),
/* harmony export */   ContactCard: () => (/* reexport safe */ _components_AgentList_components_ContactCard__WEBPACK_IMPORTED_MODULE_4__.ContactCard),
/* harmony export */   ContentError: () => (/* reexport safe */ _components_ContentState_ContentError__WEBPACK_IMPORTED_MODULE_8__.ContentError),
/* harmony export */   ContentLoading: () => (/* reexport safe */ _components_ContentState_ContentLoading__WEBPACK_IMPORTED_MODULE_9__.ContentLoading),
/* harmony export */   EmergencyNotificationContent: () => (/* reexport safe */ _components_EmergencyNotification_EmergencyNotificationContent__WEBPACK_IMPORTED_MODULE_10__.EmergencyNotificationContent),
/* harmony export */   EmptyState: () => (/* reexport safe */ _components_EmptyState_EmptyState__WEBPACK_IMPORTED_MODULE_11__.EmptyState),
/* harmony export */   ErrorDetail: () => (/* reexport safe */ _components_ErrorDetail_ErrorDetail__WEBPACK_IMPORTED_MODULE_12__.ErrorDetail),
/* harmony export */   ErrorModal: () => (/* reexport safe */ _components_ErrorModal_ErrorModal__WEBPACK_IMPORTED_MODULE_13__.ErrorModal),
/* harmony export */   MaximizeAreaBlock: () => (/* reexport safe */ _components_MaximizeArea_MaximizeAreaBlock__WEBPACK_IMPORTED_MODULE_14__.MaximizeAreaBlock),
/* harmony export */   MaximizeAreaHost: () => (/* reexport safe */ _components_MaximizeArea_MaximizeAreaHost__WEBPACK_IMPORTED_MODULE_15__.MaximizeAreaHost),
/* harmony export */   ModalNotification: () => (/* reexport safe */ _components_Notifications__WEBPACK_IMPORTED_MODULE_17__.ModalNotification),
/* harmony export */   ModalNotificationsHost: () => (/* reexport safe */ _components_Notifications__WEBPACK_IMPORTED_MODULE_17__.ModalNotificationsHost),
/* harmony export */   Navigation: () => (/* reexport safe */ _components_Navigation_Navigation__WEBPACK_IMPORTED_MODULE_16__.Navigation),
/* harmony export */   NotificationsHost: () => (/* reexport safe */ _components_Notifications__WEBPACK_IMPORTED_MODULE_17__.NotificationsHost),
/* harmony export */   PersonalGreeting: () => (/* reexport safe */ _components_PersonalGreeting_PersonalGreeting__WEBPACK_IMPORTED_MODULE_18__.PersonalGreeting),
/* harmony export */   PersonalGreetingList: () => (/* reexport safe */ _components_PersonalGreeting_PersonalGreetingList__WEBPACK_IMPORTED_MODULE_19__.PersonalGreetingList),
/* harmony export */   ToasterNotification: () => (/* reexport safe */ _components_Notifications__WEBPACK_IMPORTED_MODULE_17__.ToasterNotification),
/* harmony export */   ToasterNotificationItemContent: () => (/* reexport safe */ _components_Notifications__WEBPACK_IMPORTED_MODULE_17__.ToasterNotificationItemContent),
/* harmony export */   ToasterNotificationsHost: () => (/* reexport safe */ _components_Notifications__WEBPACK_IMPORTED_MODULE_17__.ToasterNotificationsHost),
/* harmony export */   UserProfile: () => (/* reexport safe */ _components_UserProfile_UserProfile__WEBPACK_IMPORTED_MODULE_20__.UserProfile),
/* harmony export */   UserProfileTypes: () => (/* reexport safe */ _components_UserProfile_UserProfileTypes__WEBPACK_IMPORTED_MODULE_21__.UserProfileTypes),
/* harmony export */   UserStationLogin: () => (/* reexport safe */ _components_UserStationLogin_UserStationLogin__WEBPACK_IMPORTED_MODULE_22__.UserStationLogin),
/* harmony export */   WidgetWrapper: () => (/* reexport safe */ _components_WidgetWrapper_WidgetWrapper__WEBPACK_IMPORTED_MODULE_23__.WidgetWrapper)
/* harmony export */ });
/* harmony import */ var _components_AdvancedSearch_components_AdvancedSearch__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./components/AdvancedSearch/components/AdvancedSearch */ "./src/components/AdvancedSearch/components/AdvancedSearch.ts");
/* harmony import */ var _components_AgentList_AgentList__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./components/AgentList/AgentList */ "./src/components/AgentList/AgentList.ts");
/* harmony import */ var _components_AgentList_components_AgentListItem__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./components/AgentList/components/AgentListItem */ "./src/components/AgentList/components/AgentListItem.ts");
/* harmony import */ var _components_AgentList_components_AgentPopoverAvatar__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./components/AgentList/components/AgentPopoverAvatar */ "./src/components/AgentList/components/AgentPopoverAvatar.ts");
/* harmony import */ var _components_AgentList_components_ContactCard__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./components/AgentList/components/ContactCard */ "./src/components/AgentList/components/ContactCard.ts");
/* harmony import */ var _components_ChatMessageList_ChatMessageList__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./components/ChatMessageList/ChatMessageList */ "./src/components/ChatMessageList/ChatMessageList.ts");
/* harmony import */ var _components_ChatMessageList_components_ChatMessage__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./components/ChatMessageList/components/ChatMessage */ "./src/components/ChatMessageList/components/ChatMessage.ts");
/* harmony import */ var _components_CollapseArea_CollapseArea__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./components/CollapseArea/CollapseArea */ "./src/components/CollapseArea/CollapseArea.ts");
/* harmony import */ var _components_ContentState_ContentError__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./components/ContentState/ContentError */ "./src/components/ContentState/ContentError.ts");
/* harmony import */ var _components_ContentState_ContentLoading__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./components/ContentState/ContentLoading */ "./src/components/ContentState/ContentLoading.ts");
/* harmony import */ var _components_EmergencyNotification_EmergencyNotificationContent__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./components/EmergencyNotification/EmergencyNotificationContent */ "./src/components/EmergencyNotification/EmergencyNotificationContent.ts");
/* harmony import */ var _components_EmptyState_EmptyState__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./components/EmptyState/EmptyState */ "./src/components/EmptyState/EmptyState.ts");
/* harmony import */ var _components_ErrorDetail_ErrorDetail__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./components/ErrorDetail/ErrorDetail */ "./src/components/ErrorDetail/ErrorDetail.ts");
/* harmony import */ var _components_ErrorModal_ErrorModal__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./components/ErrorModal/ErrorModal */ "./src/components/ErrorModal/ErrorModal.ts");
/* harmony import */ var _components_MaximizeArea_MaximizeAreaBlock__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./components/MaximizeArea/MaximizeAreaBlock */ "./src/components/MaximizeArea/MaximizeAreaBlock.ts");
/* harmony import */ var _components_MaximizeArea_MaximizeAreaHost__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./components/MaximizeArea/MaximizeAreaHost */ "./src/components/MaximizeArea/MaximizeAreaHost.ts");
/* harmony import */ var _components_Navigation_Navigation__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./components/Navigation/Navigation */ "./src/components/Navigation/Navigation.ts");
/* harmony import */ var _components_Notifications__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./components/Notifications */ "./src/components/Notifications/index.ts");
/* harmony import */ var _components_PersonalGreeting_PersonalGreeting__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./components/PersonalGreeting/PersonalGreeting */ "./src/components/PersonalGreeting/PersonalGreeting.ts");
/* harmony import */ var _components_PersonalGreeting_PersonalGreetingList__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./components/PersonalGreeting/PersonalGreetingList */ "./src/components/PersonalGreeting/PersonalGreetingList.ts");
/* harmony import */ var _components_UserProfile_UserProfile__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./components/UserProfile/UserProfile */ "./src/components/UserProfile/UserProfile.ts");
/* harmony import */ var _components_UserProfile_UserProfileTypes__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ./components/UserProfile/UserProfileTypes */ "./src/components/UserProfile/UserProfileTypes.ts");
/* harmony import */ var _components_UserStationLogin_UserStationLogin__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./components/UserStationLogin/UserStationLogin */ "./src/components/UserStationLogin/UserStationLogin.ts");
/* harmony import */ var _components_WidgetWrapper_WidgetWrapper__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ./components/WidgetWrapper/WidgetWrapper */ "./src/components/WidgetWrapper/WidgetWrapper.ts");

























})();

/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=index.js.map